//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ClientBase {
  private readonly config: IAuthorizationConfig;

  protected constructor(config: IAuthorizationConfig) {
    this.config = config;
  }

  protected transformOptions = async (
    options: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> => {
    options.headers = {
      ...options.headers,
      Authorization: await this.config.getAuthorization(),
    };
    return Promise.resolve(options);
  };
}

export interface IKundserviceAppApiClient {
    /**
     * Hämtar basuppgifter för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Basuppgifter för en anställd.
     */
    getBasuppgifterForAnstalld(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfBasuppgifterData>;
    /**
     * Hämtar efterlevandeskydd för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Efterlevandeskydd för en anställd.
     */
    getEfterlevandeskyddForAnstalld(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfEfterlevandeskydd>;
    /**
     * Hämtar ITP1-information för en anställd.
     * @param individId Den anställdes IndividId.
     * @return ITP1-information för en anställd.
     */
    getItp1ForAnstalld(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfItp1>;
    /**
     * Hämtar ITP2-information för en anställd.
     * @param individId Den anställdes IndividId.
     * @return ITP2-information för en anställd.
     */
    getItp2ForAnstalld(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfItp2>;
    /**
     * Hämtar premier per anställning för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Premier för en anställd.
     */
    getPremier(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfList_1OfAnstallningPremier>;
    /**
     * Hämtar arbetsgivare för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Arbetsgivare för en anställd.
     */
    getAnstallningarForAnstalld(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfList_1OfArbetsgivare>;
    /**
     * Hämtar insikter för en anställd
     * @param individId IndividId för en person att hämta insikter för.
     * @return Arbetsgivare för en anställd.
     */
    getInsikterForAnstalld(individId: string,  cancelToken?: CancelToken): Promise<Insikt[]>;
    /**
     * @return OK
     */
    getIndividuellaValForAnstalld(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfIndividuellaVal>;
    /**
     * Hämtar nyckeltal för en arbetsgivare
     * @param arbetsgivareId Arbetsgivarens id
     * @return Nyckeltal för en arbetsgivare som matchar inskickat arbetsgivare id.
     */
    getNyckeltalForArbetsgivare(arbetsgivareId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfNyckeltalForArbetsgivareResponse>;
    /**
     * Hämta anställda för en arbetsgivare.
     * @param arbetsgivareId Id för arbetsgivare
     * @param kategori (optional) 
     * @param pensionsplan (optional) 
     * @param orderBy (optional) 
     * @param sortOrder (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @return Anställda till den arbetsgivare som matchar organisationsnumret.
     */
    getAnstalldaAtArbetsgivare(arbetsgivareId: string, kategori: AnstalldaFilterKategoriType | undefined, pensionsplan: PensionsplanType | undefined, orderBy: AnstalldOrderByColumnType | undefined, sortOrder: SortOrderType | undefined, top: number | undefined, skip: number | undefined,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfAnstalldaAtArbetsgivareResponse | null>;
    /**
     * Hämtar företag en individ är representant för.
     * @param individId IndividId för personen att hämta företag för.
     * @return OK
     */
    getMinaForetag(individId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfList_1OfMinaForetag>;
    /**
     * Hämtar försäkrings- och pensionsavtal för en arbetsgivare.
     * @param arbetsgivareId Id för arbetsgivare
     * @return OK
     */
    getAvtalForArbetsgivare(arbetsgivareId: string,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfAvtalResponse>;
    /**
     * Gets arenden for a customer by individ id
     * @param individId guid for the customer
     * @return OK
     */
    getArendenByIndivid(individId: string,  cancelToken?: CancelToken): Promise<SimpleAnstalldarende[]>;
    /**
     * Create a arende
     * @param puzzelId (optional) 
     * @param contact_phoneNumber (optional) 
     * @param contact_individId (optional) 
     * @param contact_email (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param internalNoteAttachments (optional) 
     * @param conversation (optional) 
     * @param conversationAttachments (optional) 
     * @param isClosed (optional) 
     * @param isVerified (optional) 
     * @param isManuallyVerified (optional) 
     * @param kundgrupp (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kanal (optional) 
     * @param ombud (optional) 
     * @return Created
     */
    createAnstalldarende(puzzelId: string | null | undefined, contact_phoneNumber: string | null | undefined, contact_individId: string | null | undefined, contact_email: string | null | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, internalNoteAttachments: FileParameter[] | null | undefined, conversation: string | null | undefined, conversationAttachments: FileParameter[] | null | undefined, isClosed: boolean | undefined, isVerified: boolean | undefined, isManuallyVerified: boolean | undefined, kundgrupp: KundgruppType | undefined, arendetyp: ArendeType | undefined, lamnaOverTill: LamnaOverType | undefined, kanal: KanalType | undefined, ombud: boolean | undefined,  cancelToken?: CancelToken): Promise<ValueResult_1OfAnstalldarende>;
    /**
     * Gets arenden by ids
     * @param ids List of arende ids
     * @return OK
     */
    getArendenByIds(ids: number[],  cancelToken?: CancelToken): Promise<Anstalldarende[]>;
    /**
     * Gets current users assigned arenden. 30 arenden per page.
     * @return OK
     */
    getAnstalldarendenByMedarbetare(open: boolean, page: number,  cancelToken?: CancelToken): Promise<ValueResult_1OfList_1OfAnstalldarende>;
    /**
     * Gets a arende by id
     * @param arendeId Id for the arende
     * @return OK
     */
    getArendeById(arendeId: number,  cancelToken?: CancelToken): Promise<Anstalldarende>;
    /**
     * Update existing arende in freshesk and/or create arende in Dynamics CRM as needed
     * @param arendeId Id for the arende
     * @param puzzelId (optional) 
     * @param contact_phoneNumber (optional) 
     * @param contact_individId (optional) 
     * @param contact_email (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param internalNoteAttachments (optional) 
     * @param conversation (optional) 
     * @param conversationAttachments (optional) 
     * @param isClosed (optional) 
     * @param isVerified (optional) 
     * @param isManuallyVerified (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kundgrupp (optional) 
     * @return OK
     */
    ensureArende(arendeId: number, puzzelId: string | null | undefined, contact_phoneNumber: string | null | undefined, contact_individId: string | null | undefined, contact_email: string | null | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, internalNoteAttachments: FileParameter[] | null | undefined, conversation: string | null | undefined, conversationAttachments: FileParameter[] | null | undefined, isClosed: boolean | null | undefined, isVerified: boolean | null | undefined, isManuallyVerified: boolean | null | undefined, arendetyp: ArendeType | null | undefined, lamnaOverTill: LamnaOverType | null | undefined, kundgrupp: KundgruppType | null | undefined,  cancelToken?: CancelToken): Promise<ValueResult_1OfAnstalldarende>;
    /**
     * Create an unlinked arende on a dummy contact
     * @param puzzelId (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param internalNoteAttachments (optional) 
     * @param isClosed (optional) 
     * @param kundgrupp (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kanal (optional) 
     * @param ombud (optional) 
     * @return Created
     */
    createUnlinkedArende(puzzelId: string | null | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, internalNoteAttachments: FileParameter[] | null | undefined, isClosed: boolean | undefined, kundgrupp: KundgruppType | undefined, arendetyp: ArendeType | undefined, lamnaOverTill: LamnaOverType | undefined, kanal: KanalType | undefined, ombud: boolean | undefined,  cancelToken?: CancelToken): Promise<ValueResult_1OfAnstalldarende>;
    /**
     * Create arende
     * @param puzzelId (optional) 
     * @param organizationNumber (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param isClosed (optional) 
     * @param isVerified (optional) 
     * @param kundgrupp (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kanal (optional) 
     * @param ombud (optional) 
     * @param namn (optional) 
     * @param email (optional) 
     * @param telefonnummer (optional) 
     * @return Created
     */
    createArbetsgivarearende(puzzelId: string | null | undefined, organizationNumber: string | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, isClosed: boolean | undefined, isVerified: boolean | undefined, kundgrupp: KundgruppType | undefined, arendetyp: ArendeType | undefined, lamnaOverTill: LamnaOverType | undefined, kanal: KanalType | undefined, ombud: boolean | undefined, namn: string | null | undefined, email: string | null | undefined, telefonnummer: string | null | undefined,  cancelToken?: CancelToken): Promise<ValueResult_1OfGuid>;
    /**
     * Gets arenden by organisationsnummer
     * @param body Organisationsnummer
     * @return OK
     */
    getArbetsgivarearendenByOrganisationsnummer(body: ArendenByOrganisationsnummerRequest,  cancelToken?: CancelToken): Promise<PaginatedResult_1OfList_1OfSimpleArbetsgivarearende>;
    /**
     * Gets arende by CRM arende number
     * @param arendeNumber Arendenumber
     * @return OK
     */
    getArbetsgivarearendeByArendeNumber(arendeNumber: string,  cancelToken?: CancelToken): Promise<Arbetsgivarearende>;
    /**
     * Update existing arende
     * @param arendeNumber Arende number
     * @param puzzelId (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internKommentar (optional) 
     * @param isClosed (optional) 
     * @param lamnaOverTill (optional) 
     * @param namn (optional) 
     * @param telefonnummer (optional) 
     * @param email (optional) 
     * @return OK
     */
    updateArbetsgivarearendeByArendeNumber(arendeNumber: string, puzzelId: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internKommentar: string | null | undefined, isClosed: boolean | null | undefined, lamnaOverTill: LamnaOverType | null | undefined, namn: string | null | undefined, telefonnummer: string | null | undefined, email: string | null | undefined,  cancelToken?: CancelToken): Promise<ValueResult_1OfArbetsgivarearende>;
    /**
     * Gets arenden owned by current user
     * @param body Arende filter parameters
     * @return OK
     */
    getArbetsgivarearendenByMedarbetare(body: ArendenByMedarbetareRequest,  cancelToken?: CancelToken): Promise<PaginatedResult_1OfList_1OfArbetsgivarearende>;
    /**
     * Update internal note
     * @param internKommentarId Id of internal note
     * @param body (optional) 
     * @return OK
     */
    updateInternKommentar(internKommentarId: string, body: string | undefined,  cancelToken?: CancelToken): Promise<ValueResult_1OfInternKommentar>;
    /**
     * Starta en bankid-inloggning för en individ utifrån ett personnummer.
     * @param body (optional) Svenskt personnummer samt parameter för inkomande eller utgående samtal
     * @return Accepted
     */
    authenticateIndivid(body: AuthenticateIndividRequest | undefined,  cancelToken?: CancelToken): Promise<AuthenticateResponse>;
    /**
     * Kontrollera status på om en användare autentiserat sig.
     * @param sessionId Sessionsid som erhållits efter initiering av authentisering.
     * @return OK
     */
    getSessionStatus(sessionId: string,  cancelToken?: CancelToken): Promise<SessionStatusResponse>;
    /**
     * Avsluta session hos bankid.
     * @param sessionId Sessionsid som erhållits efter initiering av authentisering.
     * @return OK
     */
    logoutSession(sessionId: string,  cancelToken?: CancelToken): Promise<SessionLoggedOutResponse>;
    /**
     * Gets app config
     * @return OK
     */
    getConfig( cancelToken?: CancelToken): Promise<Config>;
    /**
     * Söker företag utifrån möjliga sökparametrar.
     * @param organisationsnummer Organisationsnummer för det företag som eftersöks.
     * @return Ett företag som matchar organisationsnumret.
     */
    getForetag(organisationsnummer: string,  cancelToken?: CancelToken): Promise<ForetagResponse | null>;
    /**
     * Söker person utifrån möjliga sökparametrar.
     * @param id (optional) En individs unika avtalat-id kan vi använda detta för att hämta
     * @param personnummer (optional) Svenskt person-/samordningsnummer
     * @return En individ som matchar personnumret.
     */
    getIndivid(id: string | undefined, personnummer: string | undefined,  cancelToken?: CancelToken): Promise<PlatformResponse_1OfIndivid>;
    /**
     * Skapar en ny kundkontakt eller hämtar en befintlig om det finns.
     * @param body Värden att sättas på kundkontakten alt. användas för att hämta en befintlig.
     * @return Url till kontaktkortet.
     */
    createKundkontakt(body: KundkontaktRequest,  cancelToken?: CancelToken): Promise<KundkontaktResponse>;
    /**
     * Get current users profile
     * @return OK
     */
    getMe( cancelToken?: CancelToken): Promise<UserProfile>;
    /**
     * Get platform data for individ
     * @param individId guid for the customer
     * @return OK
     */
    getPlatformData(individId: string,  cancelToken?: CancelToken): Promise<PlatformData>;
    /**
     * Mock individ data
     * @param individId IndividId
     * @param body (optional) Mock data
     * @return No Content
     */
    mockData(individId: string, body: MockDataRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Clear individ Mock data
     * @param individId IndividId
     * @return No Content
     */
    clearData(individId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getReleaseNotesList( cancelToken?: CancelToken): Promise<ReleaseNotes[]>;
    /**
     * @return OK
     */
    getReleaseNotesContent(wikipagename: string,  cancelToken?: CancelToken): Promise<ReleaseNotesContent>;
    /**
     * Söker person eller företag utifrån möjliga sökparametrar.
     * @param q (optional) Söker individ och företag
    Personnummer, organisationsnummer, Freshdesk ärende-id (4-6 siffror) eller CRM ärendenummer (12-3456789)
     * @return OK
     */
    search(q: string | undefined,  cancelToken?: CancelToken): Promise<SearchResponse[]>;
    /**
     * Get available svarsmallar
     * @return OK
     */
    getSvarsmallar( cancelToken?: CancelToken): Promise<SvarsmallarResponse>;
}

export class KundserviceAppApiClient extends ClientBase implements IKundserviceAppApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthorizationConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Hämtar basuppgifter för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Basuppgifter för en anställd.
     */
    getBasuppgifterForAnstalld(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfBasuppgifterData> {
        let url_ = this.baseUrl + "/anstallda/{individId}/basuppgifter";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasuppgifterForAnstalld(_response);
        });
    }

    protected processGetBasuppgifterForAnstalld(response: AxiosResponse): Promise<PlatformResponse_1OfBasuppgifterData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfBasuppgifterData.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfBasuppgifterData>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfBasuppgifterData>(null as any);
    }

    /**
     * Hämtar efterlevandeskydd för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Efterlevandeskydd för en anställd.
     */
    getEfterlevandeskyddForAnstalld(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfEfterlevandeskydd> {
        let url_ = this.baseUrl + "/anstallda/{individId}/efterlevandeskydd";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEfterlevandeskyddForAnstalld(_response);
        });
    }

    protected processGetEfterlevandeskyddForAnstalld(response: AxiosResponse): Promise<PlatformResponse_1OfEfterlevandeskydd> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfEfterlevandeskydd.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfEfterlevandeskydd>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("Inget efterlevandeskydd funnet.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfEfterlevandeskydd>(null as any);
    }

    /**
     * Hämtar ITP1-information för en anställd.
     * @param individId Den anställdes IndividId.
     * @return ITP1-information för en anställd.
     */
    getItp1ForAnstalld(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfItp1> {
        let url_ = this.baseUrl + "/anstallda/{individId}/itp1";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItp1ForAnstalld(_response);
        });
    }

    protected processGetItp1ForAnstalld(response: AxiosResponse): Promise<PlatformResponse_1OfItp1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfItp1.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfItp1>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfItp1>(null as any);
    }

    /**
     * Hämtar ITP2-information för en anställd.
     * @param individId Den anställdes IndividId.
     * @return ITP2-information för en anställd.
     */
    getItp2ForAnstalld(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfItp2> {
        let url_ = this.baseUrl + "/anstallda/{individId}/itp2";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItp2ForAnstalld(_response);
        });
    }

    protected processGetItp2ForAnstalld(response: AxiosResponse): Promise<PlatformResponse_1OfItp2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfItp2.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfItp2>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("Ingen ITP2-information funnen.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfItp2>(null as any);
    }

    /**
     * Hämtar premier per anställning för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Premier för en anställd.
     */
    getPremier(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfList_1OfAnstallningPremier> {
        let url_ = this.baseUrl + "/anstallda/{individId}/premier";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPremier(_response);
        });
    }

    protected processGetPremier(response: AxiosResponse): Promise<PlatformResponse_1OfList_1OfAnstallningPremier> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfList_1OfAnstallningPremier.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfList_1OfAnstallningPremier>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfList_1OfAnstallningPremier>(null as any);
    }

    /**
     * Hämtar arbetsgivare för en anställd.
     * @param individId Den anställdes IndividId.
     * @return Arbetsgivare för en anställd.
     */
    getAnstallningarForAnstalld(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfList_1OfArbetsgivare> {
        let url_ = this.baseUrl + "/anstallda/{individId}/arbetsgivare";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnstallningarForAnstalld(_response);
        });
    }

    protected processGetAnstallningarForAnstalld(response: AxiosResponse): Promise<PlatformResponse_1OfList_1OfArbetsgivare> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfList_1OfArbetsgivare.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfList_1OfArbetsgivare>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("Inga arbetsgivare funna.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfList_1OfArbetsgivare>(null as any);
    }

    /**
     * Hämtar insikter för en anställd
     * @param individId IndividId för en person att hämta insikter för.
     * @return Arbetsgivare för en anställd.
     */
    getInsikterForAnstalld(individId: string, cancelToken?: CancelToken): Promise<Insikt[]> {
        let url_ = this.baseUrl + "/anstallda/{individId}/insikter";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInsikterForAnstalld(_response);
        });
    }

    protected processGetInsikterForAnstalld(response: AxiosResponse): Promise<Insikt[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Insikt.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Insikt[]>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("Inga arbetsgivare funna.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Insikt[]>(null as any);
    }

    /**
     * @return OK
     */
    getIndividuellaValForAnstalld(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfIndividuellaVal> {
        let url_ = this.baseUrl + "/anstallda/{individId}/individuellaval";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndividuellaValForAnstalld(_response);
        });
    }

    protected processGetIndividuellaValForAnstalld(response: AxiosResponse): Promise<PlatformResponse_1OfIndividuellaVal> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfIndividuellaVal.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfIndividuellaVal>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfIndividuellaVal>(null as any);
    }

    /**
     * Hämtar nyckeltal för en arbetsgivare
     * @param arbetsgivareId Arbetsgivarens id
     * @return Nyckeltal för en arbetsgivare som matchar inskickat arbetsgivare id.
     */
    getNyckeltalForArbetsgivare(arbetsgivareId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfNyckeltalForArbetsgivareResponse> {
        let url_ = this.baseUrl + "/arbetsgivare/{arbetsgivareId}/nyckeltal";
        if (arbetsgivareId === undefined || arbetsgivareId === null)
            throw new globalThis.Error("The parameter 'arbetsgivareId' must be defined.");
        url_ = url_.replace("{arbetsgivareId}", encodeURIComponent("" + arbetsgivareId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNyckeltalForArbetsgivare(_response);
        });
    }

    protected processGetNyckeltalForArbetsgivare(response: AxiosResponse): Promise<PlatformResponse_1OfNyckeltalForArbetsgivareResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfNyckeltalForArbetsgivareResponse.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfNyckeltalForArbetsgivareResponse>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("Inga nyckeltal funna.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfNyckeltalForArbetsgivareResponse>(null as any);
    }

    /**
     * Hämta anställda för en arbetsgivare.
     * @param arbetsgivareId Id för arbetsgivare
     * @param kategori (optional) 
     * @param pensionsplan (optional) 
     * @param orderBy (optional) 
     * @param sortOrder (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @return Anställda till den arbetsgivare som matchar organisationsnumret.
     */
    getAnstalldaAtArbetsgivare(arbetsgivareId: string, kategori: AnstalldaFilterKategoriType | undefined, pensionsplan: PensionsplanType | undefined, orderBy: AnstalldOrderByColumnType | undefined, sortOrder: SortOrderType | undefined, top: number | undefined, skip: number | undefined, cancelToken?: CancelToken): Promise<PlatformResponse_1OfAnstalldaAtArbetsgivareResponse | null> {
        let url_ = this.baseUrl + "/arbetsgivare/{arbetsgivareId}/anstallda?";
        if (arbetsgivareId === undefined || arbetsgivareId === null)
            throw new globalThis.Error("The parameter 'arbetsgivareId' must be defined.");
        url_ = url_.replace("{arbetsgivareId}", encodeURIComponent("" + arbetsgivareId));
        if (kategori === null)
            throw new globalThis.Error("The parameter 'kategori' cannot be null.");
        else if (kategori !== undefined)
            url_ += "kategori=" + encodeURIComponent("" + kategori) + "&";
        if (pensionsplan === null)
            throw new globalThis.Error("The parameter 'pensionsplan' cannot be null.");
        else if (pensionsplan !== undefined)
            url_ += "pensionsplan=" + encodeURIComponent("" + pensionsplan) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnstalldaAtArbetsgivare(_response);
        });
    }

    protected processGetAnstalldaAtArbetsgivare(response: AxiosResponse): Promise<PlatformResponse_1OfAnstalldaAtArbetsgivareResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PlatformResponse_1OfAnstalldaAtArbetsgivareResponse.fromJS(resultData200) : null as any;
            return Promise.resolve<PlatformResponse_1OfAnstalldaAtArbetsgivareResponse | null>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = resultData204 ? PlatformResponse_1OfAnstalldaAtArbetsgivareResponse.fromJS(resultData204) : null as any;
            return Promise.resolve<PlatformResponse_1OfAnstalldaAtArbetsgivareResponse | null>(result204);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfAnstalldaAtArbetsgivareResponse | null>(null as any);
    }

    /**
     * Hämtar företag en individ är representant för.
     * @param individId IndividId för personen att hämta företag för.
     * @return OK
     */
    getMinaForetag(individId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfList_1OfMinaForetag> {
        let url_ = this.baseUrl + "/arbetsgivare/{individId}/minaforetag";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMinaForetag(_response);
        });
    }

    protected processGetMinaForetag(response: AxiosResponse): Promise<PlatformResponse_1OfList_1OfMinaForetag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfList_1OfMinaForetag.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfList_1OfMinaForetag>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfList_1OfMinaForetag>(null as any);
    }

    /**
     * Hämtar försäkrings- och pensionsavtal för en arbetsgivare.
     * @param arbetsgivareId Id för arbetsgivare
     * @return OK
     */
    getAvtalForArbetsgivare(arbetsgivareId: string, cancelToken?: CancelToken): Promise<PlatformResponse_1OfAvtalResponse> {
        let url_ = this.baseUrl + "/arbetsgivare/{arbetsgivareId}/avtal";
        if (arbetsgivareId === undefined || arbetsgivareId === null)
            throw new globalThis.Error("The parameter 'arbetsgivareId' must be defined.");
        url_ = url_.replace("{arbetsgivareId}", encodeURIComponent("" + arbetsgivareId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvtalForArbetsgivare(_response);
        });
    }

    protected processGetAvtalForArbetsgivare(response: AxiosResponse): Promise<PlatformResponse_1OfAvtalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfAvtalResponse.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfAvtalResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfAvtalResponse>(null as any);
    }

    /**
     * Gets arenden for a customer by individ id
     * @param individId guid for the customer
     * @return OK
     */
    getArendenByIndivid(individId: string, cancelToken?: CancelToken): Promise<SimpleAnstalldarende[]> {
        let url_ = this.baseUrl + "/anstallda/arenden?";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined and cannot be null.");
        else
            url_ += "individId=" + encodeURIComponent("" + individId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArendenByIndivid(_response);
        });
    }

    protected processGetArendenByIndivid(response: AxiosResponse): Promise<SimpleAnstalldarende[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleAnstalldarende.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SimpleAnstalldarende[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleAnstalldarende[]>(null as any);
    }

    /**
     * Create a arende
     * @param puzzelId (optional) 
     * @param contact_phoneNumber (optional) 
     * @param contact_individId (optional) 
     * @param contact_email (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param internalNoteAttachments (optional) 
     * @param conversation (optional) 
     * @param conversationAttachments (optional) 
     * @param isClosed (optional) 
     * @param isVerified (optional) 
     * @param isManuallyVerified (optional) 
     * @param kundgrupp (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kanal (optional) 
     * @param ombud (optional) 
     * @return Created
     */
    createAnstalldarende(puzzelId: string | null | undefined, contact_phoneNumber: string | null | undefined, contact_individId: string | null | undefined, contact_email: string | null | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, internalNoteAttachments: FileParameter[] | null | undefined, conversation: string | null | undefined, conversationAttachments: FileParameter[] | null | undefined, isClosed: boolean | undefined, isVerified: boolean | undefined, isManuallyVerified: boolean | undefined, kundgrupp: KundgruppType | undefined, arendetyp: ArendeType | undefined, lamnaOverTill: LamnaOverType | undefined, kanal: KanalType | undefined, ombud: boolean | undefined, cancelToken?: CancelToken): Promise<ValueResult_1OfAnstalldarende> {
        let url_ = this.baseUrl + "/anstallda/arenden";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (puzzelId !== null && puzzelId !== undefined)
            content_.append("puzzelId", puzzelId.toString());
        if (contact_phoneNumber !== null && contact_phoneNumber !== undefined)
            content_.append("contact.phoneNumber", contact_phoneNumber.toString());
        if (contact_individId !== null && contact_individId !== undefined)
            content_.append("contact.individId", contact_individId.toString());
        if (contact_email !== null && contact_email !== undefined)
            content_.append("contact.email", contact_email.toString());
        if (kontaktorsak_id !== null && kontaktorsak_id !== undefined)
            content_.append("kontaktorsak.id", kontaktorsak_id.toString());
        if (kontaktorsak_name !== null && kontaktorsak_name !== undefined)
            content_.append("kontaktorsak.name", kontaktorsak_name.toString());
        if (fortydligadKontaktorsak !== null && fortydligadKontaktorsak !== undefined)
            content_.append("fortydligadKontaktorsak", fortydligadKontaktorsak.toString());
        if (samtalsamnenIds !== null && samtalsamnenIds !== undefined)
            samtalsamnenIds.forEach(item_ => content_.append("samtalsamnenIds", item_.toString()));
        if (internalNote !== null && internalNote !== undefined)
            content_.append("internalNote", internalNote.toString());
        if (internalNoteAttachments !== null && internalNoteAttachments !== undefined)
            internalNoteAttachments.forEach(item_ => content_.append("internalNoteAttachments", item_.data, item_.fileName ? item_.fileName : "internalNoteAttachments") );
        if (conversation !== null && conversation !== undefined)
            content_.append("conversation", conversation.toString());
        if (conversationAttachments !== null && conversationAttachments !== undefined)
            conversationAttachments.forEach(item_ => content_.append("conversationAttachments", item_.data, item_.fileName ? item_.fileName : "conversationAttachments") );
        if (isClosed === null || isClosed === undefined)
            throw new globalThis.Error("The parameter 'isClosed' cannot be null.");
        else
            content_.append("isClosed", isClosed.toString());
        if (isVerified === null || isVerified === undefined)
            throw new globalThis.Error("The parameter 'isVerified' cannot be null.");
        else
            content_.append("isVerified", isVerified.toString());
        if (isManuallyVerified === null || isManuallyVerified === undefined)
            throw new globalThis.Error("The parameter 'isManuallyVerified' cannot be null.");
        else
            content_.append("isManuallyVerified", isManuallyVerified.toString());
        if (kundgrupp === null || kundgrupp === undefined)
            throw new globalThis.Error("The parameter 'kundgrupp' cannot be null.");
        else
            content_.append("kundgrupp", kundgrupp.toString());
        if (arendetyp === null || arendetyp === undefined)
            throw new globalThis.Error("The parameter 'arendetyp' cannot be null.");
        else
            content_.append("arendetyp", arendetyp.toString());
        if (lamnaOverTill === null || lamnaOverTill === undefined)
            throw new globalThis.Error("The parameter 'lamnaOverTill' cannot be null.");
        else
            content_.append("lamnaOverTill", lamnaOverTill.toString());
        if (kanal === null || kanal === undefined)
            throw new globalThis.Error("The parameter 'kanal' cannot be null.");
        else
            content_.append("kanal", kanal.toString());
        if (ombud === null || ombud === undefined)
            throw new globalThis.Error("The parameter 'ombud' cannot be null.");
        else
            content_.append("ombud", ombud.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAnstalldarende(_response);
        });
    }

    protected processCreateAnstalldarende(response: AxiosResponse): Promise<ValueResult_1OfAnstalldarende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ValueResult_1OfAnstalldarende.fromJS(resultData201);
            return Promise.resolve<ValueResult_1OfAnstalldarende>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValueResult_1OfAnstalldarende.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ValueResult_1OfAnstalldarende.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ValueResult_1OfAnstalldarende.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValueResult_1OfAnstalldarende.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueResult_1OfAnstalldarende>(null as any);
    }

    /**
     * Gets arenden by ids
     * @param ids List of arende ids
     * @return OK
     */
    getArendenByIds(ids: number[], cancelToken?: CancelToken): Promise<Anstalldarende[]> {
        let url_ = this.baseUrl + "/anstallda/arenden/ids?";
        if (ids === undefined || ids === null)
            throw new globalThis.Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArendenByIds(_response);
        });
    }

    protected processGetArendenByIds(response: AxiosResponse): Promise<Anstalldarende[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Anstalldarende.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Anstalldarende[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = ValidationProblemDetails.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Anstalldarende[]>(null as any);
    }

    /**
     * Gets current users assigned arenden. 30 arenden per page.
     * @return OK
     */
    getAnstalldarendenByMedarbetare(open: boolean, page: number, cancelToken?: CancelToken): Promise<ValueResult_1OfList_1OfAnstalldarende> {
        let url_ = this.baseUrl + "/anstallda/arenden/medarbetare?";
        if (open === undefined || open === null)
            throw new globalThis.Error("The parameter 'open' must be defined and cannot be null.");
        else
            url_ += "open=" + encodeURIComponent("" + open) + "&";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnstalldarendenByMedarbetare(_response);
        });
    }

    protected processGetAnstalldarendenByMedarbetare(response: AxiosResponse): Promise<ValueResult_1OfList_1OfAnstalldarende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueResult_1OfList_1OfAnstalldarende.fromJS(resultData200);
            return Promise.resolve<ValueResult_1OfList_1OfAnstalldarende>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValueResult_1OfList_1OfAnstalldarende.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueResult_1OfList_1OfAnstalldarende>(null as any);
    }

    /**
     * Gets a arende by id
     * @param arendeId Id for the arende
     * @return OK
     */
    getArendeById(arendeId: number, cancelToken?: CancelToken): Promise<Anstalldarende> {
        let url_ = this.baseUrl + "/anstallda/arenden/{arendeId}";
        if (arendeId === undefined || arendeId === null)
            throw new globalThis.Error("The parameter 'arendeId' must be defined.");
        url_ = url_.replace("{arendeId}", encodeURIComponent("" + arendeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArendeById(_response);
        });
    }

    protected processGetArendeById(response: AxiosResponse): Promise<Anstalldarende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Anstalldarende.fromJS(resultData200);
            return Promise.resolve<Anstalldarende>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Anstalldarende>(null as any);
    }

    /**
     * Update existing arende in freshesk and/or create arende in Dynamics CRM as needed
     * @param arendeId Id for the arende
     * @param puzzelId (optional) 
     * @param contact_phoneNumber (optional) 
     * @param contact_individId (optional) 
     * @param contact_email (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param internalNoteAttachments (optional) 
     * @param conversation (optional) 
     * @param conversationAttachments (optional) 
     * @param isClosed (optional) 
     * @param isVerified (optional) 
     * @param isManuallyVerified (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kundgrupp (optional) 
     * @return OK
     */
    ensureArende(arendeId: number, puzzelId: string | null | undefined, contact_phoneNumber: string | null | undefined, contact_individId: string | null | undefined, contact_email: string | null | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, internalNoteAttachments: FileParameter[] | null | undefined, conversation: string | null | undefined, conversationAttachments: FileParameter[] | null | undefined, isClosed: boolean | null | undefined, isVerified: boolean | null | undefined, isManuallyVerified: boolean | null | undefined, arendetyp: ArendeType | null | undefined, lamnaOverTill: LamnaOverType | null | undefined, kundgrupp: KundgruppType | null | undefined, cancelToken?: CancelToken): Promise<ValueResult_1OfAnstalldarende> {
        let url_ = this.baseUrl + "/anstallda/arenden/{arendeId}";
        if (arendeId === undefined || arendeId === null)
            throw new globalThis.Error("The parameter 'arendeId' must be defined.");
        url_ = url_.replace("{arendeId}", encodeURIComponent("" + arendeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (puzzelId !== null && puzzelId !== undefined)
            content_.append("puzzelId", puzzelId.toString());
        if (contact_phoneNumber !== null && contact_phoneNumber !== undefined)
            content_.append("contact.phoneNumber", contact_phoneNumber.toString());
        if (contact_individId !== null && contact_individId !== undefined)
            content_.append("contact.individId", contact_individId.toString());
        if (contact_email !== null && contact_email !== undefined)
            content_.append("contact.email", contact_email.toString());
        if (kontaktorsak_id !== null && kontaktorsak_id !== undefined)
            content_.append("kontaktorsak.id", kontaktorsak_id.toString());
        if (kontaktorsak_name !== null && kontaktorsak_name !== undefined)
            content_.append("kontaktorsak.name", kontaktorsak_name.toString());
        if (fortydligadKontaktorsak !== null && fortydligadKontaktorsak !== undefined)
            content_.append("fortydligadKontaktorsak", fortydligadKontaktorsak.toString());
        if (samtalsamnenIds !== null && samtalsamnenIds !== undefined)
            samtalsamnenIds.forEach(item_ => content_.append("samtalsamnenIds", item_.toString()));
        if (internalNote !== null && internalNote !== undefined)
            content_.append("internalNote", internalNote.toString());
        if (internalNoteAttachments !== null && internalNoteAttachments !== undefined)
            internalNoteAttachments.forEach(item_ => content_.append("internalNoteAttachments", item_.data, item_.fileName ? item_.fileName : "internalNoteAttachments") );
        if (conversation !== null && conversation !== undefined)
            content_.append("conversation", conversation.toString());
        if (conversationAttachments !== null && conversationAttachments !== undefined)
            conversationAttachments.forEach(item_ => content_.append("conversationAttachments", item_.data, item_.fileName ? item_.fileName : "conversationAttachments") );
        if (isClosed !== null && isClosed !== undefined)
            content_.append("isClosed", isClosed.toString());
        if (isVerified !== null && isVerified !== undefined)
            content_.append("isVerified", isVerified.toString());
        if (isManuallyVerified !== null && isManuallyVerified !== undefined)
            content_.append("isManuallyVerified", isManuallyVerified.toString());
        if (arendetyp !== null && arendetyp !== undefined)
            content_.append("arendetyp", arendetyp.toString());
        if (lamnaOverTill !== null && lamnaOverTill !== undefined)
            content_.append("lamnaOverTill", lamnaOverTill.toString());
        if (kundgrupp !== null && kundgrupp !== undefined)
            content_.append("kundgrupp", kundgrupp.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnsureArende(_response);
        });
    }

    protected processEnsureArende(response: AxiosResponse): Promise<ValueResult_1OfAnstalldarende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueResult_1OfAnstalldarende.fromJS(resultData200);
            return Promise.resolve<ValueResult_1OfAnstalldarende>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValueResult_1OfAnstalldarende.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ValueResult_1OfAnstalldarende.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ValueResult_1OfAnstalldarende.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValueResult_1OfAnstalldarende.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueResult_1OfAnstalldarende>(null as any);
    }

    /**
     * Create an unlinked arende on a dummy contact
     * @param puzzelId (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param internalNoteAttachments (optional) 
     * @param isClosed (optional) 
     * @param kundgrupp (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kanal (optional) 
     * @param ombud (optional) 
     * @return Created
     */
    createUnlinkedArende(puzzelId: string | null | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, internalNoteAttachments: FileParameter[] | null | undefined, isClosed: boolean | undefined, kundgrupp: KundgruppType | undefined, arendetyp: ArendeType | undefined, lamnaOverTill: LamnaOverType | undefined, kanal: KanalType | undefined, ombud: boolean | undefined, cancelToken?: CancelToken): Promise<ValueResult_1OfAnstalldarende> {
        let url_ = this.baseUrl + "/anstallda/arenden/unlinked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (puzzelId !== null && puzzelId !== undefined)
            content_.append("puzzelId", puzzelId.toString());
        if (kontaktorsak_id !== null && kontaktorsak_id !== undefined)
            content_.append("kontaktorsak.id", kontaktorsak_id.toString());
        if (kontaktorsak_name !== null && kontaktorsak_name !== undefined)
            content_.append("kontaktorsak.name", kontaktorsak_name.toString());
        if (fortydligadKontaktorsak !== null && fortydligadKontaktorsak !== undefined)
            content_.append("fortydligadKontaktorsak", fortydligadKontaktorsak.toString());
        if (samtalsamnenIds !== null && samtalsamnenIds !== undefined)
            samtalsamnenIds.forEach(item_ => content_.append("samtalsamnenIds", item_.toString()));
        if (internalNote !== null && internalNote !== undefined)
            content_.append("internalNote", internalNote.toString());
        if (internalNoteAttachments !== null && internalNoteAttachments !== undefined)
            internalNoteAttachments.forEach(item_ => content_.append("internalNoteAttachments", item_.data, item_.fileName ? item_.fileName : "internalNoteAttachments") );
        if (isClosed === null || isClosed === undefined)
            throw new globalThis.Error("The parameter 'isClosed' cannot be null.");
        else
            content_.append("isClosed", isClosed.toString());
        if (kundgrupp === null || kundgrupp === undefined)
            throw new globalThis.Error("The parameter 'kundgrupp' cannot be null.");
        else
            content_.append("kundgrupp", kundgrupp.toString());
        if (arendetyp === null || arendetyp === undefined)
            throw new globalThis.Error("The parameter 'arendetyp' cannot be null.");
        else
            content_.append("arendetyp", arendetyp.toString());
        if (lamnaOverTill === null || lamnaOverTill === undefined)
            throw new globalThis.Error("The parameter 'lamnaOverTill' cannot be null.");
        else
            content_.append("lamnaOverTill", lamnaOverTill.toString());
        if (kanal === null || kanal === undefined)
            throw new globalThis.Error("The parameter 'kanal' cannot be null.");
        else
            content_.append("kanal", kanal.toString());
        if (ombud === null || ombud === undefined)
            throw new globalThis.Error("The parameter 'ombud' cannot be null.");
        else
            content_.append("ombud", ombud.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUnlinkedArende(_response);
        });
    }

    protected processCreateUnlinkedArende(response: AxiosResponse): Promise<ValueResult_1OfAnstalldarende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ValueResult_1OfAnstalldarende.fromJS(resultData201);
            return Promise.resolve<ValueResult_1OfAnstalldarende>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValueResult_1OfAnstalldarende.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ValueResult_1OfAnstalldarende.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValueResult_1OfAnstalldarende.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueResult_1OfAnstalldarende>(null as any);
    }

    /**
     * Create arende
     * @param puzzelId (optional) 
     * @param organizationNumber (optional) 
     * @param kontaktorsak_id (optional) 
     * @param kontaktorsak_name (optional) 
     * @param fortydligadKontaktorsak (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internalNote (optional) 
     * @param isClosed (optional) 
     * @param isVerified (optional) 
     * @param kundgrupp (optional) 
     * @param arendetyp (optional) 
     * @param lamnaOverTill (optional) 
     * @param kanal (optional) 
     * @param ombud (optional) 
     * @param namn (optional) 
     * @param email (optional) 
     * @param telefonnummer (optional) 
     * @return Created
     */
    createArbetsgivarearende(puzzelId: string | null | undefined, organizationNumber: string | undefined, kontaktorsak_id: string | null | undefined, kontaktorsak_name: string | null | undefined, fortydligadKontaktorsak: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internalNote: string | null | undefined, isClosed: boolean | undefined, isVerified: boolean | undefined, kundgrupp: KundgruppType | undefined, arendetyp: ArendeType | undefined, lamnaOverTill: LamnaOverType | undefined, kanal: KanalType | undefined, ombud: boolean | undefined, namn: string | null | undefined, email: string | null | undefined, telefonnummer: string | null | undefined, cancelToken?: CancelToken): Promise<ValueResult_1OfGuid> {
        let url_ = this.baseUrl + "/arbetsgivare/arenden";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (puzzelId !== null && puzzelId !== undefined)
            content_.append("puzzelId", puzzelId.toString());
        if (organizationNumber === null || organizationNumber === undefined)
            throw new globalThis.Error("The parameter 'organizationNumber' cannot be null.");
        else
            content_.append("organizationNumber", organizationNumber.toString());
        if (kontaktorsak_id !== null && kontaktorsak_id !== undefined)
            content_.append("kontaktorsak.id", kontaktorsak_id.toString());
        if (kontaktorsak_name !== null && kontaktorsak_name !== undefined)
            content_.append("kontaktorsak.name", kontaktorsak_name.toString());
        if (fortydligadKontaktorsak !== null && fortydligadKontaktorsak !== undefined)
            content_.append("fortydligadKontaktorsak", fortydligadKontaktorsak.toString());
        if (samtalsamnenIds !== null && samtalsamnenIds !== undefined)
            samtalsamnenIds.forEach(item_ => content_.append("samtalsamnenIds", item_.toString()));
        if (internalNote !== null && internalNote !== undefined)
            content_.append("internalNote", internalNote.toString());
        if (isClosed === null || isClosed === undefined)
            throw new globalThis.Error("The parameter 'isClosed' cannot be null.");
        else
            content_.append("isClosed", isClosed.toString());
        if (isVerified === null || isVerified === undefined)
            throw new globalThis.Error("The parameter 'isVerified' cannot be null.");
        else
            content_.append("isVerified", isVerified.toString());
        if (kundgrupp === null || kundgrupp === undefined)
            throw new globalThis.Error("The parameter 'kundgrupp' cannot be null.");
        else
            content_.append("kundgrupp", kundgrupp.toString());
        if (arendetyp === null || arendetyp === undefined)
            throw new globalThis.Error("The parameter 'arendetyp' cannot be null.");
        else
            content_.append("arendetyp", arendetyp.toString());
        if (lamnaOverTill === null || lamnaOverTill === undefined)
            throw new globalThis.Error("The parameter 'lamnaOverTill' cannot be null.");
        else
            content_.append("lamnaOverTill", lamnaOverTill.toString());
        if (kanal === null || kanal === undefined)
            throw new globalThis.Error("The parameter 'kanal' cannot be null.");
        else
            content_.append("kanal", kanal.toString());
        if (ombud === null || ombud === undefined)
            throw new globalThis.Error("The parameter 'ombud' cannot be null.");
        else
            content_.append("ombud", ombud.toString());
        if (namn !== null && namn !== undefined)
            content_.append("namn", namn.toString());
        if (email !== null && email !== undefined)
            content_.append("email", email.toString());
        if (telefonnummer !== null && telefonnummer !== undefined)
            content_.append("telefonnummer", telefonnummer.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateArbetsgivarearende(_response);
        });
    }

    protected processCreateArbetsgivarearende(response: AxiosResponse): Promise<ValueResult_1OfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ValueResult_1OfGuid.fromJS(resultData201);
            return Promise.resolve<ValueResult_1OfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValueResult_1OfNullable_1OfGuid.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ValueResult_1OfNullable_1OfGuid.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ValueResult_1OfNullable_1OfGuid.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValueResult_1OfNullable_1OfGuid.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueResult_1OfGuid>(null as any);
    }

    /**
     * Gets arenden by organisationsnummer
     * @param body Organisationsnummer
     * @return OK
     */
    getArbetsgivarearendenByOrganisationsnummer(body: ArendenByOrganisationsnummerRequest, cancelToken?: CancelToken): Promise<PaginatedResult_1OfList_1OfSimpleArbetsgivarearende> {
        let url_ = this.baseUrl + "/arbetsgivare/arenden/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArbetsgivarearendenByOrganisationsnummer(_response);
        });
    }

    protected processGetArbetsgivarearendenByOrganisationsnummer(response: AxiosResponse): Promise<PaginatedResult_1OfList_1OfSimpleArbetsgivarearende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResult_1OfList_1OfSimpleArbetsgivarearende.fromJS(resultData200);
            return Promise.resolve<PaginatedResult_1OfList_1OfSimpleArbetsgivarearende>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = ValidationProblemDetails.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResult_1OfList_1OfSimpleArbetsgivarearende>(null as any);
    }

    /**
     * Gets arende by CRM arende number
     * @param arendeNumber Arendenumber
     * @return OK
     */
    getArbetsgivarearendeByArendeNumber(arendeNumber: string, cancelToken?: CancelToken): Promise<Arbetsgivarearende> {
        let url_ = this.baseUrl + "/arbetsgivare/arenden/{arendeNumber}";
        if (arendeNumber === undefined || arendeNumber === null)
            throw new globalThis.Error("The parameter 'arendeNumber' must be defined.");
        url_ = url_.replace("{arendeNumber}", encodeURIComponent("" + arendeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArbetsgivarearendeByArendeNumber(_response);
        });
    }

    protected processGetArbetsgivarearendeByArendeNumber(response: AxiosResponse): Promise<Arbetsgivarearende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Arbetsgivarearende.fromJS(resultData200);
            return Promise.resolve<Arbetsgivarearende>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = Arbetsgivarearende.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Arbetsgivarearende>(null as any);
    }

    /**
     * Update existing arende
     * @param arendeNumber Arende number
     * @param puzzelId (optional) 
     * @param samtalsamnenIds (optional) 
     * @param internKommentar (optional) 
     * @param isClosed (optional) 
     * @param lamnaOverTill (optional) 
     * @param namn (optional) 
     * @param telefonnummer (optional) 
     * @param email (optional) 
     * @return OK
     */
    updateArbetsgivarearendeByArendeNumber(arendeNumber: string, puzzelId: string | null | undefined, samtalsamnenIds: string[] | null | undefined, internKommentar: string | null | undefined, isClosed: boolean | null | undefined, lamnaOverTill: LamnaOverType | null | undefined, namn: string | null | undefined, telefonnummer: string | null | undefined, email: string | null | undefined, cancelToken?: CancelToken): Promise<ValueResult_1OfArbetsgivarearende> {
        let url_ = this.baseUrl + "/arbetsgivare/arenden/{arendeNumber}";
        if (arendeNumber === undefined || arendeNumber === null)
            throw new globalThis.Error("The parameter 'arendeNumber' must be defined.");
        url_ = url_.replace("{arendeNumber}", encodeURIComponent("" + arendeNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (puzzelId !== null && puzzelId !== undefined)
            content_.append("puzzelId", puzzelId.toString());
        if (samtalsamnenIds !== null && samtalsamnenIds !== undefined)
            samtalsamnenIds.forEach(item_ => content_.append("samtalsamnenIds", item_.toString()));
        if (internKommentar !== null && internKommentar !== undefined)
            content_.append("internKommentar", internKommentar.toString());
        if (isClosed !== null && isClosed !== undefined)
            content_.append("isClosed", isClosed.toString());
        if (lamnaOverTill !== null && lamnaOverTill !== undefined)
            content_.append("lamnaOverTill", lamnaOverTill.toString());
        if (namn !== null && namn !== undefined)
            content_.append("namn", namn.toString());
        if (telefonnummer !== null && telefonnummer !== undefined)
            content_.append("telefonnummer", telefonnummer.toString());
        if (email !== null && email !== undefined)
            content_.append("email", email.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateArbetsgivarearendeByArendeNumber(_response);
        });
    }

    protected processUpdateArbetsgivarearendeByArendeNumber(response: AxiosResponse): Promise<ValueResult_1OfArbetsgivarearende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueResult_1OfArbetsgivarearende.fromJS(resultData200);
            return Promise.resolve<ValueResult_1OfArbetsgivarearende>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValueResult_1OfArbetsgivarearende.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ValueResult_1OfArbetsgivarearende.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ValueResult_1OfArbetsgivarearende.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValueResult_1OfArbetsgivarearende.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueResult_1OfArbetsgivarearende>(null as any);
    }

    /**
     * Gets arenden owned by current user
     * @param body Arende filter parameters
     * @return OK
     */
    getArbetsgivarearendenByMedarbetare(body: ArendenByMedarbetareRequest, cancelToken?: CancelToken): Promise<PaginatedResult_1OfList_1OfArbetsgivarearende> {
        let url_ = this.baseUrl + "/arbetsgivare/arenden/medarbetare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArbetsgivarearendenByMedarbetare(_response);
        });
    }

    protected processGetArbetsgivarearendenByMedarbetare(response: AxiosResponse): Promise<PaginatedResult_1OfList_1OfArbetsgivarearende> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResult_1OfList_1OfArbetsgivarearende.fromJS(resultData200);
            return Promise.resolve<PaginatedResult_1OfList_1OfArbetsgivarearende>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResult_1OfList_1OfArbetsgivarearende>(null as any);
    }

    /**
     * Update internal note
     * @param internKommentarId Id of internal note
     * @param body (optional) 
     * @return OK
     */
    updateInternKommentar(internKommentarId: string, body: string | undefined, cancelToken?: CancelToken): Promise<ValueResult_1OfInternKommentar> {
        let url_ = this.baseUrl + "/arbetsgivare/arenden/kommentar/{internKommentarId}";
        if (internKommentarId === undefined || internKommentarId === null)
            throw new globalThis.Error("The parameter 'internKommentarId' must be defined.");
        url_ = url_.replace("{internKommentarId}", encodeURIComponent("" + internKommentarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (body === null || body === undefined)
            throw new globalThis.Error("The parameter 'body' cannot be null.");
        else
            content_.append("body", body.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInternKommentar(_response);
        });
    }

    protected processUpdateInternKommentar(response: AxiosResponse): Promise<ValueResult_1OfInternKommentar> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueResult_1OfInternKommentar.fromJS(resultData200);
            return Promise.resolve<ValueResult_1OfInternKommentar>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValueResult_1OfInternKommentar.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ValueResult_1OfInternKommentar.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ValueResult_1OfInternKommentar.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValueResult_1OfInternKommentar.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueResult_1OfInternKommentar>(null as any);
    }

    /**
     * Starta en bankid-inloggning för en individ utifrån ett personnummer.
     * @param body (optional) Svenskt personnummer samt parameter för inkomande eller utgående samtal
     * @return Accepted
     */
    authenticateIndivid(body: AuthenticateIndividRequest | undefined, cancelToken?: CancelToken): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/authentications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateIndivid(_response);
        });
    }

    protected processAuthenticateIndivid(response: AxiosResponse): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = AuthenticateResponse.fromJS(resultData202);
            return Promise.resolve<AuthenticateResponse>(result202);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }

    /**
     * Kontrollera status på om en användare autentiserat sig.
     * @param sessionId Sessionsid som erhållits efter initiering av authentisering.
     * @return OK
     */
    getSessionStatus(sessionId: string, cancelToken?: CancelToken): Promise<SessionStatusResponse> {
        let url_ = this.baseUrl + "/authentications/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionStatus(_response);
        });
    }

    protected processGetSessionStatus(response: AxiosResponse): Promise<SessionStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionStatusResponse.fromJS(resultData200);
            return Promise.resolve<SessionStatusResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionStatusResponse>(null as any);
    }

    /**
     * Avsluta session hos bankid.
     * @param sessionId Sessionsid som erhållits efter initiering av authentisering.
     * @return OK
     */
    logoutSession(sessionId: string, cancelToken?: CancelToken): Promise<SessionLoggedOutResponse> {
        let url_ = this.baseUrl + "/authentications/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogoutSession(_response);
        });
    }

    protected processLogoutSession(response: AxiosResponse): Promise<SessionLoggedOutResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionLoggedOutResponse.fromJS(resultData200);
            return Promise.resolve<SessionLoggedOutResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionLoggedOutResponse>(null as any);
    }

    /**
     * Gets app config
     * @return OK
     */
    getConfig( cancelToken?: CancelToken): Promise<Config> {
        let url_ = this.baseUrl + "/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: AxiosResponse): Promise<Config> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Config.fromJS(resultData200);
            return Promise.resolve<Config>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Config>(null as any);
    }

    /**
     * Söker företag utifrån möjliga sökparametrar.
     * @param organisationsnummer Organisationsnummer för det företag som eftersöks.
     * @return Ett företag som matchar organisationsnumret.
     */
    getForetag(organisationsnummer: string, cancelToken?: CancelToken): Promise<ForetagResponse | null> {
        let url_ = this.baseUrl + "/foretag/{organisationsnummer}";
        if (organisationsnummer === undefined || organisationsnummer === null)
            throw new globalThis.Error("The parameter 'organisationsnummer' must be defined.");
        url_ = url_.replace("{organisationsnummer}", encodeURIComponent("" + organisationsnummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForetag(_response);
        });
    }

    protected processGetForetag(response: AxiosResponse): Promise<ForetagResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ForetagResponse.fromJS(resultData200) : null as any;
            return Promise.resolve<ForetagResponse | null>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = resultData204 ? ForetagResponse.fromJS(resultData204) : null as any;
            return Promise.resolve<ForetagResponse | null>(result204);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForetagResponse | null>(null as any);
    }

    /**
     * Söker person utifrån möjliga sökparametrar.
     * @param id (optional) En individs unika avtalat-id kan vi använda detta för att hämta
     * @param personnummer (optional) Svenskt person-/samordningsnummer
     * @return En individ som matchar personnumret.
     */
    getIndivid(id: string | undefined, personnummer: string | undefined, cancelToken?: CancelToken): Promise<PlatformResponse_1OfIndivid> {
        let url_ = this.baseUrl + "/individer?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (personnummer === null)
            throw new globalThis.Error("The parameter 'personnummer' cannot be null.");
        else if (personnummer !== undefined)
            url_ += "personnummer=" + encodeURIComponent("" + personnummer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndivid(_response);
        });
    }

    protected processGetIndivid(response: AxiosResponse): Promise<PlatformResponse_1OfIndivid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformResponse_1OfIndivid.fromJS(resultData200);
            return Promise.resolve<PlatformResponse_1OfIndivid>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("Ingen individ funnen.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformResponse_1OfIndivid>(null as any);
    }

    /**
     * Skapar en ny kundkontakt eller hämtar en befintlig om det finns.
     * @param body Värden att sättas på kundkontakten alt. användas för att hämta en befintlig.
     * @return Url till kontaktkortet.
     */
    createKundkontakt(body: KundkontaktRequest, cancelToken?: CancelToken): Promise<KundkontaktResponse> {
        let url_ = this.baseUrl + "/kundkontakter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateKundkontakt(_response);
        });
    }

    protected processCreateKundkontakt(response: AxiosResponse): Promise<KundkontaktResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KundkontaktResponse.fromJS(resultData200);
            return Promise.resolve<KundkontaktResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("If things have gone really bad.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KundkontaktResponse>(null as any);
    }

    /**
     * Get current users profile
     * @return OK
     */
    getMe( cancelToken?: CancelToken): Promise<UserProfile> {
        let url_ = this.baseUrl + "/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMe(_response);
        });
    }

    protected processGetMe(response: AxiosResponse): Promise<UserProfile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfile.fromJS(resultData200);
            return Promise.resolve<UserProfile>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfile>(null as any);
    }

    /**
     * Get platform data for individ
     * @param individId guid for the customer
     * @return OK
     */
    getPlatformData(individId: string, cancelToken?: CancelToken): Promise<PlatformData> {
        let url_ = this.baseUrl + "/mock/{individId}";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlatformData(_response);
        });
    }

    protected processGetPlatformData(response: AxiosResponse): Promise<PlatformData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformData.fromJS(resultData200);
            return Promise.resolve<PlatformData>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformData>(null as any);
    }

    /**
     * Mock individ data
     * @param individId IndividId
     * @param body (optional) Mock data
     * @return No Content
     */
    mockData(individId: string, body: MockDataRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/mock/{individId}";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMockData(_response);
        });
    }

    protected processMockData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Clear individ Mock data
     * @param individId IndividId
     * @return No Content
     */
    clearData(individId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/mock/{individId}";
        if (individId === undefined || individId === null)
            throw new globalThis.Error("The parameter 'individId' must be defined.");
        url_ = url_.replace("{individId}", encodeURIComponent("" + individId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearData(_response);
        });
    }

    protected processClearData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getReleaseNotesList( cancelToken?: CancelToken): Promise<ReleaseNotes[]> {
        let url_ = this.baseUrl + "/releasenotes/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReleaseNotesList(_response);
        });
    }

    protected processGetReleaseNotesList(response: AxiosResponse): Promise<ReleaseNotes[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseNotes.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ReleaseNotes[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReleaseNotes[]>(null as any);
    }

    /**
     * @return OK
     */
    getReleaseNotesContent(wikipagename: string, cancelToken?: CancelToken): Promise<ReleaseNotesContent> {
        let url_ = this.baseUrl + "/releasenotes/content/{wikipagename}";
        if (wikipagename === undefined || wikipagename === null)
            throw new globalThis.Error("The parameter 'wikipagename' must be defined.");
        url_ = url_.replace("{wikipagename}", encodeURIComponent("" + wikipagename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReleaseNotesContent(_response);
        });
    }

    protected processGetReleaseNotesContent(response: AxiosResponse): Promise<ReleaseNotesContent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReleaseNotesContent.fromJS(resultData200);
            return Promise.resolve<ReleaseNotesContent>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReleaseNotesContent>(null as any);
    }

    /**
     * Söker person eller företag utifrån möjliga sökparametrar.
     * @param q (optional) Söker individ och företag
    Personnummer, organisationsnummer, Freshdesk ärende-id (4-6 siffror) eller CRM ärendenummer (12-3456789)
     * @return OK
     */
    search(q: string | undefined, cancelToken?: CancelToken): Promise<SearchResponse[]> {
        let url_ = this.baseUrl + "/search?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<SearchResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SearchResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResponse[]>(null as any);
    }

    /**
     * Get available svarsmallar
     * @return OK
     */
    getSvarsmallar( cancelToken?: CancelToken): Promise<SvarsmallarResponse> {
        let url_ = this.baseUrl + "/svarsmallar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSvarsmallar(_response);
        });
    }

    protected processGetSvarsmallar(response: AxiosResponse): Promise<SvarsmallarResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SvarsmallarResponse.fromJS(resultData200);
            return Promise.resolve<SvarsmallarResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SvarsmallarResponse>(null as any);
    }
}

export class Adress implements IAdress {
    gatuadress?: string | null;
    coAdress?: string | null;
    postnummer?: string | null;
    postort?: string | null;
    land?: string | null;

    constructor(data?: IAdress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatuadress = _data["gatuadress"] !== undefined ? _data["gatuadress"] : null as any;
            this.coAdress = _data["coAdress"] !== undefined ? _data["coAdress"] : null as any;
            this.postnummer = _data["postnummer"] !== undefined ? _data["postnummer"] : null as any;
            this.postort = _data["postort"] !== undefined ? _data["postort"] : null as any;
            this.land = _data["land"] !== undefined ? _data["land"] : null as any;
        }
    }

    static fromJS(data: any): Adress {
        data = typeof data === 'object' ? data : {};
        let result = new Adress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatuadress"] = this.gatuadress !== undefined ? this.gatuadress : null as any;
        data["coAdress"] = this.coAdress !== undefined ? this.coAdress : null as any;
        data["postnummer"] = this.postnummer !== undefined ? this.postnummer : null as any;
        data["postort"] = this.postort !== undefined ? this.postort : null as any;
        data["land"] = this.land !== undefined ? this.land : null as any;
        return data;
    }
}

export interface IAdress {
    gatuadress?: string | null;
    coAdress?: string | null;
    postnummer?: string | null;
    postort?: string | null;
    land?: string | null;
}

export enum DataSource {
    Unknown = "Unknown",
    Syna = "Syna",
    Collectum = "Collectum",
    Alecta = "Alecta",
    Fora = "Fora",
    Permissions = "Permissions",
}

export enum DataStatus {
    Success = "Success",
    Error = "Error",
    NotFound = "NotFound",
    OldData = "OldData",
    Timeout = "Timeout",
}

export enum ErrorType {
    AgentNotFound = "AgentNotFound",
    ArendeAlreadyClosed = "ArendeAlreadyClosed",
    EmailConflict = "EmailConflict",
    PhoneNumberConflict = "PhoneNumberConflict",
    DummyContact = "DummyContact",
    InvalidContact = "InvalidContact",
    ArendeNotFound = "ArendeNotFound",
    ForbiddenFromCreatingNote = "ForbiddenFromCreatingNote",
    InternKommentarNotFound = "InternKommentarNotFound",
    Unknown = "Unknown",
}

export class InfoStatus implements IInfoStatus {
    source!: DataSource;
    status!: DataStatus;
    /** Tidpunkt för senaste hämtningen */
    updatedAtDateTime?: Date | null;
    /** Tidpunkt för uppdatering av data */
    updatedStatusDateTime!: Date;

    constructor(data?: IInfoStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.updatedAtDateTime = _data["updatedAtDateTime"] ? new Date(_data["updatedAtDateTime"].toString()) : null as any;
            this.updatedStatusDateTime = _data["updatedStatusDateTime"] ? new Date(_data["updatedStatusDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): InfoStatus {
        data = typeof data === 'object' ? data : {};
        let result = new InfoStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["updatedAtDateTime"] = this.updatedAtDateTime ? this.updatedAtDateTime.toISOString() : null as any;
        data["updatedStatusDateTime"] = this.updatedStatusDateTime ? this.updatedStatusDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IInfoStatus {
    source: DataSource;
    status: DataStatus;
    /** Tidpunkt för senaste hämtningen */
    updatedAtDateTime?: Date | null;
    /** Tidpunkt för uppdatering av data */
    updatedStatusDateTime: Date;
}

export enum PensionsplanType {
    ITP1 = "ITP1",
    ITP2 = "ITP2",
}

export class PlatformResponse_1OfBasuppgifterData implements IPlatformResponse_1OfBasuppgifterData {
    data?: BasuppgifterData | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfBasuppgifterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? BasuppgifterData.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfBasuppgifterData {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfBasuppgifterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfBasuppgifterData {
    data?: BasuppgifterData | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfEfterlevandeskydd implements IPlatformResponse_1OfEfterlevandeskydd {
    data?: Efterlevandeskydd | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfEfterlevandeskydd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Efterlevandeskydd.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfEfterlevandeskydd {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfEfterlevandeskydd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfEfterlevandeskydd {
    data?: Efterlevandeskydd | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfIndividuellaVal implements IPlatformResponse_1OfIndividuellaVal {
    data?: IndividuellaVal | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfIndividuellaVal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? IndividuellaVal.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfIndividuellaVal {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfIndividuellaVal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfIndividuellaVal {
    data?: IndividuellaVal | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfItp1 implements IPlatformResponse_1OfItp1 {
    data?: Itp1 | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfItp1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Itp1.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfItp1 {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfItp1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfItp1 {
    data?: Itp1 | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfItp2 implements IPlatformResponse_1OfItp2 {
    data?: Itp2 | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfItp2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Itp2.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfItp2 {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfItp2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfItp2 {
    data?: Itp2 | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfAnstalldaAtArbetsgivareResponse implements IPlatformResponse_1OfAnstalldaAtArbetsgivareResponse {
    data?: AnstalldaAtArbetsgivareResponse | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfAnstalldaAtArbetsgivareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AnstalldaAtArbetsgivareResponse.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfAnstalldaAtArbetsgivareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfAnstalldaAtArbetsgivareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfAnstalldaAtArbetsgivareResponse {
    data?: AnstalldaAtArbetsgivareResponse | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfAvtalResponse implements IPlatformResponse_1OfAvtalResponse {
    data?: AvtalResponse | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfAvtalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AvtalResponse.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfAvtalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfAvtalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfAvtalResponse {
    data?: AvtalResponse | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfNyckeltalForArbetsgivareResponse implements IPlatformResponse_1OfNyckeltalForArbetsgivareResponse {
    data?: NyckeltalForArbetsgivareResponse | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfNyckeltalForArbetsgivareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? NyckeltalForArbetsgivareResponse.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfNyckeltalForArbetsgivareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfNyckeltalForArbetsgivareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfNyckeltalForArbetsgivareResponse {
    data?: NyckeltalForArbetsgivareResponse | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfIndivid implements IPlatformResponse_1OfIndivid {
    data?: Individ | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfIndivid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Individ.fromJS(_data["data"]) : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfIndivid {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfIndivid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfIndivid {
    data?: Individ | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfList_1OfArbetsgivare implements IPlatformResponse_1OfList_1OfArbetsgivare {
    data?: Arbetsgivare[] | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfList_1OfArbetsgivare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Arbetsgivare.fromJS(item));
            }
            else {
                this.data = null as any;
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfList_1OfArbetsgivare {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfList_1OfArbetsgivare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfList_1OfArbetsgivare {
    data?: Arbetsgivare[] | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfList_1OfAnstallningPremier implements IPlatformResponse_1OfList_1OfAnstallningPremier {
    data?: AnstallningPremier[] | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfList_1OfAnstallningPremier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AnstallningPremier.fromJS(item));
            }
            else {
                this.data = null as any;
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfList_1OfAnstallningPremier {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfList_1OfAnstallningPremier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfList_1OfAnstallningPremier {
    data?: AnstallningPremier[] | null;
    statuses: InfoStatus[];
}

export class PlatformResponse_1OfList_1OfMinaForetag implements IPlatformResponse_1OfList_1OfMinaForetag {
    data?: MinaForetag[] | null;
    statuses!: InfoStatus[];

    constructor(data?: IPlatformResponse_1OfList_1OfMinaForetag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MinaForetag.fromJS(item));
            }
            else {
                this.data = null as any;
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(InfoStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): PlatformResponse_1OfList_1OfMinaForetag {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformResponse_1OfList_1OfMinaForetag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlatformResponse_1OfList_1OfMinaForetag {
    data?: MinaForetag[] | null;
    statuses: InfoStatus[];
}

export enum SortOrderType {
    Asc = "Asc",
    Desc = "Desc",
}

export class ValueResult_1OfAnstalldarende implements IValueResult_1OfAnstalldarende {
    value?: Anstalldarende | null;
    status!: number;
    errors!: ErrorType[];

    constructor(data?: IValueResult_1OfAnstalldarende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? Anstalldarende.fromJS(_data["value"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ValueResult_1OfAnstalldarende {
        data = typeof data === 'object' ? data : {};
        let result = new ValueResult_1OfAnstalldarende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IValueResult_1OfAnstalldarende {
    value?: Anstalldarende | null;
    status: number;
    errors: ErrorType[];
}

export class ValueResult_1OfArbetsgivarearende implements IValueResult_1OfArbetsgivarearende {
    value?: Arbetsgivarearende | null;
    status!: number;
    errors!: ErrorType[];

    constructor(data?: IValueResult_1OfArbetsgivarearende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? Arbetsgivarearende.fromJS(_data["value"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ValueResult_1OfArbetsgivarearende {
        data = typeof data === 'object' ? data : {};
        let result = new ValueResult_1OfArbetsgivarearende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IValueResult_1OfArbetsgivarearende {
    value?: Arbetsgivarearende | null;
    status: number;
    errors: ErrorType[];
}

export class ValueResult_1OfInternKommentar implements IValueResult_1OfInternKommentar {
    value?: InternKommentar | null;
    status!: number;
    errors!: ErrorType[];

    constructor(data?: IValueResult_1OfInternKommentar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? InternKommentar.fromJS(_data["value"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ValueResult_1OfInternKommentar {
        data = typeof data === 'object' ? data : {};
        let result = new ValueResult_1OfInternKommentar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IValueResult_1OfInternKommentar {
    value?: InternKommentar | null;
    status: number;
    errors: ErrorType[];
}

export class ValueResult_1OfList_1OfAnstalldarende implements IValueResult_1OfList_1OfAnstalldarende {
    value?: Anstalldarende[] | null;
    status!: number;
    errors!: ErrorType[];

    constructor(data?: IValueResult_1OfList_1OfAnstalldarende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Anstalldarende.fromJS(item));
            }
            else {
                this.value = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ValueResult_1OfList_1OfAnstalldarende {
        data = typeof data === 'object' ? data : {};
        let result = new ValueResult_1OfList_1OfAnstalldarende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IValueResult_1OfList_1OfAnstalldarende {
    value?: Anstalldarende[] | null;
    status: number;
    errors: ErrorType[];
}

export class ValueResult_1OfGuid implements IValueResult_1OfGuid {
    value?: string;
    status!: number;
    errors!: ErrorType[];

    constructor(data?: IValueResult_1OfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ValueResult_1OfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ValueResult_1OfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IValueResult_1OfGuid {
    value?: string;
    status: number;
    errors: ErrorType[];
}

export class ValueResult_1OfNullable_1OfGuid implements IValueResult_1OfNullable_1OfGuid {
    value?: string | null;
    status!: number;
    errors!: ErrorType[];

    constructor(data?: IValueResult_1OfNullable_1OfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ValueResult_1OfNullable_1OfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ValueResult_1OfNullable_1OfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IValueResult_1OfNullable_1OfGuid {
    value?: string | null;
    status: number;
    errors: ErrorType[];
}

export class Arbetsgivare implements IArbetsgivare {
    arbetsgivareId!: string;
    arbetsgivareTitle!: string;
    datumintervall!: string;
    organisationsnummer!: string;
    isPremiebefriad!: boolean;
    pensionsplan!: string;

    constructor(data?: IArbetsgivare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arbetsgivareId = _data["arbetsgivareId"] !== undefined ? _data["arbetsgivareId"] : null as any;
            this.arbetsgivareTitle = _data["arbetsgivareTitle"] !== undefined ? _data["arbetsgivareTitle"] : null as any;
            this.datumintervall = _data["datumintervall"] !== undefined ? _data["datumintervall"] : null as any;
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.isPremiebefriad = _data["isPremiebefriad"] !== undefined ? _data["isPremiebefriad"] : null as any;
            this.pensionsplan = _data["pensionsplan"] !== undefined ? _data["pensionsplan"] : null as any;
        }
    }

    static fromJS(data: any): Arbetsgivare {
        data = typeof data === 'object' ? data : {};
        let result = new Arbetsgivare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arbetsgivareId"] = this.arbetsgivareId !== undefined ? this.arbetsgivareId : null as any;
        data["arbetsgivareTitle"] = this.arbetsgivareTitle !== undefined ? this.arbetsgivareTitle : null as any;
        data["datumintervall"] = this.datumintervall !== undefined ? this.datumintervall : null as any;
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["isPremiebefriad"] = this.isPremiebefriad !== undefined ? this.isPremiebefriad : null as any;
        data["pensionsplan"] = this.pensionsplan !== undefined ? this.pensionsplan : null as any;
        return data;
    }
}

export interface IArbetsgivare {
    arbetsgivareId: string;
    arbetsgivareTitle: string;
    datumintervall: string;
    organisationsnummer: string;
    isPremiebefriad: boolean;
    pensionsplan: string;
}

export class Basuppgifter implements IBasuppgifter {
    isAktiv!: boolean;
    arbetsgivareNamn?: string | null;
    organisationsnummer?: string | null;
    foretagId?: string | null;
    startdatum!: string;
    slutdatum!: string;
    anmaldArslon?: number | null;
    anmaldLon?: number | null;
    efterskyddslon?: number | null;
    anmaldLonGiltigFrom!: string;
    pensionsmedforandeLon?: number | null;
    sjukpensionsgrundandeLon?: number | null;
    pensionsplansnamn?: string | null;
    pensionsalder?: string | null;
    pensionsplan?: PensionsplanType | null;
    uauTyp!: UauType;
    uauStartdatum!: string;
    uauSlutdatum!: string;
    isPremiebefriad!: boolean;

    constructor(data?: IBasuppgifter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAktiv = _data["isAktiv"] !== undefined ? _data["isAktiv"] : null as any;
            this.arbetsgivareNamn = _data["arbetsgivareNamn"] !== undefined ? _data["arbetsgivareNamn"] : null as any;
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.foretagId = _data["foretagId"] !== undefined ? _data["foretagId"] : null as any;
            this.startdatum = _data["startdatum"] !== undefined ? _data["startdatum"] : null as any;
            this.slutdatum = _data["slutdatum"] !== undefined ? _data["slutdatum"] : null as any;
            this.anmaldArslon = _data["anmaldArslon"] !== undefined ? _data["anmaldArslon"] : null as any;
            this.anmaldLon = _data["anmaldLon"] !== undefined ? _data["anmaldLon"] : null as any;
            this.efterskyddslon = _data["efterskyddslon"] !== undefined ? _data["efterskyddslon"] : null as any;
            this.anmaldLonGiltigFrom = _data["anmaldLonGiltigFrom"] !== undefined ? _data["anmaldLonGiltigFrom"] : null as any;
            this.pensionsmedforandeLon = _data["pensionsmedforandeLon"] !== undefined ? _data["pensionsmedforandeLon"] : null as any;
            this.sjukpensionsgrundandeLon = _data["sjukpensionsgrundandeLon"] !== undefined ? _data["sjukpensionsgrundandeLon"] : null as any;
            this.pensionsplansnamn = _data["pensionsplansnamn"] !== undefined ? _data["pensionsplansnamn"] : null as any;
            this.pensionsalder = _data["pensionsalder"] !== undefined ? _data["pensionsalder"] : null as any;
            this.pensionsplan = _data["pensionsplan"] !== undefined ? _data["pensionsplan"] : null as any;
            this.uauTyp = _data["uauTyp"] !== undefined ? _data["uauTyp"] : null as any;
            this.uauStartdatum = _data["uauStartdatum"] !== undefined ? _data["uauStartdatum"] : null as any;
            this.uauSlutdatum = _data["uauSlutdatum"] !== undefined ? _data["uauSlutdatum"] : null as any;
            this.isPremiebefriad = _data["isPremiebefriad"] !== undefined ? _data["isPremiebefriad"] : null as any;
        }
    }

    static fromJS(data: any): Basuppgifter {
        data = typeof data === 'object' ? data : {};
        let result = new Basuppgifter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAktiv"] = this.isAktiv !== undefined ? this.isAktiv : null as any;
        data["arbetsgivareNamn"] = this.arbetsgivareNamn !== undefined ? this.arbetsgivareNamn : null as any;
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["foretagId"] = this.foretagId !== undefined ? this.foretagId : null as any;
        data["startdatum"] = this.startdatum !== undefined ? this.startdatum : null as any;
        data["slutdatum"] = this.slutdatum !== undefined ? this.slutdatum : null as any;
        data["anmaldArslon"] = this.anmaldArslon !== undefined ? this.anmaldArslon : null as any;
        data["anmaldLon"] = this.anmaldLon !== undefined ? this.anmaldLon : null as any;
        data["efterskyddslon"] = this.efterskyddslon !== undefined ? this.efterskyddslon : null as any;
        data["anmaldLonGiltigFrom"] = this.anmaldLonGiltigFrom !== undefined ? this.anmaldLonGiltigFrom : null as any;
        data["pensionsmedforandeLon"] = this.pensionsmedforandeLon !== undefined ? this.pensionsmedforandeLon : null as any;
        data["sjukpensionsgrundandeLon"] = this.sjukpensionsgrundandeLon !== undefined ? this.sjukpensionsgrundandeLon : null as any;
        data["pensionsplansnamn"] = this.pensionsplansnamn !== undefined ? this.pensionsplansnamn : null as any;
        data["pensionsalder"] = this.pensionsalder !== undefined ? this.pensionsalder : null as any;
        data["pensionsplan"] = this.pensionsplan !== undefined ? this.pensionsplan : null as any;
        data["uauTyp"] = this.uauTyp !== undefined ? this.uauTyp : null as any;
        data["uauStartdatum"] = this.uauStartdatum !== undefined ? this.uauStartdatum : null as any;
        data["uauSlutdatum"] = this.uauSlutdatum !== undefined ? this.uauSlutdatum : null as any;
        data["isPremiebefriad"] = this.isPremiebefriad !== undefined ? this.isPremiebefriad : null as any;
        return data;
    }
}

export interface IBasuppgifter {
    isAktiv: boolean;
    arbetsgivareNamn?: string | null;
    organisationsnummer?: string | null;
    foretagId?: string | null;
    startdatum: string;
    slutdatum: string;
    anmaldArslon?: number | null;
    anmaldLon?: number | null;
    efterskyddslon?: number | null;
    anmaldLonGiltigFrom: string;
    pensionsmedforandeLon?: number | null;
    sjukpensionsgrundandeLon?: number | null;
    pensionsplansnamn?: string | null;
    pensionsalder?: string | null;
    pensionsplan?: PensionsplanType | null;
    uauTyp: UauType;
    uauStartdatum: string;
    uauSlutdatum: string;
    isPremiebefriad: boolean;
}

export class BasuppgifterData implements IBasuppgifterData {
    alder!: string;
    basuppgifterList!: Basuppgifter[];

    constructor(data?: IBasuppgifterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.basuppgifterList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alder = _data["alder"] !== undefined ? _data["alder"] : null as any;
            if (Array.isArray(_data["basuppgifterList"])) {
                this.basuppgifterList = [] as any;
                for (let item of _data["basuppgifterList"])
                    this.basuppgifterList!.push(Basuppgifter.fromJS(item));
            }
            else {
                this.basuppgifterList = null as any;
            }
        }
    }

    static fromJS(data: any): BasuppgifterData {
        data = typeof data === 'object' ? data : {};
        let result = new BasuppgifterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alder"] = this.alder !== undefined ? this.alder : null as any;
        if (Array.isArray(this.basuppgifterList)) {
            data["basuppgifterList"] = [];
            for (let item of this.basuppgifterList)
                data["basuppgifterList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBasuppgifterData {
    alder: string;
    basuppgifterList: Basuppgifter[];
}

export enum UauType {
    Okand = "Okand",
    Undantag = "Undantag",
    Avstaende = "Avstaende",
    Uttrade = "Uttrade",
}

export class NuvarandePlaceringsval implements INuvarandePlaceringsval {
    forsakringsbolagNamn!: string;
    procent!: string;

    constructor(data?: INuvarandePlaceringsval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakringsbolagNamn = _data["forsakringsbolagNamn"] !== undefined ? _data["forsakringsbolagNamn"] : null as any;
            this.procent = _data["procent"] !== undefined ? _data["procent"] : null as any;
        }
    }

    static fromJS(data: any): NuvarandePlaceringsval {
        data = typeof data === 'object' ? data : {};
        let result = new NuvarandePlaceringsval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakringsbolagNamn"] = this.forsakringsbolagNamn !== undefined ? this.forsakringsbolagNamn : null as any;
        data["procent"] = this.procent !== undefined ? this.procent : null as any;
        return data;
    }
}

export interface INuvarandePlaceringsval {
    forsakringsbolagNamn: string;
    procent: string;
}

export class Aterbetalningsskydd implements IAterbetalningsskydd {
    forsakringsbolagsnamn!: string;
    produkttyp!: string;
    forsakringsnummer!: string;
    aterbetalningsskyddHalsoprovningPagar?: boolean;
    hasAterbetalningsskydd?: boolean;

    constructor(data?: IAterbetalningsskydd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakringsbolagsnamn = _data["forsakringsbolagsnamn"] !== undefined ? _data["forsakringsbolagsnamn"] : null as any;
            this.produkttyp = _data["produkttyp"] !== undefined ? _data["produkttyp"] : null as any;
            this.forsakringsnummer = _data["forsakringsnummer"] !== undefined ? _data["forsakringsnummer"] : null as any;
            this.aterbetalningsskyddHalsoprovningPagar = _data["aterbetalningsskyddHalsoprovningPagar"] !== undefined ? _data["aterbetalningsskyddHalsoprovningPagar"] : null as any;
            this.hasAterbetalningsskydd = _data["hasAterbetalningsskydd"] !== undefined ? _data["hasAterbetalningsskydd"] : null as any;
        }
    }

    static fromJS(data: any): Aterbetalningsskydd {
        data = typeof data === 'object' ? data : {};
        let result = new Aterbetalningsskydd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakringsbolagsnamn"] = this.forsakringsbolagsnamn !== undefined ? this.forsakringsbolagsnamn : null as any;
        data["produkttyp"] = this.produkttyp !== undefined ? this.produkttyp : null as any;
        data["forsakringsnummer"] = this.forsakringsnummer !== undefined ? this.forsakringsnummer : null as any;
        data["aterbetalningsskyddHalsoprovningPagar"] = this.aterbetalningsskyddHalsoprovningPagar !== undefined ? this.aterbetalningsskyddHalsoprovningPagar : null as any;
        data["hasAterbetalningsskydd"] = this.hasAterbetalningsskydd !== undefined ? this.hasAterbetalningsskydd : null as any;
        return data;
    }
}

export interface IAterbetalningsskydd {
    forsakringsbolagsnamn: string;
    produkttyp: string;
    forsakringsnummer: string;
    aterbetalningsskyddHalsoprovningPagar?: boolean;
    hasAterbetalningsskydd?: boolean;
}

export class Efterlevandeskydd implements IEfterlevandeskydd {
    aterbetalningsskyddHalsoprovningPagar?: boolean;
    aterbetalningsskyddList!: Aterbetalningsskydd[];
    familjepension?: Familjepension | null;
    familjeskydd?: Familjeskydd | null;

    constructor(data?: IEfterlevandeskydd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.aterbetalningsskyddList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aterbetalningsskyddHalsoprovningPagar = _data["aterbetalningsskyddHalsoprovningPagar"] !== undefined ? _data["aterbetalningsskyddHalsoprovningPagar"] : null as any;
            if (Array.isArray(_data["aterbetalningsskyddList"])) {
                this.aterbetalningsskyddList = [] as any;
                for (let item of _data["aterbetalningsskyddList"])
                    this.aterbetalningsskyddList!.push(Aterbetalningsskydd.fromJS(item));
            }
            else {
                this.aterbetalningsskyddList = null as any;
            }
            this.familjepension = _data["familjepension"] ? Familjepension.fromJS(_data["familjepension"]) : null as any;
            this.familjeskydd = _data["familjeskydd"] ? Familjeskydd.fromJS(_data["familjeskydd"]) : null as any;
        }
    }

    static fromJS(data: any): Efterlevandeskydd {
        data = typeof data === 'object' ? data : {};
        let result = new Efterlevandeskydd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aterbetalningsskyddHalsoprovningPagar"] = this.aterbetalningsskyddHalsoprovningPagar !== undefined ? this.aterbetalningsskyddHalsoprovningPagar : null as any;
        if (Array.isArray(this.aterbetalningsskyddList)) {
            data["aterbetalningsskyddList"] = [];
            for (let item of this.aterbetalningsskyddList)
                data["aterbetalningsskyddList"].push(item ? item.toJSON() : null as any);
        }
        data["familjepension"] = this.familjepension ? this.familjepension.toJSON() : null as any;
        data["familjeskydd"] = this.familjeskydd ? this.familjeskydd.toJSON() : null as any;
        return data;
    }
}

export interface IEfterlevandeskydd {
    aterbetalningsskyddHalsoprovningPagar?: boolean;
    aterbetalningsskyddList: Aterbetalningsskydd[];
    familjepension?: Familjepension | null;
    familjeskydd?: Familjeskydd | null;
}

export class Familjepension implements IFamiljepension {
    avstaendeFamiljepension!: boolean;
    familjepensionItems!: FamiljepensionItem[];

    constructor(data?: IFamiljepension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.familjepensionItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avstaendeFamiljepension = _data["avstaendeFamiljepension"] !== undefined ? _data["avstaendeFamiljepension"] : null as any;
            if (Array.isArray(_data["familjepensionItems"])) {
                this.familjepensionItems = [] as any;
                for (let item of _data["familjepensionItems"])
                    this.familjepensionItems!.push(FamiljepensionItem.fromJS(item));
            }
            else {
                this.familjepensionItems = null as any;
            }
        }
    }

    static fromJS(data: any): Familjepension {
        data = typeof data === 'object' ? data : {};
        let result = new Familjepension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avstaendeFamiljepension"] = this.avstaendeFamiljepension !== undefined ? this.avstaendeFamiljepension : null as any;
        if (Array.isArray(this.familjepensionItems)) {
            data["familjepensionItems"] = [];
            for (let item of this.familjepensionItems)
                data["familjepensionItems"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFamiljepension {
    avstaendeFamiljepension: boolean;
    familjepensionItems: FamiljepensionItem[];
}

export class FamiljepensionItem implements IFamiljepensionItem {
    familjepensionNamn!: string | null;
    familjepensionFribrevsvarde?: number | null;
    familjepensionPrognos?: number | null;

    constructor(data?: IFamiljepensionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.familjepensionNamn = _data["familjepensionNamn"] !== undefined ? _data["familjepensionNamn"] : null as any;
            this.familjepensionFribrevsvarde = _data["familjepensionFribrevsvarde"] !== undefined ? _data["familjepensionFribrevsvarde"] : null as any;
            this.familjepensionPrognos = _data["familjepensionPrognos"] !== undefined ? _data["familjepensionPrognos"] : null as any;
        }
    }

    static fromJS(data: any): FamiljepensionItem {
        data = typeof data === 'object' ? data : {};
        let result = new FamiljepensionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familjepensionNamn"] = this.familjepensionNamn !== undefined ? this.familjepensionNamn : null as any;
        data["familjepensionFribrevsvarde"] = this.familjepensionFribrevsvarde !== undefined ? this.familjepensionFribrevsvarde : null as any;
        data["familjepensionPrognos"] = this.familjepensionPrognos !== undefined ? this.familjepensionPrognos : null as any;
        return data;
    }
}

export interface IFamiljepensionItem {
    familjepensionNamn: string | null;
    familjepensionFribrevsvarde?: number | null;
    familjepensionPrognos?: number | null;
}

export class Familjeskydd implements IFamiljeskydd {
    familjeskyddTitle!: string;
    ersattningsbeloppPerManad!: string;
    utbetalningstid!: string;

    constructor(data?: IFamiljeskydd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.familjeskyddTitle = _data["familjeskyddTitle"] !== undefined ? _data["familjeskyddTitle"] : null as any;
            this.ersattningsbeloppPerManad = _data["ersattningsbeloppPerManad"] !== undefined ? _data["ersattningsbeloppPerManad"] : null as any;
            this.utbetalningstid = _data["utbetalningstid"] !== undefined ? _data["utbetalningstid"] : null as any;
        }
    }

    static fromJS(data: any): Familjeskydd {
        data = typeof data === 'object' ? data : {};
        let result = new Familjeskydd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familjeskyddTitle"] = this.familjeskyddTitle !== undefined ? this.familjeskyddTitle : null as any;
        data["ersattningsbeloppPerManad"] = this.ersattningsbeloppPerManad !== undefined ? this.ersattningsbeloppPerManad : null as any;
        data["utbetalningstid"] = this.utbetalningstid !== undefined ? this.utbetalningstid : null as any;
        return data;
    }
}

export interface IFamiljeskydd {
    familjeskyddTitle: string;
    ersattningsbeloppPerManad: string;
    utbetalningstid: string;
}

export class Aterbetalningsskydd2 implements IAterbetalningsskydd2 {
    produkttyp!: string;
    gallandeVal!: string;
    giltigFrom?: string | null;
    statustext!: string;

    constructor(data?: IAterbetalningsskydd2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produkttyp = _data["produkttyp"] !== undefined ? _data["produkttyp"] : null as any;
            this.gallandeVal = _data["gallandeVal"] !== undefined ? _data["gallandeVal"] : null as any;
            this.giltigFrom = _data["giltigFrom"] !== undefined ? _data["giltigFrom"] : null as any;
            this.statustext = _data["statustext"] !== undefined ? _data["statustext"] : null as any;
        }
    }

    static fromJS(data: any): Aterbetalningsskydd2 {
        data = typeof data === 'object' ? data : {};
        let result = new Aterbetalningsskydd2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produkttyp"] = this.produkttyp !== undefined ? this.produkttyp : null as any;
        data["gallandeVal"] = this.gallandeVal !== undefined ? this.gallandeVal : null as any;
        data["giltigFrom"] = this.giltigFrom !== undefined ? this.giltigFrom : null as any;
        data["statustext"] = this.statustext !== undefined ? this.statustext : null as any;
        return data;
    }
}

export interface IAterbetalningsskydd2 {
    produkttyp: string;
    gallandeVal: string;
    giltigFrom?: string | null;
    statustext: string;
}

export class AvstaendeFamiljepension implements IAvstaendeFamiljepension {
    hasAvstaende?: boolean | null;
    giltigFrom!: string;

    constructor(data?: IAvstaendeFamiljepension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAvstaende = _data["hasAvstaende"] !== undefined ? _data["hasAvstaende"] : null as any;
            this.giltigFrom = _data["giltigFrom"] !== undefined ? _data["giltigFrom"] : null as any;
        }
    }

    static fromJS(data: any): AvstaendeFamiljepension {
        data = typeof data === 'object' ? data : {};
        let result = new AvstaendeFamiljepension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAvstaende"] = this.hasAvstaende !== undefined ? this.hasAvstaende : null as any;
        data["giltigFrom"] = this.giltigFrom !== undefined ? this.giltigFrom : null as any;
        return data;
    }
}

export interface IAvstaendeFamiljepension {
    hasAvstaende?: boolean | null;
    giltigFrom: string;
}

export class FamiljeSkydd implements IFamiljeSkydd {
    gallandeVal!: string;
    giltigFrom?: string | null;
    statustext!: string;

    constructor(data?: IFamiljeSkydd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gallandeVal = _data["gallandeVal"] !== undefined ? _data["gallandeVal"] : null as any;
            this.giltigFrom = _data["giltigFrom"] !== undefined ? _data["giltigFrom"] : null as any;
            this.statustext = _data["statustext"] !== undefined ? _data["statustext"] : null as any;
        }
    }

    static fromJS(data: any): FamiljeSkydd {
        data = typeof data === 'object' ? data : {};
        let result = new FamiljeSkydd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gallandeVal"] = this.gallandeVal !== undefined ? this.gallandeVal : null as any;
        data["giltigFrom"] = this.giltigFrom !== undefined ? this.giltigFrom : null as any;
        data["statustext"] = this.statustext !== undefined ? this.statustext : null as any;
        return data;
    }
}

export interface IFamiljeSkydd {
    gallandeVal: string;
    giltigFrom?: string | null;
    statustext: string;
}

export class IndividuellaVal implements IIndividuellaVal {
    aterbetalningsskyddList!: Aterbetalningsskydd2[];
    avstaendeFamiljepension?: AvstaendeFamiljepension | null;
    familjeskydd!: FamiljeSkydd;

    constructor(data?: IIndividuellaVal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.aterbetalningsskyddList = [];
            this.familjeskydd = new FamiljeSkydd();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["aterbetalningsskyddList"])) {
                this.aterbetalningsskyddList = [] as any;
                for (let item of _data["aterbetalningsskyddList"])
                    this.aterbetalningsskyddList!.push(Aterbetalningsskydd2.fromJS(item));
            }
            else {
                this.aterbetalningsskyddList = null as any;
            }
            this.avstaendeFamiljepension = _data["avstaendeFamiljepension"] ? AvstaendeFamiljepension.fromJS(_data["avstaendeFamiljepension"]) : null as any;
            this.familjeskydd = _data["familjeskydd"] ? FamiljeSkydd.fromJS(_data["familjeskydd"]) : new FamiljeSkydd();
        }
    }

    static fromJS(data: any): IndividuellaVal {
        data = typeof data === 'object' ? data : {};
        let result = new IndividuellaVal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.aterbetalningsskyddList)) {
            data["aterbetalningsskyddList"] = [];
            for (let item of this.aterbetalningsskyddList)
                data["aterbetalningsskyddList"].push(item ? item.toJSON() : null as any);
        }
        data["avstaendeFamiljepension"] = this.avstaendeFamiljepension ? this.avstaendeFamiljepension.toJSON() : null as any;
        data["familjeskydd"] = this.familjeskydd ? this.familjeskydd.toJSON() : null as any;
        return data;
    }
}

export interface IIndividuellaVal {
    aterbetalningsskyddList: Aterbetalningsskydd2[];
    avstaendeFamiljepension?: AvstaendeFamiljepension | null;
    familjeskydd: FamiljeSkydd;
}

export class Insikt implements IInsikt {
    beskrivning!: string;

    constructor(data?: IInsikt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beskrivning = _data["beskrivning"] !== undefined ? _data["beskrivning"] : null as any;
        }
    }

    static fromJS(data: any): Insikt {
        data = typeof data === 'object' ? data : {};
        let result = new Insikt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beskrivning"] = this.beskrivning !== undefined ? this.beskrivning : null as any;
        return data;
    }
}

export interface IInsikt {
    beskrivning: string;
}

export class Itp1 implements IItp1 {
    pensionsplansnamn?: string | null;
    nuvarandePlaceringsval!: NuvarandePlaceringsval[];
    pensioner!: Itp1Pension[];
    preliminartBeloppPerManad!: number;
    isActive!: boolean;

    constructor(data?: IItp1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.nuvarandePlaceringsval = [];
            this.pensioner = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pensionsplansnamn = _data["pensionsplansnamn"] !== undefined ? _data["pensionsplansnamn"] : null as any;
            if (Array.isArray(_data["nuvarandePlaceringsval"])) {
                this.nuvarandePlaceringsval = [] as any;
                for (let item of _data["nuvarandePlaceringsval"])
                    this.nuvarandePlaceringsval!.push(NuvarandePlaceringsval.fromJS(item));
            }
            else {
                this.nuvarandePlaceringsval = null as any;
            }
            if (Array.isArray(_data["pensioner"])) {
                this.pensioner = [] as any;
                for (let item of _data["pensioner"])
                    this.pensioner!.push(Itp1Pension.fromJS(item));
            }
            else {
                this.pensioner = null as any;
            }
            this.preliminartBeloppPerManad = _data["preliminartBeloppPerManad"] !== undefined ? _data["preliminartBeloppPerManad"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): Itp1 {
        data = typeof data === 'object' ? data : {};
        let result = new Itp1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pensionsplansnamn"] = this.pensionsplansnamn !== undefined ? this.pensionsplansnamn : null as any;
        if (Array.isArray(this.nuvarandePlaceringsval)) {
            data["nuvarandePlaceringsval"] = [];
            for (let item of this.nuvarandePlaceringsval)
                data["nuvarandePlaceringsval"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pensioner)) {
            data["pensioner"] = [];
            for (let item of this.pensioner)
                data["pensioner"].push(item ? item.toJSON() : null as any);
        }
        data["preliminartBeloppPerManad"] = this.preliminartBeloppPerManad !== undefined ? this.preliminartBeloppPerManad : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }
}

export interface IItp1 {
    pensionsplansnamn?: string | null;
    nuvarandePlaceringsval: NuvarandePlaceringsval[];
    pensioner: Itp1Pension[];
    preliminartBeloppPerManad: number;
    isActive: boolean;
}

export class Itp1Pension implements IItp1Pension {
    forsakringsbolagNamn!: string;
    subtext!: string;
    belopp?: number | null;

    constructor(data?: IItp1Pension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakringsbolagNamn = _data["forsakringsbolagNamn"] !== undefined ? _data["forsakringsbolagNamn"] : null as any;
            this.subtext = _data["subtext"] !== undefined ? _data["subtext"] : null as any;
            this.belopp = _data["belopp"] !== undefined ? _data["belopp"] : null as any;
        }
    }

    static fromJS(data: any): Itp1Pension {
        data = typeof data === 'object' ? data : {};
        let result = new Itp1Pension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakringsbolagNamn"] = this.forsakringsbolagNamn !== undefined ? this.forsakringsbolagNamn : null as any;
        data["subtext"] = this.subtext !== undefined ? this.subtext : null as any;
        data["belopp"] = this.belopp !== undefined ? this.belopp : null as any;
        return data;
    }
}

export interface IItp1Pension {
    forsakringsbolagNamn: string;
    subtext: string;
    belopp?: number | null;
}

export class FormansbestamdAlderspension implements IFormansbestamdAlderspension {
    produktnamn!: string;
    fribrevsvarden!: FormansbestamdAlderspensionItem[];
    prognosManadsbelopp!: FormansbestamdAlderspensionItem[];

    constructor(data?: IFormansbestamdAlderspension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.fribrevsvarden = [];
            this.prognosManadsbelopp = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produktnamn = _data["produktnamn"] !== undefined ? _data["produktnamn"] : null as any;
            if (Array.isArray(_data["fribrevsvarden"])) {
                this.fribrevsvarden = [] as any;
                for (let item of _data["fribrevsvarden"])
                    this.fribrevsvarden!.push(FormansbestamdAlderspensionItem.fromJS(item));
            }
            else {
                this.fribrevsvarden = null as any;
            }
            if (Array.isArray(_data["prognosManadsbelopp"])) {
                this.prognosManadsbelopp = [] as any;
                for (let item of _data["prognosManadsbelopp"])
                    this.prognosManadsbelopp!.push(FormansbestamdAlderspensionItem.fromJS(item));
            }
            else {
                this.prognosManadsbelopp = null as any;
            }
        }
    }

    static fromJS(data: any): FormansbestamdAlderspension {
        data = typeof data === 'object' ? data : {};
        let result = new FormansbestamdAlderspension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produktnamn"] = this.produktnamn !== undefined ? this.produktnamn : null as any;
        if (Array.isArray(this.fribrevsvarden)) {
            data["fribrevsvarden"] = [];
            for (let item of this.fribrevsvarden)
                data["fribrevsvarden"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prognosManadsbelopp)) {
            data["prognosManadsbelopp"] = [];
            for (let item of this.prognosManadsbelopp)
                data["prognosManadsbelopp"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFormansbestamdAlderspension {
    produktnamn: string;
    fribrevsvarden: FormansbestamdAlderspensionItem[];
    prognosManadsbelopp: FormansbestamdAlderspensionItem[];
}

export class FormansbestamdAlderspensionItem implements IFormansbestamdAlderspensionItem {
    utbetalningstext!: string;
    belopp!: string;

    constructor(data?: IFormansbestamdAlderspensionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utbetalningstext = _data["utbetalningstext"] !== undefined ? _data["utbetalningstext"] : null as any;
            this.belopp = _data["belopp"] !== undefined ? _data["belopp"] : null as any;
        }
    }

    static fromJS(data: any): FormansbestamdAlderspensionItem {
        data = typeof data === 'object' ? data : {};
        let result = new FormansbestamdAlderspensionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utbetalningstext"] = this.utbetalningstext !== undefined ? this.utbetalningstext : null as any;
        data["belopp"] = this.belopp !== undefined ? this.belopp : null as any;
        return data;
    }
}

export interface IFormansbestamdAlderspensionItem {
    utbetalningstext: string;
    belopp: string;
}

export class Itp2 implements IItp2 {
    intjanadTjanstetidUnder75Ibb?: number | null;
    beraknadTjanstetidUnder75Ibb?: number | null;
    intjanadTjanstetidOver75Ibb?: number | null;
    beraknadTjanstetidOver75Ibb?: number | null;
    formansbestamdAlderspension!: FormansbestamdAlderspension[] | null;
    forsakringsbolagItpk?: string | null;
    tiotaggarlosning?: Tiotaggarlosning | null;
    pensionsplanNamn?: string | null;
    itpk?: Itpk | null;
    uitpk?: Uitpk | null;
    lp?: Lp | null;
    pp?: Pp | null;
    isActive!: boolean;

    constructor(data?: IItp2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intjanadTjanstetidUnder75Ibb = _data["intjanadTjanstetidUnder75Ibb"] !== undefined ? _data["intjanadTjanstetidUnder75Ibb"] : null as any;
            this.beraknadTjanstetidUnder75Ibb = _data["beraknadTjanstetidUnder75Ibb"] !== undefined ? _data["beraknadTjanstetidUnder75Ibb"] : null as any;
            this.intjanadTjanstetidOver75Ibb = _data["intjanadTjanstetidOver75Ibb"] !== undefined ? _data["intjanadTjanstetidOver75Ibb"] : null as any;
            this.beraknadTjanstetidOver75Ibb = _data["beraknadTjanstetidOver75Ibb"] !== undefined ? _data["beraknadTjanstetidOver75Ibb"] : null as any;
            if (Array.isArray(_data["formansbestamdAlderspension"])) {
                this.formansbestamdAlderspension = [] as any;
                for (let item of _data["formansbestamdAlderspension"])
                    this.formansbestamdAlderspension!.push(FormansbestamdAlderspension.fromJS(item));
            }
            else {
                this.formansbestamdAlderspension = null as any;
            }
            this.forsakringsbolagItpk = _data["forsakringsbolagItpk"] !== undefined ? _data["forsakringsbolagItpk"] : null as any;
            this.tiotaggarlosning = _data["tiotaggarlosning"] ? Tiotaggarlosning.fromJS(_data["tiotaggarlosning"]) : null as any;
            this.pensionsplanNamn = _data["pensionsplanNamn"] !== undefined ? _data["pensionsplanNamn"] : null as any;
            this.itpk = _data["itpk"] ? Itpk.fromJS(_data["itpk"]) : null as any;
            this.uitpk = _data["uitpk"] ? Uitpk.fromJS(_data["uitpk"]) : null as any;
            this.lp = _data["lp"] ? Lp.fromJS(_data["lp"]) : null as any;
            this.pp = _data["pp"] ? Pp.fromJS(_data["pp"]) : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): Itp2 {
        data = typeof data === 'object' ? data : {};
        let result = new Itp2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intjanadTjanstetidUnder75Ibb"] = this.intjanadTjanstetidUnder75Ibb !== undefined ? this.intjanadTjanstetidUnder75Ibb : null as any;
        data["beraknadTjanstetidUnder75Ibb"] = this.beraknadTjanstetidUnder75Ibb !== undefined ? this.beraknadTjanstetidUnder75Ibb : null as any;
        data["intjanadTjanstetidOver75Ibb"] = this.intjanadTjanstetidOver75Ibb !== undefined ? this.intjanadTjanstetidOver75Ibb : null as any;
        data["beraknadTjanstetidOver75Ibb"] = this.beraknadTjanstetidOver75Ibb !== undefined ? this.beraknadTjanstetidOver75Ibb : null as any;
        if (Array.isArray(this.formansbestamdAlderspension)) {
            data["formansbestamdAlderspension"] = [];
            for (let item of this.formansbestamdAlderspension)
                data["formansbestamdAlderspension"].push(item ? item.toJSON() : null as any);
        }
        data["forsakringsbolagItpk"] = this.forsakringsbolagItpk !== undefined ? this.forsakringsbolagItpk : null as any;
        data["tiotaggarlosning"] = this.tiotaggarlosning ? this.tiotaggarlosning.toJSON() : null as any;
        data["pensionsplanNamn"] = this.pensionsplanNamn !== undefined ? this.pensionsplanNamn : null as any;
        data["itpk"] = this.itpk ? this.itpk.toJSON() : null as any;
        data["uitpk"] = this.uitpk ? this.uitpk.toJSON() : null as any;
        data["lp"] = this.lp ? this.lp.toJSON() : null as any;
        data["pp"] = this.pp ? this.pp.toJSON() : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }
}

export interface IItp2 {
    intjanadTjanstetidUnder75Ibb?: number | null;
    beraknadTjanstetidUnder75Ibb?: number | null;
    intjanadTjanstetidOver75Ibb?: number | null;
    beraknadTjanstetidOver75Ibb?: number | null;
    formansbestamdAlderspension: FormansbestamdAlderspension[] | null;
    forsakringsbolagItpk?: string | null;
    tiotaggarlosning?: Tiotaggarlosning | null;
    pensionsplanNamn?: string | null;
    itpk?: Itpk | null;
    uitpk?: Uitpk | null;
    lp?: Lp | null;
    pp?: Pp | null;
    isActive: boolean;
}

export class Tiotaggarlosning implements ITiotaggarlosning {
    status!: TiotaggarlosningStatus;
    datum!: string;

    constructor(data?: ITiotaggarlosning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.datum = _data["datum"] !== undefined ? _data["datum"] : null as any;
        }
    }

    static fromJS(data: any): Tiotaggarlosning {
        data = typeof data === 'object' ? data : {};
        let result = new Tiotaggarlosning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["datum"] = this.datum !== undefined ? this.datum : null as any;
        return data;
    }
}

export interface ITiotaggarlosning {
    status: TiotaggarlosningStatus;
    datum: string;
}

export enum TiotaggarlosningStatus {
    EndastAktiv = "EndastAktiv",
    EndastInaktiv = "EndastInaktiv",
    AktivOchInaktiv = "AktivOchInaktiv",
}

export class Itpk implements IItpk {
    nuvarandePlaceringsval!: NuvarandePlaceringsval[];
    kapital!: TjanstepensionKapital[];
    preliminaraBelopp!: PreliminartBelopp[];

    constructor(data?: IItpk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.nuvarandePlaceringsval = [];
            this.kapital = [];
            this.preliminaraBelopp = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nuvarandePlaceringsval"])) {
                this.nuvarandePlaceringsval = [] as any;
                for (let item of _data["nuvarandePlaceringsval"])
                    this.nuvarandePlaceringsval!.push(NuvarandePlaceringsval.fromJS(item));
            }
            else {
                this.nuvarandePlaceringsval = null as any;
            }
            if (Array.isArray(_data["kapital"])) {
                this.kapital = [] as any;
                for (let item of _data["kapital"])
                    this.kapital!.push(TjanstepensionKapital.fromJS(item));
            }
            else {
                this.kapital = null as any;
            }
            if (Array.isArray(_data["preliminaraBelopp"])) {
                this.preliminaraBelopp = [] as any;
                for (let item of _data["preliminaraBelopp"])
                    this.preliminaraBelopp!.push(PreliminartBelopp.fromJS(item));
            }
            else {
                this.preliminaraBelopp = null as any;
            }
        }
    }

    static fromJS(data: any): Itpk {
        data = typeof data === 'object' ? data : {};
        let result = new Itpk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nuvarandePlaceringsval)) {
            data["nuvarandePlaceringsval"] = [];
            for (let item of this.nuvarandePlaceringsval)
                data["nuvarandePlaceringsval"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.kapital)) {
            data["kapital"] = [];
            for (let item of this.kapital)
                data["kapital"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.preliminaraBelopp)) {
            data["preliminaraBelopp"] = [];
            for (let item of this.preliminaraBelopp)
                data["preliminaraBelopp"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IItpk {
    nuvarandePlaceringsval: NuvarandePlaceringsval[];
    kapital: TjanstepensionKapital[];
    preliminaraBelopp: PreliminartBelopp[];
}

export class Lp implements ILp {
    nuvarandePlaceringsval!: NuvarandePlaceringsval[];
    kapital!: TjanstepensionKapital[];
    preliminaraBelopp!: PreliminartBelopp[];

    constructor(data?: ILp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.nuvarandePlaceringsval = [];
            this.kapital = [];
            this.preliminaraBelopp = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nuvarandePlaceringsval"])) {
                this.nuvarandePlaceringsval = [] as any;
                for (let item of _data["nuvarandePlaceringsval"])
                    this.nuvarandePlaceringsval!.push(NuvarandePlaceringsval.fromJS(item));
            }
            else {
                this.nuvarandePlaceringsval = null as any;
            }
            if (Array.isArray(_data["kapital"])) {
                this.kapital = [] as any;
                for (let item of _data["kapital"])
                    this.kapital!.push(TjanstepensionKapital.fromJS(item));
            }
            else {
                this.kapital = null as any;
            }
            if (Array.isArray(_data["preliminaraBelopp"])) {
                this.preliminaraBelopp = [] as any;
                for (let item of _data["preliminaraBelopp"])
                    this.preliminaraBelopp!.push(PreliminartBelopp.fromJS(item));
            }
            else {
                this.preliminaraBelopp = null as any;
            }
        }
    }

    static fromJS(data: any): Lp {
        data = typeof data === 'object' ? data : {};
        let result = new Lp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nuvarandePlaceringsval)) {
            data["nuvarandePlaceringsval"] = [];
            for (let item of this.nuvarandePlaceringsval)
                data["nuvarandePlaceringsval"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.kapital)) {
            data["kapital"] = [];
            for (let item of this.kapital)
                data["kapital"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.preliminaraBelopp)) {
            data["preliminaraBelopp"] = [];
            for (let item of this.preliminaraBelopp)
                data["preliminaraBelopp"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ILp {
    nuvarandePlaceringsval: NuvarandePlaceringsval[];
    kapital: TjanstepensionKapital[];
    preliminaraBelopp: PreliminartBelopp[];
}

export class Pp implements IPp {
    nuvarandePlaceringsval!: NuvarandePlaceringsval[];
    kapital!: TjanstepensionKapital[];
    preliminaraBelopp!: PreliminartBelopp[];

    constructor(data?: IPp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.nuvarandePlaceringsval = [];
            this.kapital = [];
            this.preliminaraBelopp = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nuvarandePlaceringsval"])) {
                this.nuvarandePlaceringsval = [] as any;
                for (let item of _data["nuvarandePlaceringsval"])
                    this.nuvarandePlaceringsval!.push(NuvarandePlaceringsval.fromJS(item));
            }
            else {
                this.nuvarandePlaceringsval = null as any;
            }
            if (Array.isArray(_data["kapital"])) {
                this.kapital = [] as any;
                for (let item of _data["kapital"])
                    this.kapital!.push(TjanstepensionKapital.fromJS(item));
            }
            else {
                this.kapital = null as any;
            }
            if (Array.isArray(_data["preliminaraBelopp"])) {
                this.preliminaraBelopp = [] as any;
                for (let item of _data["preliminaraBelopp"])
                    this.preliminaraBelopp!.push(PreliminartBelopp.fromJS(item));
            }
            else {
                this.preliminaraBelopp = null as any;
            }
        }
    }

    static fromJS(data: any): Pp {
        data = typeof data === 'object' ? data : {};
        let result = new Pp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nuvarandePlaceringsval)) {
            data["nuvarandePlaceringsval"] = [];
            for (let item of this.nuvarandePlaceringsval)
                data["nuvarandePlaceringsval"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.kapital)) {
            data["kapital"] = [];
            for (let item of this.kapital)
                data["kapital"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.preliminaraBelopp)) {
            data["preliminaraBelopp"] = [];
            for (let item of this.preliminaraBelopp)
                data["preliminaraBelopp"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPp {
    nuvarandePlaceringsval: NuvarandePlaceringsval[];
    kapital: TjanstepensionKapital[];
    preliminaraBelopp: PreliminartBelopp[];
}

export class PreliminartBelopp implements IPreliminartBelopp {
    title!: string;
    beloppPerManad?: number | null;

    constructor(data?: IPreliminartBelopp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.beloppPerManad = _data["beloppPerManad"] !== undefined ? _data["beloppPerManad"] : null as any;
        }
    }

    static fromJS(data: any): PreliminartBelopp {
        data = typeof data === 'object' ? data : {};
        let result = new PreliminartBelopp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["beloppPerManad"] = this.beloppPerManad !== undefined ? this.beloppPerManad : null as any;
        return data;
    }
}

export interface IPreliminartBelopp {
    title: string;
    beloppPerManad?: number | null;
}

export class TjanstepensionKapital implements ITjanstepensionKapital {
    forsakringsbolagNamn!: string;
    subtext!: string;
    belopp?: number | null;

    constructor(data?: ITjanstepensionKapital) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakringsbolagNamn = _data["forsakringsbolagNamn"] !== undefined ? _data["forsakringsbolagNamn"] : null as any;
            this.subtext = _data["subtext"] !== undefined ? _data["subtext"] : null as any;
            this.belopp = _data["belopp"] !== undefined ? _data["belopp"] : null as any;
        }
    }

    static fromJS(data: any): TjanstepensionKapital {
        data = typeof data === 'object' ? data : {};
        let result = new TjanstepensionKapital();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakringsbolagNamn"] = this.forsakringsbolagNamn !== undefined ? this.forsakringsbolagNamn : null as any;
        data["subtext"] = this.subtext !== undefined ? this.subtext : null as any;
        data["belopp"] = this.belopp !== undefined ? this.belopp : null as any;
        return data;
    }
}

export interface ITjanstepensionKapital {
    forsakringsbolagNamn: string;
    subtext: string;
    belopp?: number | null;
}

export class Uitpk implements IUitpk {
    preliminaraBelopp!: PreliminartBelopp[];

    constructor(data?: IUitpk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.preliminaraBelopp = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["preliminaraBelopp"])) {
                this.preliminaraBelopp = [] as any;
                for (let item of _data["preliminaraBelopp"])
                    this.preliminaraBelopp!.push(PreliminartBelopp.fromJS(item));
            }
            else {
                this.preliminaraBelopp = null as any;
            }
        }
    }

    static fromJS(data: any): Uitpk {
        data = typeof data === 'object' ? data : {};
        let result = new Uitpk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.preliminaraBelopp)) {
            data["preliminaraBelopp"] = [];
            for (let item of this.preliminaraBelopp)
                data["preliminaraBelopp"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUitpk {
    preliminaraBelopp: PreliminartBelopp[];
}

export class AnstallningPremier implements IAnstallningPremier {
    arbetsgivareId?: string | null;
    arbetsgivareNamn?: string | null;
    premier!: Premie[];

    constructor(data?: IAnstallningPremier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.premier = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arbetsgivareId = _data["arbetsgivareId"] !== undefined ? _data["arbetsgivareId"] : null as any;
            this.arbetsgivareNamn = _data["arbetsgivareNamn"] !== undefined ? _data["arbetsgivareNamn"] : null as any;
            if (Array.isArray(_data["premier"])) {
                this.premier = [] as any;
                for (let item of _data["premier"])
                    this.premier!.push(Premie.fromJS(item));
            }
            else {
                this.premier = null as any;
            }
        }
    }

    static fromJS(data: any): AnstallningPremier {
        data = typeof data === 'object' ? data : {};
        let result = new AnstallningPremier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arbetsgivareId"] = this.arbetsgivareId !== undefined ? this.arbetsgivareId : null as any;
        data["arbetsgivareNamn"] = this.arbetsgivareNamn !== undefined ? this.arbetsgivareNamn : null as any;
        if (Array.isArray(this.premier)) {
            data["premier"] = [];
            for (let item of this.premier)
                data["premier"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAnstallningPremier {
    arbetsgivareId?: string | null;
    arbetsgivareNamn?: string | null;
    premier: Premie[];
}

export class Premie implements IPremie {
    typKod?: PremieType | null;
    typNamn?: string | null;
    belopp?: number | null;
    transaktionsDatum?: string | null;

    constructor(data?: IPremie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typKod = _data["typKod"] !== undefined ? _data["typKod"] : null as any;
            this.typNamn = _data["typNamn"] !== undefined ? _data["typNamn"] : null as any;
            this.belopp = _data["belopp"] !== undefined ? _data["belopp"] : null as any;
            this.transaktionsDatum = _data["transaktionsDatum"] !== undefined ? _data["transaktionsDatum"] : null as any;
        }
    }

    static fromJS(data: any): Premie {
        data = typeof data === 'object' ? data : {};
        let result = new Premie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typKod"] = this.typKod !== undefined ? this.typKod : null as any;
        data["typNamn"] = this.typNamn !== undefined ? this.typNamn : null as any;
        data["belopp"] = this.belopp !== undefined ? this.belopp : null as any;
        data["transaktionsDatum"] = this.transaktionsDatum !== undefined ? this.transaktionsDatum : null as any;
        return data;
    }
}

export interface IPremie {
    typKod?: PremieType | null;
    typNamn?: string | null;
    belopp?: number | null;
    transaktionsDatum?: string | null;
}

export enum PremieType {
    Ord = "Ord",
    DpFlex = "DpFlex",
    Lonevx = "Lonevx",
    Kompl = "Kompl",
    Fril = "Fril",
    Trappa = "Trappa",
    AvstFp = "AvstFp",
    Lp = "Lp",
    Eg = "Eg",
    KostnFs = "KostnFs",
    Utl = "Utl",
    ErsTak = "ErsTak",
    Coav = "Coav",
    Kompens = "Kompens",
    Okand = "Okand",
}

export class Anstalld implements IAnstalld {
    individId?: string | null;
    personnummer?: string | null;
    fornamn?: string | null;
    tilltalsnamn?: string | null;
    mellannamn?: string | null;
    efternamn?: string | null;
    pensionsplan?: string | null;
    anmaldArslon?: number | null;
    anmaldLon?: number | null;

    constructor(data?: IAnstalld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            this.personnummer = _data["personnummer"] !== undefined ? _data["personnummer"] : null as any;
            this.fornamn = _data["fornamn"] !== undefined ? _data["fornamn"] : null as any;
            this.tilltalsnamn = _data["tilltalsnamn"] !== undefined ? _data["tilltalsnamn"] : null as any;
            this.mellannamn = _data["mellannamn"] !== undefined ? _data["mellannamn"] : null as any;
            this.efternamn = _data["efternamn"] !== undefined ? _data["efternamn"] : null as any;
            this.pensionsplan = _data["pensionsplan"] !== undefined ? _data["pensionsplan"] : null as any;
            this.anmaldArslon = _data["anmaldArslon"] !== undefined ? _data["anmaldArslon"] : null as any;
            this.anmaldLon = _data["anmaldLon"] !== undefined ? _data["anmaldLon"] : null as any;
        }
    }

    static fromJS(data: any): Anstalld {
        data = typeof data === 'object' ? data : {};
        let result = new Anstalld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        data["personnummer"] = this.personnummer !== undefined ? this.personnummer : null as any;
        data["fornamn"] = this.fornamn !== undefined ? this.fornamn : null as any;
        data["tilltalsnamn"] = this.tilltalsnamn !== undefined ? this.tilltalsnamn : null as any;
        data["mellannamn"] = this.mellannamn !== undefined ? this.mellannamn : null as any;
        data["efternamn"] = this.efternamn !== undefined ? this.efternamn : null as any;
        data["pensionsplan"] = this.pensionsplan !== undefined ? this.pensionsplan : null as any;
        data["anmaldArslon"] = this.anmaldArslon !== undefined ? this.anmaldArslon : null as any;
        data["anmaldLon"] = this.anmaldLon !== undefined ? this.anmaldLon : null as any;
        return data;
    }
}

export interface IAnstalld {
    individId?: string | null;
    personnummer?: string | null;
    fornamn?: string | null;
    tilltalsnamn?: string | null;
    mellannamn?: string | null;
    efternamn?: string | null;
    pensionsplan?: string | null;
    anmaldArslon?: number | null;
    anmaldLon?: number | null;
}

export enum AnstalldOrderByColumnType {
    None = "None",
    Personnummer = "Personnummer",
    Namn = "Namn",
    Pensionsplan = "Pensionsplan",
}

export class AnstalldaAtArbetsgivareResponse implements IAnstalldaAtArbetsgivareResponse {
    arbetsgivareId!: string;
    totalCount!: number;
    anstallda!: Anstalld[];

    constructor(data?: IAnstalldaAtArbetsgivareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.anstallda = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arbetsgivareId = _data["arbetsgivareId"] !== undefined ? _data["arbetsgivareId"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["anstallda"])) {
                this.anstallda = [] as any;
                for (let item of _data["anstallda"])
                    this.anstallda!.push(Anstalld.fromJS(item));
            }
            else {
                this.anstallda = null as any;
            }
        }
    }

    static fromJS(data: any): AnstalldaAtArbetsgivareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnstalldaAtArbetsgivareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arbetsgivareId"] = this.arbetsgivareId !== undefined ? this.arbetsgivareId : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.anstallda)) {
            data["anstallda"] = [];
            for (let item of this.anstallda)
                data["anstallda"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAnstalldaAtArbetsgivareResponse {
    arbetsgivareId: string;
    totalCount: number;
    anstallda: Anstalld[];
}

export enum AnstalldaFilterKategoriType {
    Tjansteman = "Tjansteman",
    AlternativPensionslosning = "AlternativPensionslosning",
    PremiebefriadeItp2 = "PremiebefriadeItp2",
    Utlandsanstallda = "Utlandsanstallda",
    UndantagnaFranItp = "UndantagnaFranItp",
    Nyanmalda = "Nyanmalda",
    Avanmalda = "Avanmalda",
}

export class AvtalResponse implements IAvtalResponse {
    pensionsplaner!: Pensionsplan[];
    forsakringsavtal!: Forsakringsavtal[];
    kompletterandePremier!: KompletterandePremie[];

    constructor(data?: IAvtalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.pensionsplaner = [];
            this.forsakringsavtal = [];
            this.kompletterandePremier = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pensionsplaner"])) {
                this.pensionsplaner = [] as any;
                for (let item of _data["pensionsplaner"])
                    this.pensionsplaner!.push(Pensionsplan.fromJS(item));
            }
            else {
                this.pensionsplaner = null as any;
            }
            if (Array.isArray(_data["forsakringsavtal"])) {
                this.forsakringsavtal = [] as any;
                for (let item of _data["forsakringsavtal"])
                    this.forsakringsavtal!.push(Forsakringsavtal.fromJS(item));
            }
            else {
                this.forsakringsavtal = null as any;
            }
            if (Array.isArray(_data["kompletterandePremier"])) {
                this.kompletterandePremier = [] as any;
                for (let item of _data["kompletterandePremier"])
                    this.kompletterandePremier!.push(KompletterandePremie.fromJS(item));
            }
            else {
                this.kompletterandePremier = null as any;
            }
        }
    }

    static fromJS(data: any): AvtalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvtalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pensionsplaner)) {
            data["pensionsplaner"] = [];
            for (let item of this.pensionsplaner)
                data["pensionsplaner"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.forsakringsavtal)) {
            data["forsakringsavtal"] = [];
            for (let item of this.forsakringsavtal)
                data["forsakringsavtal"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.kompletterandePremier)) {
            data["kompletterandePremier"] = [];
            for (let item of this.kompletterandePremier)
                data["kompletterandePremier"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAvtalResponse {
    pensionsplaner: Pensionsplan[];
    forsakringsavtal: Forsakringsavtal[];
    kompletterandePremier: KompletterandePremie[];
}

export class Forsakringsavtal implements IForsakringsavtal {
    avtalstypNamn!: string;
    tecknatGenom!: string;
    giltigFrom?: Date | null;
    giltigTom?: Date | null;

    constructor(data?: IForsakringsavtal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avtalstypNamn = _data["avtalstypNamn"] !== undefined ? _data["avtalstypNamn"] : null as any;
            this.tecknatGenom = _data["tecknatGenom"] !== undefined ? _data["tecknatGenom"] : null as any;
            this.giltigFrom = _data["giltigFrom"] ? new Date(_data["giltigFrom"].toString()) : null as any;
            this.giltigTom = _data["giltigTom"] ? new Date(_data["giltigTom"].toString()) : null as any;
        }
    }

    static fromJS(data: any): Forsakringsavtal {
        data = typeof data === 'object' ? data : {};
        let result = new Forsakringsavtal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avtalstypNamn"] = this.avtalstypNamn !== undefined ? this.avtalstypNamn : null as any;
        data["tecknatGenom"] = this.tecknatGenom !== undefined ? this.tecknatGenom : null as any;
        data["giltigFrom"] = this.giltigFrom ? this.giltigFrom.toISOString() : null as any;
        data["giltigTom"] = this.giltigTom ? this.giltigTom.toISOString() : null as any;
        return data;
    }
}

export interface IForsakringsavtal {
    avtalstypNamn: string;
    tecknatGenom: string;
    giltigFrom?: Date | null;
    giltigTom?: Date | null;
}

export class KompletterandePremie implements IKompletterandePremie {
    namn!: string;
    giltigFrom?: Date | null;
    giltigTom?: Date | null;
    planNamn!: string;

    constructor(data?: IKompletterandePremie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namn = _data["namn"] !== undefined ? _data["namn"] : null as any;
            this.giltigFrom = _data["giltigFrom"] ? new Date(_data["giltigFrom"].toString()) : null as any;
            this.giltigTom = _data["giltigTom"] ? new Date(_data["giltigTom"].toString()) : null as any;
            this.planNamn = _data["planNamn"] !== undefined ? _data["planNamn"] : null as any;
        }
    }

    static fromJS(data: any): KompletterandePremie {
        data = typeof data === 'object' ? data : {};
        let result = new KompletterandePremie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namn"] = this.namn !== undefined ? this.namn : null as any;
        data["giltigFrom"] = this.giltigFrom ? this.giltigFrom.toISOString() : null as any;
        data["giltigTom"] = this.giltigTom ? this.giltigTom.toISOString() : null as any;
        data["planNamn"] = this.planNamn !== undefined ? this.planNamn : null as any;
        return data;
    }
}

export interface IKompletterandePremie {
    namn: string;
    giltigFrom?: Date | null;
    giltigTom?: Date | null;
    planNamn: string;
}

export class Pensionsplan implements IPensionsplan {
    namn!: string;
    giltigFrom?: Date | null;
    giltigTom?: Date | null;
    pensionsalder!: number;

    constructor(data?: IPensionsplan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namn = _data["namn"] !== undefined ? _data["namn"] : null as any;
            this.giltigFrom = _data["giltigFrom"] ? new Date(_data["giltigFrom"].toString()) : null as any;
            this.giltigTom = _data["giltigTom"] ? new Date(_data["giltigTom"].toString()) : null as any;
            this.pensionsalder = _data["pensionsalder"] !== undefined ? _data["pensionsalder"] : null as any;
        }
    }

    static fromJS(data: any): Pensionsplan {
        data = typeof data === 'object' ? data : {};
        let result = new Pensionsplan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namn"] = this.namn !== undefined ? this.namn : null as any;
        data["giltigFrom"] = this.giltigFrom ? this.giltigFrom.toISOString() : null as any;
        data["giltigTom"] = this.giltigTom ? this.giltigTom.toISOString() : null as any;
        data["pensionsalder"] = this.pensionsalder !== undefined ? this.pensionsalder : null as any;
        return data;
    }
}

export interface IPensionsplan {
    namn: string;
    giltigFrom?: Date | null;
    giltigTom?: Date | null;
    pensionsalder: number;
}

export class MinaForetag implements IMinaForetag {
    namn!: string;
    organisationsnummer!: string;
    giltigFrom!: Date;

    constructor(data?: IMinaForetag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namn = _data["namn"] !== undefined ? _data["namn"] : null as any;
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.giltigFrom = _data["giltigFrom"] ? new Date(_data["giltigFrom"].toString()) : null as any;
        }
    }

    static fromJS(data: any): MinaForetag {
        data = typeof data === 'object' ? data : {};
        let result = new MinaForetag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namn"] = this.namn !== undefined ? this.namn : null as any;
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["giltigFrom"] = this.giltigFrom ? this.giltigFrom.toISOString() : null as any;
        return data;
    }
}

export interface IMinaForetag {
    namn: string;
    organisationsnummer: string;
    giltigFrom: Date;
}

export class NyckeltalForArbetsgivareResponse implements INyckeltalForArbetsgivareResponse {
    anmaldaCollectum?: number | null;
    itp1?: number | null;
    itp2?: number | null;
    pensioneringsavtal?: string | null;
    priModellenAnvands?: boolean | null;
    sjukanmalda?: number | null;
    alternativPensionslosning?: number | null;
    premiebefriadeInomItp2?: number | null;
    utlandsanstallda?: number | null;
    undantagnaFranItp?: number | null;
    nyanmalda?: number | null;
    avanmalda?: number | null;

    constructor(data?: INyckeltalForArbetsgivareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anmaldaCollectum = _data["anmaldaCollectum"] !== undefined ? _data["anmaldaCollectum"] : null as any;
            this.itp1 = _data["itp1"] !== undefined ? _data["itp1"] : null as any;
            this.itp2 = _data["itp2"] !== undefined ? _data["itp2"] : null as any;
            this.pensioneringsavtal = _data["pensioneringsavtal"] !== undefined ? _data["pensioneringsavtal"] : null as any;
            this.priModellenAnvands = _data["priModellenAnvands"] !== undefined ? _data["priModellenAnvands"] : null as any;
            this.sjukanmalda = _data["sjukanmalda"] !== undefined ? _data["sjukanmalda"] : null as any;
            this.alternativPensionslosning = _data["alternativPensionslosning"] !== undefined ? _data["alternativPensionslosning"] : null as any;
            this.premiebefriadeInomItp2 = _data["premiebefriadeInomItp2"] !== undefined ? _data["premiebefriadeInomItp2"] : null as any;
            this.utlandsanstallda = _data["utlandsanstallda"] !== undefined ? _data["utlandsanstallda"] : null as any;
            this.undantagnaFranItp = _data["undantagnaFranItp"] !== undefined ? _data["undantagnaFranItp"] : null as any;
            this.nyanmalda = _data["nyanmalda"] !== undefined ? _data["nyanmalda"] : null as any;
            this.avanmalda = _data["avanmalda"] !== undefined ? _data["avanmalda"] : null as any;
        }
    }

    static fromJS(data: any): NyckeltalForArbetsgivareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NyckeltalForArbetsgivareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anmaldaCollectum"] = this.anmaldaCollectum !== undefined ? this.anmaldaCollectum : null as any;
        data["itp1"] = this.itp1 !== undefined ? this.itp1 : null as any;
        data["itp2"] = this.itp2 !== undefined ? this.itp2 : null as any;
        data["pensioneringsavtal"] = this.pensioneringsavtal !== undefined ? this.pensioneringsavtal : null as any;
        data["priModellenAnvands"] = this.priModellenAnvands !== undefined ? this.priModellenAnvands : null as any;
        data["sjukanmalda"] = this.sjukanmalda !== undefined ? this.sjukanmalda : null as any;
        data["alternativPensionslosning"] = this.alternativPensionslosning !== undefined ? this.alternativPensionslosning : null as any;
        data["premiebefriadeInomItp2"] = this.premiebefriadeInomItp2 !== undefined ? this.premiebefriadeInomItp2 : null as any;
        data["utlandsanstallda"] = this.utlandsanstallda !== undefined ? this.utlandsanstallda : null as any;
        data["undantagnaFranItp"] = this.undantagnaFranItp !== undefined ? this.undantagnaFranItp : null as any;
        data["nyanmalda"] = this.nyanmalda !== undefined ? this.nyanmalda : null as any;
        data["avanmalda"] = this.avanmalda !== undefined ? this.avanmalda : null as any;
        return data;
    }
}

export interface INyckeltalForArbetsgivareResponse {
    anmaldaCollectum?: number | null;
    itp1?: number | null;
    itp2?: number | null;
    pensioneringsavtal?: string | null;
    priModellenAnvands?: boolean | null;
    sjukanmalda?: number | null;
    alternativPensionslosning?: number | null;
    premiebefriadeInomItp2?: number | null;
    utlandsanstallda?: number | null;
    undantagnaFranItp?: number | null;
    nyanmalda?: number | null;
    avanmalda?: number | null;
}

export class Anstalldarende implements IAnstalldarende {
    id!: number;
    groupId?: number | null;
    kanal!: KanalType;
    isOpen!: boolean;
    rubrik!: string;
    createdAt!: Date;
    updatedAt?: Date | null;
    attachments!: SakertMeddelandeAttachment[];
    sakraMeddelanden!: SakertMeddelande[];
    internaKommentarer!: InternKommentar[];
    kundgrupp?: KundgruppType | null;
    kontaktorsakId?: string | null;
    fortydligadKontaktorsak?: string | null;
    samtalsamneIds?: string[] | null;
    arendetyp?: ArendeType | null;
    ombud!: boolean;
    overlamnadTill!: LamnaOverType;
    okopplat!: boolean;

    constructor(data?: IAnstalldarende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.attachments = [];
            this.sakraMeddelanden = [];
            this.internaKommentarer = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.kanal = _data["kanal"] !== undefined ? _data["kanal"] : null as any;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : null as any;
            this.rubrik = _data["rubrik"] !== undefined ? _data["rubrik"] : null as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : null as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(SakertMeddelandeAttachment.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
            if (Array.isArray(_data["sakraMeddelanden"])) {
                this.sakraMeddelanden = [] as any;
                for (let item of _data["sakraMeddelanden"])
                    this.sakraMeddelanden!.push(SakertMeddelande.fromJS(item));
            }
            else {
                this.sakraMeddelanden = null as any;
            }
            if (Array.isArray(_data["internaKommentarer"])) {
                this.internaKommentarer = [] as any;
                for (let item of _data["internaKommentarer"])
                    this.internaKommentarer!.push(InternKommentar.fromJS(item));
            }
            else {
                this.internaKommentarer = null as any;
            }
            this.kundgrupp = _data["kundgrupp"] !== undefined ? _data["kundgrupp"] : null as any;
            this.kontaktorsakId = _data["kontaktorsakId"] !== undefined ? _data["kontaktorsakId"] : null as any;
            this.fortydligadKontaktorsak = _data["fortydligadKontaktorsak"] !== undefined ? _data["fortydligadKontaktorsak"] : null as any;
            if (Array.isArray(_data["samtalsamneIds"])) {
                this.samtalsamneIds = [] as any;
                for (let item of _data["samtalsamneIds"])
                    this.samtalsamneIds!.push(item);
            }
            else {
                this.samtalsamneIds = null as any;
            }
            this.arendetyp = _data["arendetyp"] !== undefined ? _data["arendetyp"] : null as any;
            this.ombud = _data["ombud"] !== undefined ? _data["ombud"] : null as any;
            this.overlamnadTill = _data["overlamnadTill"] !== undefined ? _data["overlamnadTill"] : null as any;
            this.okopplat = _data["okopplat"] !== undefined ? _data["okopplat"] : null as any;
        }
    }

    static fromJS(data: any): Anstalldarende {
        data = typeof data === 'object' ? data : {};
        let result = new Anstalldarende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["kanal"] = this.kanal !== undefined ? this.kanal : null as any;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : null as any;
        data["rubrik"] = this.rubrik !== undefined ? this.rubrik : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.sakraMeddelanden)) {
            data["sakraMeddelanden"] = [];
            for (let item of this.sakraMeddelanden)
                data["sakraMeddelanden"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.internaKommentarer)) {
            data["internaKommentarer"] = [];
            for (let item of this.internaKommentarer)
                data["internaKommentarer"].push(item ? item.toJSON() : null as any);
        }
        data["kundgrupp"] = this.kundgrupp !== undefined ? this.kundgrupp : null as any;
        data["kontaktorsakId"] = this.kontaktorsakId !== undefined ? this.kontaktorsakId : null as any;
        data["fortydligadKontaktorsak"] = this.fortydligadKontaktorsak !== undefined ? this.fortydligadKontaktorsak : null as any;
        if (Array.isArray(this.samtalsamneIds)) {
            data["samtalsamneIds"] = [];
            for (let item of this.samtalsamneIds)
                data["samtalsamneIds"].push(item);
        }
        data["arendetyp"] = this.arendetyp !== undefined ? this.arendetyp : null as any;
        data["ombud"] = this.ombud !== undefined ? this.ombud : null as any;
        data["overlamnadTill"] = this.overlamnadTill !== undefined ? this.overlamnadTill : null as any;
        data["okopplat"] = this.okopplat !== undefined ? this.okopplat : null as any;
        return data;
    }
}

export interface IAnstalldarende {
    id: number;
    groupId?: number | null;
    kanal: KanalType;
    isOpen: boolean;
    rubrik: string;
    createdAt: Date;
    updatedAt?: Date | null;
    attachments: SakertMeddelandeAttachment[];
    sakraMeddelanden: SakertMeddelande[];
    internaKommentarer: InternKommentar[];
    kundgrupp?: KundgruppType | null;
    kontaktorsakId?: string | null;
    fortydligadKontaktorsak?: string | null;
    samtalsamneIds?: string[] | null;
    arendetyp?: ArendeType | null;
    ombud: boolean;
    overlamnadTill: LamnaOverType;
    okopplat: boolean;
}

export class SimpleAnstalldarende implements ISimpleAnstalldarende {
    id!: number;
    rubrik!: string;
    groupId?: number | null;
    isOpen!: boolean;
    kundserviceId?: string | null;
    updatedAt?: Date | null;
    closedAt?: Date | null;
    createdAt!: Date;

    constructor(data?: ISimpleAnstalldarende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rubrik = _data["rubrik"] !== undefined ? _data["rubrik"] : null as any;
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : null as any;
            this.kundserviceId = _data["kundserviceId"] !== undefined ? _data["kundserviceId"] : null as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : null as any;
            this.closedAt = _data["closedAt"] ? new Date(_data["closedAt"].toString()) : null as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SimpleAnstalldarende {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleAnstalldarende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rubrik"] = this.rubrik !== undefined ? this.rubrik : null as any;
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : null as any;
        data["kundserviceId"] = this.kundserviceId !== undefined ? this.kundserviceId : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        data["closedAt"] = this.closedAt ? this.closedAt.toISOString() : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        return data;
    }
}

export interface ISimpleAnstalldarende {
    id: number;
    rubrik: string;
    groupId?: number | null;
    isOpen: boolean;
    kundserviceId?: string | null;
    updatedAt?: Date | null;
    closedAt?: Date | null;
    createdAt: Date;
}

export class Arbetsgivarearende implements IArbetsgivarearende {
    id!: string;
    foretagDynamicsId!: string;
    kanal?: KanalType | null;
    isOpen!: boolean;
    rubrik!: string;
    createdAt!: Date;
    updatedAt?: Date | null;
    kundgrupp?: KundgruppType | null;
    kundserviceId?: string | null;
    kontaktorsakId?: string | null;
    fortydligadKontaktorsak?: string | null;
    samtalsamneIds?: string[] | null;
    ombud!: boolean;
    overlamnadTill!: LamnaOverType;
    internaKommentarer!: InternKommentar[];
    namn?: string | null;
    email?: string | null;
    telefonnummer?: string | null;
    okopplat!: boolean;

    constructor(data?: IArbetsgivarearende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.internaKommentarer = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.foretagDynamicsId = _data["foretagDynamicsId"] !== undefined ? _data["foretagDynamicsId"] : null as any;
            this.kanal = _data["kanal"] !== undefined ? _data["kanal"] : null as any;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : null as any;
            this.rubrik = _data["rubrik"] !== undefined ? _data["rubrik"] : null as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : null as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : null as any;
            this.kundgrupp = _data["kundgrupp"] !== undefined ? _data["kundgrupp"] : null as any;
            this.kundserviceId = _data["kundserviceId"] !== undefined ? _data["kundserviceId"] : null as any;
            this.kontaktorsakId = _data["kontaktorsakId"] !== undefined ? _data["kontaktorsakId"] : null as any;
            this.fortydligadKontaktorsak = _data["fortydligadKontaktorsak"] !== undefined ? _data["fortydligadKontaktorsak"] : null as any;
            if (Array.isArray(_data["samtalsamneIds"])) {
                this.samtalsamneIds = [] as any;
                for (let item of _data["samtalsamneIds"])
                    this.samtalsamneIds!.push(item);
            }
            else {
                this.samtalsamneIds = null as any;
            }
            this.ombud = _data["ombud"] !== undefined ? _data["ombud"] : null as any;
            this.overlamnadTill = _data["overlamnadTill"] !== undefined ? _data["overlamnadTill"] : null as any;
            if (Array.isArray(_data["internaKommentarer"])) {
                this.internaKommentarer = [] as any;
                for (let item of _data["internaKommentarer"])
                    this.internaKommentarer!.push(InternKommentar.fromJS(item));
            }
            else {
                this.internaKommentarer = null as any;
            }
            this.namn = _data["namn"] !== undefined ? _data["namn"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.telefonnummer = _data["telefonnummer"] !== undefined ? _data["telefonnummer"] : null as any;
            this.okopplat = _data["okopplat"] !== undefined ? _data["okopplat"] : null as any;
        }
    }

    static fromJS(data: any): Arbetsgivarearende {
        data = typeof data === 'object' ? data : {};
        let result = new Arbetsgivarearende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["foretagDynamicsId"] = this.foretagDynamicsId !== undefined ? this.foretagDynamicsId : null as any;
        data["kanal"] = this.kanal !== undefined ? this.kanal : null as any;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : null as any;
        data["rubrik"] = this.rubrik !== undefined ? this.rubrik : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        data["kundgrupp"] = this.kundgrupp !== undefined ? this.kundgrupp : null as any;
        data["kundserviceId"] = this.kundserviceId !== undefined ? this.kundserviceId : null as any;
        data["kontaktorsakId"] = this.kontaktorsakId !== undefined ? this.kontaktorsakId : null as any;
        data["fortydligadKontaktorsak"] = this.fortydligadKontaktorsak !== undefined ? this.fortydligadKontaktorsak : null as any;
        if (Array.isArray(this.samtalsamneIds)) {
            data["samtalsamneIds"] = [];
            for (let item of this.samtalsamneIds)
                data["samtalsamneIds"].push(item);
        }
        data["ombud"] = this.ombud !== undefined ? this.ombud : null as any;
        data["overlamnadTill"] = this.overlamnadTill !== undefined ? this.overlamnadTill : null as any;
        if (Array.isArray(this.internaKommentarer)) {
            data["internaKommentarer"] = [];
            for (let item of this.internaKommentarer)
                data["internaKommentarer"].push(item ? item.toJSON() : null as any);
        }
        data["namn"] = this.namn !== undefined ? this.namn : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["telefonnummer"] = this.telefonnummer !== undefined ? this.telefonnummer : null as any;
        data["okopplat"] = this.okopplat !== undefined ? this.okopplat : null as any;
        return data;
    }
}

export interface IArbetsgivarearende {
    id: string;
    foretagDynamicsId: string;
    kanal?: KanalType | null;
    isOpen: boolean;
    rubrik: string;
    createdAt: Date;
    updatedAt?: Date | null;
    kundgrupp?: KundgruppType | null;
    kundserviceId?: string | null;
    kontaktorsakId?: string | null;
    fortydligadKontaktorsak?: string | null;
    samtalsamneIds?: string[] | null;
    ombud: boolean;
    overlamnadTill: LamnaOverType;
    internaKommentarer: InternKommentar[];
    namn?: string | null;
    email?: string | null;
    telefonnummer?: string | null;
    okopplat: boolean;
}

export class SimpleArbetsgivarearende implements ISimpleArbetsgivarearende {
    id!: string;
    dynamicsId!: string;
    rubrik?: string | null;
    isOpen!: boolean;
    kundserviceId?: string | null;
    updatedAt?: Date | null;
    createdAt!: Date;

    constructor(data?: ISimpleArbetsgivarearende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dynamicsId = _data["dynamicsId"] !== undefined ? _data["dynamicsId"] : null as any;
            this.rubrik = _data["rubrik"] !== undefined ? _data["rubrik"] : null as any;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : null as any;
            this.kundserviceId = _data["kundserviceId"] !== undefined ? _data["kundserviceId"] : null as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : null as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SimpleArbetsgivarearende {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleArbetsgivarearende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dynamicsId"] = this.dynamicsId !== undefined ? this.dynamicsId : null as any;
        data["rubrik"] = this.rubrik !== undefined ? this.rubrik : null as any;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : null as any;
        data["kundserviceId"] = this.kundserviceId !== undefined ? this.kundserviceId : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        return data;
    }
}

export interface ISimpleArbetsgivarearende {
    id: string;
    dynamicsId: string;
    rubrik?: string | null;
    isOpen: boolean;
    kundserviceId?: string | null;
    updatedAt?: Date | null;
    createdAt: Date;
}

export class ArendenByMedarbetareRequest implements IArendenByMedarbetareRequest {
    top?: number | null;
    open!: boolean;
    nextLink?: string | null;

    constructor(data?: IArendenByMedarbetareRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.top = _data["top"] !== undefined ? _data["top"] : null as any;
            this.open = _data["open"] !== undefined ? _data["open"] : null as any;
            this.nextLink = _data["nextLink"] !== undefined ? _data["nextLink"] : null as any;
        }
    }

    static fromJS(data: any): ArendenByMedarbetareRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArendenByMedarbetareRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["top"] = this.top !== undefined ? this.top : null as any;
        data["open"] = this.open !== undefined ? this.open : null as any;
        data["nextLink"] = this.nextLink !== undefined ? this.nextLink : null as any;
        return data;
    }
}

export interface IArendenByMedarbetareRequest {
    top?: number | null;
    open: boolean;
    nextLink?: string | null;
}

export class ArendenByOrganisationsnummerRequest implements IArendenByOrganisationsnummerRequest {
    organisationsnummer!: string | null;
    top?: number | null;
    nextLink?: string | null;
    open!: boolean;

    constructor(data?: IArendenByOrganisationsnummerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.top = _data["top"] !== undefined ? _data["top"] : null as any;
            this.nextLink = _data["nextLink"] !== undefined ? _data["nextLink"] : null as any;
            this.open = _data["open"] !== undefined ? _data["open"] : null as any;
        }
    }

    static fromJS(data: any): ArendenByOrganisationsnummerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArendenByOrganisationsnummerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["top"] = this.top !== undefined ? this.top : null as any;
        data["nextLink"] = this.nextLink !== undefined ? this.nextLink : null as any;
        data["open"] = this.open !== undefined ? this.open : null as any;
        return data;
    }
}

export interface IArendenByOrganisationsnummerRequest {
    organisationsnummer: string | null;
    top?: number | null;
    nextLink?: string | null;
    open: boolean;
}

export class AuthenticateIndividRequest implements IAuthenticateIndividRequest {
    personalIdentityNumber!: string;
    incoming!: boolean;

    constructor(data?: IAuthenticateIndividRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalIdentityNumber = _data["personalIdentityNumber"] !== undefined ? _data["personalIdentityNumber"] : null as any;
            this.incoming = _data["incoming"] !== undefined ? _data["incoming"] : null as any;
        }
    }

    static fromJS(data: any): AuthenticateIndividRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateIndividRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalIdentityNumber"] = this.personalIdentityNumber !== undefined ? this.personalIdentityNumber : null as any;
        data["incoming"] = this.incoming !== undefined ? this.incoming : null as any;
        return data;
    }
}

export interface IAuthenticateIndividRequest {
    personalIdentityNumber: string;
    incoming: boolean;
}

export class AuthenticateResponse implements IAuthenticateResponse {
    sessionId?: string | null;
    qrCode?: string | null;
    autoStartToken?: string | null;
    /** If already initiated, then a redirecturl is provided. */
    redirectUrl?: string | null;

    constructor(data?: IAuthenticateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"] !== undefined ? _data["sessionId"] : null as any;
            this.qrCode = _data["qrCode"] !== undefined ? _data["qrCode"] : null as any;
            this.autoStartToken = _data["autoStartToken"] !== undefined ? _data["autoStartToken"] : null as any;
            this.redirectUrl = _data["redirectUrl"] !== undefined ? _data["redirectUrl"] : null as any;
        }
    }

    static fromJS(data: any): AuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId !== undefined ? this.sessionId : null as any;
        data["qrCode"] = this.qrCode !== undefined ? this.qrCode : null as any;
        data["autoStartToken"] = this.autoStartToken !== undefined ? this.autoStartToken : null as any;
        data["redirectUrl"] = this.redirectUrl !== undefined ? this.redirectUrl : null as any;
        return data;
    }
}

export interface IAuthenticateResponse {
    sessionId?: string | null;
    qrCode?: string | null;
    autoStartToken?: string | null;
    /** If already initiated, then a redirecturl is provided. */
    redirectUrl?: string | null;
}

export class SessionLoggedOutResponse implements ISessionLoggedOutResponse {
    sessiondeleted?: string | null;
    bankIdCancel?: string | null;

    constructor(data?: ISessionLoggedOutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessiondeleted = _data["sessiondeleted"] !== undefined ? _data["sessiondeleted"] : null as any;
            this.bankIdCancel = _data["bankIdCancel"] !== undefined ? _data["bankIdCancel"] : null as any;
        }
    }

    static fromJS(data: any): SessionLoggedOutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLoggedOutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessiondeleted"] = this.sessiondeleted !== undefined ? this.sessiondeleted : null as any;
        data["bankIdCancel"] = this.bankIdCancel !== undefined ? this.bankIdCancel : null as any;
        return data;
    }
}

export interface ISessionLoggedOutResponse {
    sessiondeleted?: string | null;
    bankIdCancel?: string | null;
}

export class PendingStatus implements IPendingStatus {
    code?: string | null;
    qrCode?: string | null;
    autoStartToken?: string | null;
    hintCode?: string | null;

    constructor(data?: IPendingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.qrCode = _data["qrCode"] !== undefined ? _data["qrCode"] : null as any;
            this.autoStartToken = _data["autoStartToken"] !== undefined ? _data["autoStartToken"] : null as any;
            this.hintCode = _data["hintCode"] !== undefined ? _data["hintCode"] : null as any;
        }
    }

    static fromJS(data: any): PendingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PendingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["qrCode"] = this.qrCode !== undefined ? this.qrCode : null as any;
        data["autoStartToken"] = this.autoStartToken !== undefined ? this.autoStartToken : null as any;
        data["hintCode"] = this.hintCode !== undefined ? this.hintCode : null as any;
        return data;
    }
}

export interface IPendingStatus {
    code?: string | null;
    qrCode?: string | null;
    autoStartToken?: string | null;
    hintCode?: string | null;
}

export class SessionStatusResponse implements ISessionStatusResponse {
    sessionId?: string | null;
    status?: SessionStatusType;
    sessionUser?: SessionUser | null;
    pendingStatus?: PendingStatus | null;

    constructor(data?: ISessionStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"] !== undefined ? _data["sessionId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.sessionUser = _data["sessionUser"] ? SessionUser.fromJS(_data["sessionUser"]) : null as any;
            this.pendingStatus = _data["pendingStatus"] ? PendingStatus.fromJS(_data["pendingStatus"]) : null as any;
        }
    }

    static fromJS(data: any): SessionStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SessionStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId !== undefined ? this.sessionId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["sessionUser"] = this.sessionUser ? this.sessionUser.toJSON() : null as any;
        data["pendingStatus"] = this.pendingStatus ? this.pendingStatus.toJSON() : null as any;
        return data;
    }
}

export interface ISessionStatusResponse {
    sessionId?: string | null;
    status?: SessionStatusType;
    sessionUser?: SessionUser | null;
    pendingStatus?: PendingStatus | null;
}

export enum SessionStatusType {
    NonExisting = "NonExisting",
    Pending = "Pending",
    Authenticated = "Authenticated",
}

export class SessionUser implements ISessionUser {
    username?: string | null;
    personalNumber?: string | null;
    name?: string | null;
    givenName?: string | null;
    surname?: string | null;
    ipAddress?: string | null;
    notBefore?: string | null;
    notAfter?: string | null;
    signature?: string | null;
    ocspResponse?: string | null;

    constructor(data?: ISessionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.personalNumber = _data["personalNumber"] !== undefined ? _data["personalNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.givenName = _data["givenName"] !== undefined ? _data["givenName"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.ipAddress = _data["ipAddress"] !== undefined ? _data["ipAddress"] : null as any;
            this.notBefore = _data["notBefore"] !== undefined ? _data["notBefore"] : null as any;
            this.notAfter = _data["notAfter"] !== undefined ? _data["notAfter"] : null as any;
            this.signature = _data["signature"] !== undefined ? _data["signature"] : null as any;
            this.ocspResponse = _data["ocspResponse"] !== undefined ? _data["ocspResponse"] : null as any;
        }
    }

    static fromJS(data: any): SessionUser {
        data = typeof data === 'object' ? data : {};
        let result = new SessionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["personalNumber"] = this.personalNumber !== undefined ? this.personalNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["givenName"] = this.givenName !== undefined ? this.givenName : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : null as any;
        data["notBefore"] = this.notBefore !== undefined ? this.notBefore : null as any;
        data["notAfter"] = this.notAfter !== undefined ? this.notAfter : null as any;
        data["signature"] = this.signature !== undefined ? this.signature : null as any;
        data["ocspResponse"] = this.ocspResponse !== undefined ? this.ocspResponse : null as any;
        return data;
    }
}

export interface ISessionUser {
    username?: string | null;
    personalNumber?: string | null;
    name?: string | null;
    givenName?: string | null;
    surname?: string | null;
    ipAddress?: string | null;
    notBefore?: string | null;
    notAfter?: string | null;
    signature?: string | null;
    ocspResponse?: string | null;
}

export enum ArendeType {
    Vagledning = "Vagledning",
    Utredning = "Utredning",
    Handlaggning = "Handlaggning",
    Kundservicearende = "Kundservicearende",
}

export class InternKommentar implements IInternKommentar {
    id!: string;
    body!: string;
    createdAt!: Date;
    updatedAt!: Date;
    createdBy!: string;
    updatedBy!: string;
    verified!: boolean;
    manuallyVerified!: boolean;

    constructor(data?: IInternKommentar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : null as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
            this.verified = _data["verified"] !== undefined ? _data["verified"] : null as any;
            this.manuallyVerified = _data["manuallyVerified"] !== undefined ? _data["manuallyVerified"] : null as any;
        }
    }

    static fromJS(data: any): InternKommentar {
        data = typeof data === 'object' ? data : {};
        let result = new InternKommentar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        data["verified"] = this.verified !== undefined ? this.verified : null as any;
        data["manuallyVerified"] = this.manuallyVerified !== undefined ? this.manuallyVerified : null as any;
        return data;
    }
}

export interface IInternKommentar {
    id: string;
    body: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: string;
    updatedBy: string;
    verified: boolean;
    manuallyVerified: boolean;
}

export enum KanalType {
    Epost = "Epost",
    Telefon = "Telefon",
    Chat = "Chat",
    Kundservice = "Kundservice",
    Radgivningstjansten = "Radgivningstjansten",
    InloggadPaAvtalatSe = "InloggadPaAvtalatSe",
    Freshdesk = "Freshdesk",
    FysisktMote = "FysisktMote",
    DigitaltMote = "DigitaltMote",
}

export enum KundgruppType {
    Tjansteman = "Tjansteman",
    Arbetare = "Arbetare",
    Arbetsgivare = "Arbetsgivare",
    Arbetsgivarforbund = "Arbetsgivarforbund",
    Partsbolag = "Partsbolag",
    Forsakringsinformator = "Forsakringsinformator",
    Fackforbund = "Fackforbund",
    Ovrigt = "Ovrigt",
}

export enum LamnaOverType {
    Nej = "Nej",
    Kundservice = "Kundservice",
    Collectum = "Collectum",
    Radgivningstjansten = "Radgivningstjansten",
    SupportForInformatorer = "SupportForInformatorer",
    Webbgruppen = "Webbgruppen",
    Klagomal = "Klagomal",
    Legal = "Legal",
    Leveransadministration = "Leveransadministration",
    Fora = "Fora",
    Alecta = "Alecta",
    AfaForsakring = "AfaForsakring",
    CollectumForetag = "CollectumForetag",
}

export class PaginatedResult_1OfList_1OfArbetsgivarearende implements IPaginatedResult_1OfList_1OfArbetsgivarearende {
    value!: Arbetsgivarearende[];
    count?: number | null;
    nextLink?: string | null;

    constructor(data?: IPaginatedResult_1OfList_1OfArbetsgivarearende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Arbetsgivarearende.fromJS(item));
            }
            else {
                this.value = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.nextLink = _data["nextLink"] !== undefined ? _data["nextLink"] : null as any;
        }
    }

    static fromJS(data: any): PaginatedResult_1OfList_1OfArbetsgivarearende {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfList_1OfArbetsgivarearende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : null as any);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["nextLink"] = this.nextLink !== undefined ? this.nextLink : null as any;
        return data;
    }
}

export interface IPaginatedResult_1OfList_1OfArbetsgivarearende {
    value: Arbetsgivarearende[];
    count?: number | null;
    nextLink?: string | null;
}

export class PaginatedResult_1OfList_1OfSimpleArbetsgivarearende implements IPaginatedResult_1OfList_1OfSimpleArbetsgivarearende {
    value!: SimpleArbetsgivarearende[];
    count?: number | null;
    nextLink?: string | null;

    constructor(data?: IPaginatedResult_1OfList_1OfSimpleArbetsgivarearende) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.value = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(SimpleArbetsgivarearende.fromJS(item));
            }
            else {
                this.value = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.nextLink = _data["nextLink"] !== undefined ? _data["nextLink"] : null as any;
        }
    }

    static fromJS(data: any): PaginatedResult_1OfList_1OfSimpleArbetsgivarearende {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfList_1OfSimpleArbetsgivarearende();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : null as any);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["nextLink"] = this.nextLink !== undefined ? this.nextLink : null as any;
        return data;
    }
}

export interface IPaginatedResult_1OfList_1OfSimpleArbetsgivarearende {
    value: SimpleArbetsgivarearende[];
    count?: number | null;
    nextLink?: string | null;
}

export class SakertMeddelande implements ISakertMeddelande {
    id!: string;
    body!: string;
    createdAt!: Date;
    createdBy!: string;
    createdByCustomer!: boolean;
    attachments!: SakertMeddelandeAttachment[];

    constructor(data?: ISakertMeddelande) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.createdByCustomer = _data["createdByCustomer"] !== undefined ? _data["createdByCustomer"] : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(SakertMeddelandeAttachment.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
        }
    }

    static fromJS(data: any): SakertMeddelande {
        data = typeof data === 'object' ? data : {};
        let result = new SakertMeddelande();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdByCustomer"] = this.createdByCustomer !== undefined ? this.createdByCustomer : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISakertMeddelande {
    id: string;
    body: string;
    createdAt: Date;
    createdBy: string;
    createdByCustomer: boolean;
    attachments: SakertMeddelandeAttachment[];
}

export class SakertMeddelandeAttachment implements ISakertMeddelandeAttachment {
    name!: string;
    contentType!: string;
    size!: number;
    attachmentUrl!: string;

    constructor(data?: ISakertMeddelandeAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.attachmentUrl = _data["attachmentUrl"] !== undefined ? _data["attachmentUrl"] : null as any;
        }
    }

    static fromJS(data: any): SakertMeddelandeAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new SakertMeddelandeAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["attachmentUrl"] = this.attachmentUrl !== undefined ? this.attachmentUrl : null as any;
        return data;
    }
}

export interface ISakertMeddelandeAttachment {
    name: string;
    contentType: string;
    size: number;
    attachmentUrl: string;
}

export class Config implements IConfig {
    featureFlags!: FeatureFlag[];
    kontaktorsaker!: Kontaktorsak[];
    ovrigaSamtalsamnen!: Kontaktorsak[];

    constructor(data?: IConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.featureFlags = [];
            this.kontaktorsaker = [];
            this.ovrigaSamtalsamnen = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureFlags"])) {
                this.featureFlags = [] as any;
                for (let item of _data["featureFlags"])
                    this.featureFlags!.push(FeatureFlag.fromJS(item));
            }
            else {
                this.featureFlags = null as any;
            }
            if (Array.isArray(_data["kontaktorsaker"])) {
                this.kontaktorsaker = [] as any;
                for (let item of _data["kontaktorsaker"])
                    this.kontaktorsaker!.push(Kontaktorsak.fromJS(item));
            }
            else {
                this.kontaktorsaker = null as any;
            }
            if (Array.isArray(_data["ovrigaSamtalsamnen"])) {
                this.ovrigaSamtalsamnen = [] as any;
                for (let item of _data["ovrigaSamtalsamnen"])
                    this.ovrigaSamtalsamnen!.push(Kontaktorsak.fromJS(item));
            }
            else {
                this.ovrigaSamtalsamnen = null as any;
            }
        }
    }

    static fromJS(data: any): Config {
        data = typeof data === 'object' ? data : {};
        let result = new Config();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureFlags)) {
            data["featureFlags"] = [];
            for (let item of this.featureFlags)
                data["featureFlags"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.kontaktorsaker)) {
            data["kontaktorsaker"] = [];
            for (let item of this.kontaktorsaker)
                data["kontaktorsaker"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.ovrigaSamtalsamnen)) {
            data["ovrigaSamtalsamnen"] = [];
            for (let item of this.ovrigaSamtalsamnen)
                data["ovrigaSamtalsamnen"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IConfig {
    featureFlags: FeatureFlag[];
    kontaktorsaker: Kontaktorsak[];
    ovrigaSamtalsamnen: Kontaktorsak[];
}

export class FeatureFlag implements IFeatureFlag {
    name!: string;
    isEnabled!: boolean;

    constructor(data?: IFeatureFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : null as any;
        }
    }

    static fromJS(data: any): FeatureFlag {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        return data;
    }
}

export interface IFeatureFlag {
    name: string;
    isEnabled: boolean;
}

export class Kontaktorsak implements IKontaktorsak {
    id!: string;
    namn!: string;

    constructor(data?: IKontaktorsak) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.namn = _data["namn"] !== undefined ? _data["namn"] : null as any;
        }
    }

    static fromJS(data: any): Kontaktorsak {
        data = typeof data === 'object' ? data : {};
        let result = new Kontaktorsak();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["namn"] = this.namn !== undefined ? this.namn : null as any;
        return data;
    }
}

export interface IKontaktorsak {
    id: string;
    namn: string;
}

export class ForetagResponse implements IForetagResponse {
    id!: string;
    organisationsnummer!: string;
    namn!: string;
    crmUrl?: string | null;

    constructor(data?: IForetagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.namn = _data["namn"] !== undefined ? _data["namn"] : null as any;
            this.crmUrl = _data["crmUrl"] !== undefined ? _data["crmUrl"] : null as any;
        }
    }

    static fromJS(data: any): ForetagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForetagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["namn"] = this.namn !== undefined ? this.namn : null as any;
        data["crmUrl"] = this.crmUrl !== undefined ? this.crmUrl : null as any;
        return data;
    }
}

export interface IForetagResponse {
    id: string;
    organisationsnummer: string;
    namn: string;
    crmUrl?: string | null;
}

export class Individ implements IIndivid {
    id!: string;
    personnummer!: string;
    fornamn!: string;
    tilltalsnamn?: string | null;
    efternamn!: string;
    mellannamn!: string;
    skapadDateTime!: Date;
    uppdateradDateTime!: Date;
    verifieradDateTime!: Date;
    isAvliden!: boolean;
    hasSkyddadIdentitet!: boolean;
    isAvtalatAnstalld!: boolean;
    adress?: Adress | null;
    email?: string | null;
    telefonnummer?: string | null;

    constructor(data?: IIndivid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.personnummer = _data["personnummer"] !== undefined ? _data["personnummer"] : null as any;
            this.fornamn = _data["fornamn"] !== undefined ? _data["fornamn"] : null as any;
            this.tilltalsnamn = _data["tilltalsnamn"] !== undefined ? _data["tilltalsnamn"] : null as any;
            this.efternamn = _data["efternamn"] !== undefined ? _data["efternamn"] : null as any;
            this.mellannamn = _data["mellannamn"] !== undefined ? _data["mellannamn"] : null as any;
            this.skapadDateTime = _data["skapadDateTime"] ? new Date(_data["skapadDateTime"].toString()) : null as any;
            this.uppdateradDateTime = _data["uppdateradDateTime"] ? new Date(_data["uppdateradDateTime"].toString()) : null as any;
            this.verifieradDateTime = _data["verifieradDateTime"] ? new Date(_data["verifieradDateTime"].toString()) : null as any;
            this.isAvliden = _data["isAvliden"] !== undefined ? _data["isAvliden"] : null as any;
            this.hasSkyddadIdentitet = _data["hasSkyddadIdentitet"] !== undefined ? _data["hasSkyddadIdentitet"] : null as any;
            this.isAvtalatAnstalld = _data["isAvtalatAnstalld"] !== undefined ? _data["isAvtalatAnstalld"] : null as any;
            this.adress = _data["adress"] ? Adress.fromJS(_data["adress"]) : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.telefonnummer = _data["telefonnummer"] !== undefined ? _data["telefonnummer"] : null as any;
        }
    }

    static fromJS(data: any): Individ {
        data = typeof data === 'object' ? data : {};
        let result = new Individ();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["personnummer"] = this.personnummer !== undefined ? this.personnummer : null as any;
        data["fornamn"] = this.fornamn !== undefined ? this.fornamn : null as any;
        data["tilltalsnamn"] = this.tilltalsnamn !== undefined ? this.tilltalsnamn : null as any;
        data["efternamn"] = this.efternamn !== undefined ? this.efternamn : null as any;
        data["mellannamn"] = this.mellannamn !== undefined ? this.mellannamn : null as any;
        data["skapadDateTime"] = this.skapadDateTime ? this.skapadDateTime.toISOString() : null as any;
        data["uppdateradDateTime"] = this.uppdateradDateTime ? this.uppdateradDateTime.toISOString() : null as any;
        data["verifieradDateTime"] = this.verifieradDateTime ? this.verifieradDateTime.toISOString() : null as any;
        data["isAvliden"] = this.isAvliden !== undefined ? this.isAvliden : null as any;
        data["hasSkyddadIdentitet"] = this.hasSkyddadIdentitet !== undefined ? this.hasSkyddadIdentitet : null as any;
        data["isAvtalatAnstalld"] = this.isAvtalatAnstalld !== undefined ? this.isAvtalatAnstalld : null as any;
        data["adress"] = this.adress ? this.adress.toJSON() : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["telefonnummer"] = this.telefonnummer !== undefined ? this.telefonnummer : null as any;
        return data;
    }
}

export interface IIndivid {
    id: string;
    personnummer: string;
    fornamn: string;
    tilltalsnamn?: string | null;
    efternamn: string;
    mellannamn: string;
    skapadDateTime: Date;
    uppdateradDateTime: Date;
    verifieradDateTime: Date;
    isAvliden: boolean;
    hasSkyddadIdentitet: boolean;
    isAvtalatAnstalld: boolean;
    adress?: Adress | null;
    email?: string | null;
    telefonnummer?: string | null;
}

export class KundkontaktResponse implements IKundkontaktResponse {
    /** URL till kundkontakt-entiteten i CRM. */
    kundkontaktUrl!: string;
    /** URL till företag-entiteten i CRM. */
    foretagUrl?: string | null;

    constructor(data?: IKundkontaktResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kundkontaktUrl = _data["kundkontaktUrl"] !== undefined ? _data["kundkontaktUrl"] : null as any;
            this.foretagUrl = _data["foretagUrl"] !== undefined ? _data["foretagUrl"] : null as any;
        }
    }

    static fromJS(data: any): KundkontaktResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KundkontaktResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kundkontaktUrl"] = this.kundkontaktUrl !== undefined ? this.kundkontaktUrl : null as any;
        data["foretagUrl"] = this.foretagUrl !== undefined ? this.foretagUrl : null as any;
        return data;
    }
}

export interface IKundkontaktResponse {
    /** URL till kundkontakt-entiteten i CRM. */
    kundkontaktUrl: string;
    /** URL till företag-entiteten i CRM. */
    foretagUrl?: string | null;
}

export class Adress2 implements IAdress2 {
    gatuadress?: string | null;
    coAdress?: string | null;
    postnummer?: string | null;
    postort?: string | null;

    constructor(data?: IAdress2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatuadress = _data["gatuadress"] !== undefined ? _data["gatuadress"] : null as any;
            this.coAdress = _data["coAdress"] !== undefined ? _data["coAdress"] : null as any;
            this.postnummer = _data["postnummer"] !== undefined ? _data["postnummer"] : null as any;
            this.postort = _data["postort"] !== undefined ? _data["postort"] : null as any;
        }
    }

    static fromJS(data: any): Adress2 {
        data = typeof data === 'object' ? data : {};
        let result = new Adress2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatuadress"] = this.gatuadress !== undefined ? this.gatuadress : null as any;
        data["coAdress"] = this.coAdress !== undefined ? this.coAdress : null as any;
        data["postnummer"] = this.postnummer !== undefined ? this.postnummer : null as any;
        data["postort"] = this.postort !== undefined ? this.postort : null as any;
        return data;
    }
}

export interface IAdress2 {
    gatuadress?: string | null;
    coAdress?: string | null;
    postnummer?: string | null;
    postort?: string | null;
}

export class Foretag implements IForetag {
    organisationsnummer!: string;
    platformId!: string;
    namn!: string;

    constructor(data?: IForetag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.platformId = _data["platformId"] !== undefined ? _data["platformId"] : null as any;
            this.namn = _data["namn"] !== undefined ? _data["namn"] : null as any;
        }
    }

    static fromJS(data: any): Foretag {
        data = typeof data === 'object' ? data : {};
        let result = new Foretag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["platformId"] = this.platformId !== undefined ? this.platformId : null as any;
        data["namn"] = this.namn !== undefined ? this.namn : null as any;
        return data;
    }
}

export interface IForetag {
    organisationsnummer: string;
    platformId: string;
    namn: string;
}

export class KundkontaktRequest implements IKundkontaktRequest {
    puzzelId?: string | null;
    person?: Person | null;
    foretag?: Foretag | null;
    verifierad!: boolean;
    kanalTyp?: KanalType | null;
    kundgruppType!: KundgruppType;

    constructor(data?: IKundkontaktRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.puzzelId = _data["puzzelId"] !== undefined ? _data["puzzelId"] : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
            this.foretag = _data["foretag"] ? Foretag.fromJS(_data["foretag"]) : null as any;
            this.verifierad = _data["verifierad"] !== undefined ? _data["verifierad"] : null as any;
            this.kanalTyp = _data["kanalTyp"] !== undefined ? _data["kanalTyp"] : null as any;
            this.kundgruppType = _data["kundgruppType"] !== undefined ? _data["kundgruppType"] : null as any;
        }
    }

    static fromJS(data: any): KundkontaktRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KundkontaktRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["puzzelId"] = this.puzzelId !== undefined ? this.puzzelId : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["foretag"] = this.foretag ? this.foretag.toJSON() : null as any;
        data["verifierad"] = this.verifierad !== undefined ? this.verifierad : null as any;
        data["kanalTyp"] = this.kanalTyp !== undefined ? this.kanalTyp : null as any;
        data["kundgruppType"] = this.kundgruppType !== undefined ? this.kundgruppType : null as any;
        return data;
    }
}

export interface IKundkontaktRequest {
    puzzelId?: string | null;
    person?: Person | null;
    foretag?: Foretag | null;
    verifierad: boolean;
    kanalTyp?: KanalType | null;
    kundgruppType: KundgruppType;
}

export class Person implements IPerson {
    platformId!: string;
    /** Personnummer om användaren är verifierad. */
    personnummer!: string;
    fornamn?: string | null;
    mellannamn?: string | null;
    efternamn?: string | null;
    adress?: Adress2 | null;
    skyddadIdentitet!: boolean;
    avliden!: boolean;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformId = _data["platformId"] !== undefined ? _data["platformId"] : null as any;
            this.personnummer = _data["personnummer"] !== undefined ? _data["personnummer"] : null as any;
            this.fornamn = _data["fornamn"] !== undefined ? _data["fornamn"] : null as any;
            this.mellannamn = _data["mellannamn"] !== undefined ? _data["mellannamn"] : null as any;
            this.efternamn = _data["efternamn"] !== undefined ? _data["efternamn"] : null as any;
            this.adress = _data["adress"] ? Adress2.fromJS(_data["adress"]) : null as any;
            this.skyddadIdentitet = _data["skyddadIdentitet"] !== undefined ? _data["skyddadIdentitet"] : null as any;
            this.avliden = _data["avliden"] !== undefined ? _data["avliden"] : null as any;
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformId"] = this.platformId !== undefined ? this.platformId : null as any;
        data["personnummer"] = this.personnummer !== undefined ? this.personnummer : null as any;
        data["fornamn"] = this.fornamn !== undefined ? this.fornamn : null as any;
        data["mellannamn"] = this.mellannamn !== undefined ? this.mellannamn : null as any;
        data["efternamn"] = this.efternamn !== undefined ? this.efternamn : null as any;
        data["adress"] = this.adress ? this.adress.toJSON() : null as any;
        data["skyddadIdentitet"] = this.skyddadIdentitet !== undefined ? this.skyddadIdentitet : null as any;
        data["avliden"] = this.avliden !== undefined ? this.avliden : null as any;
        return data;
    }
}

export interface IPerson {
    platformId: string;
    /** Personnummer om användaren är verifierad. */
    personnummer: string;
    fornamn?: string | null;
    mellannamn?: string | null;
    efternamn?: string | null;
    adress?: Adress2 | null;
    skyddadIdentitet: boolean;
    avliden: boolean;
}

export class UserProfile implements IUserProfile {
    acl!: { [key: string]: boolean; };
    givenName!: string;
    surname!: string;
    email!: string;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.acl = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["acl"]) {
                this.acl = {} as any;
                for (let key in _data["acl"]) {
                    if (_data["acl"].hasOwnProperty(key))
                        (this.acl as any)![key] = _data["acl"][key] !== undefined ? _data["acl"][key] : null as any;
                }
            }
            else {
                this.acl = null as any;
            }
            this.givenName = _data["givenName"] !== undefined ? _data["givenName"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.acl) {
            data["acl"] = {};
            for (let key in this.acl) {
                if (this.acl.hasOwnProperty(key))
                    (data["acl"] as any)[key] = this.acl[key] !== undefined ? this.acl[key] : null as any;
            }
        }
        data["givenName"] = this.givenName !== undefined ? this.givenName : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IUserProfile {
    acl: { [key: string]: boolean; };
    givenName: string;
    surname: string;
    email: string;
}

export class PlatformData implements IPlatformData {
    anstallningar!: AnstallningarResponse;
    grunduppgifter!: GrunduppgifterResponse[];
    formansgrundandeUppgifter!: FormansgrundandeUppgifterResponse;
    individuellaVal!: IndividuellaValResponse;
    forsakringar!: ForsakringarResponse;
    tjanstepensioner!: TjanstepensionerResponse;
    placeringsval!: PlaceringsvalResponse;

    constructor(data?: IPlatformData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.anstallningar = new AnstallningarResponse();
            this.grunduppgifter = [];
            this.formansgrundandeUppgifter = new FormansgrundandeUppgifterResponse();
            this.individuellaVal = new IndividuellaValResponse();
            this.forsakringar = new ForsakringarResponse();
            this.tjanstepensioner = new TjanstepensionerResponse();
            this.placeringsval = new PlaceringsvalResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anstallningar = _data["anstallningar"] ? AnstallningarResponse.fromJS(_data["anstallningar"]) : new AnstallningarResponse();
            if (Array.isArray(_data["grunduppgifter"])) {
                this.grunduppgifter = [] as any;
                for (let item of _data["grunduppgifter"])
                    this.grunduppgifter!.push(GrunduppgifterResponse.fromJS(item));
            }
            else {
                this.grunduppgifter = null as any;
            }
            this.formansgrundandeUppgifter = _data["formansgrundandeUppgifter"] ? FormansgrundandeUppgifterResponse.fromJS(_data["formansgrundandeUppgifter"]) : new FormansgrundandeUppgifterResponse();
            this.individuellaVal = _data["individuellaVal"] ? IndividuellaValResponse.fromJS(_data["individuellaVal"]) : new IndividuellaValResponse();
            this.forsakringar = _data["forsakringar"] ? ForsakringarResponse.fromJS(_data["forsakringar"]) : new ForsakringarResponse();
            this.tjanstepensioner = _data["tjanstepensioner"] ? TjanstepensionerResponse.fromJS(_data["tjanstepensioner"]) : new TjanstepensionerResponse();
            this.placeringsval = _data["placeringsval"] ? PlaceringsvalResponse.fromJS(_data["placeringsval"]) : new PlaceringsvalResponse();
        }
    }

    static fromJS(data: any): PlatformData {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anstallningar"] = this.anstallningar ? this.anstallningar.toJSON() : null as any;
        if (Array.isArray(this.grunduppgifter)) {
            data["grunduppgifter"] = [];
            for (let item of this.grunduppgifter)
                data["grunduppgifter"].push(item ? item.toJSON() : null as any);
        }
        data["formansgrundandeUppgifter"] = this.formansgrundandeUppgifter ? this.formansgrundandeUppgifter.toJSON() : null as any;
        data["individuellaVal"] = this.individuellaVal ? this.individuellaVal.toJSON() : null as any;
        data["forsakringar"] = this.forsakringar ? this.forsakringar.toJSON() : null as any;
        data["tjanstepensioner"] = this.tjanstepensioner ? this.tjanstepensioner.toJSON() : null as any;
        data["placeringsval"] = this.placeringsval ? this.placeringsval.toJSON() : null as any;
        return data;
    }
}

export interface IPlatformData {
    anstallningar: AnstallningarResponse;
    grunduppgifter: GrunduppgifterResponse[];
    formansgrundandeUppgifter: FormansgrundandeUppgifterResponse;
    individuellaVal: IndividuellaValResponse;
    forsakringar: ForsakringarResponse;
    tjanstepensioner: TjanstepensionerResponse;
    placeringsval: PlaceringsvalResponse;
}

export class MockDataRequest implements IMockDataRequest {
    anstallningar?: AnstallningarResponse | null;
    grunduppgifter?: GrunduppgifterResponse[] | null;
    formansgrundandeUppgifter?: FormansgrundandeUppgifterResponse | null;
    individuellaVal?: IndividuellaValResponse | null;
    forsakringar?: ForsakringarResponse | null;
    tjanstepensioner?: TjanstepensionerResponse | null;
    placeringsval?: PlaceringsvalResponse | null;

    constructor(data?: IMockDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anstallningar = _data["anstallningar"] ? AnstallningarResponse.fromJS(_data["anstallningar"]) : null as any;
            if (Array.isArray(_data["grunduppgifter"])) {
                this.grunduppgifter = [] as any;
                for (let item of _data["grunduppgifter"])
                    this.grunduppgifter!.push(GrunduppgifterResponse.fromJS(item));
            }
            else {
                this.grunduppgifter = null as any;
            }
            this.formansgrundandeUppgifter = _data["formansgrundandeUppgifter"] ? FormansgrundandeUppgifterResponse.fromJS(_data["formansgrundandeUppgifter"]) : null as any;
            this.individuellaVal = _data["individuellaVal"] ? IndividuellaValResponse.fromJS(_data["individuellaVal"]) : null as any;
            this.forsakringar = _data["forsakringar"] ? ForsakringarResponse.fromJS(_data["forsakringar"]) : null as any;
            this.tjanstepensioner = _data["tjanstepensioner"] ? TjanstepensionerResponse.fromJS(_data["tjanstepensioner"]) : null as any;
            this.placeringsval = _data["placeringsval"] ? PlaceringsvalResponse.fromJS(_data["placeringsval"]) : null as any;
        }
    }

    static fromJS(data: any): MockDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MockDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anstallningar"] = this.anstallningar ? this.anstallningar.toJSON() : null as any;
        if (Array.isArray(this.grunduppgifter)) {
            data["grunduppgifter"] = [];
            for (let item of this.grunduppgifter)
                data["grunduppgifter"].push(item ? item.toJSON() : null as any);
        }
        data["formansgrundandeUppgifter"] = this.formansgrundandeUppgifter ? this.formansgrundandeUppgifter.toJSON() : null as any;
        data["individuellaVal"] = this.individuellaVal ? this.individuellaVal.toJSON() : null as any;
        data["forsakringar"] = this.forsakringar ? this.forsakringar.toJSON() : null as any;
        data["tjanstepensioner"] = this.tjanstepensioner ? this.tjanstepensioner.toJSON() : null as any;
        data["placeringsval"] = this.placeringsval ? this.placeringsval.toJSON() : null as any;
        return data;
    }
}

export interface IMockDataRequest {
    anstallningar?: AnstallningarResponse | null;
    grunduppgifter?: GrunduppgifterResponse[] | null;
    formansgrundandeUppgifter?: FormansgrundandeUppgifterResponse | null;
    individuellaVal?: IndividuellaValResponse | null;
    forsakringar?: ForsakringarResponse | null;
    tjanstepensioner?: TjanstepensionerResponse | null;
    placeringsval?: PlaceringsvalResponse | null;
}

export class ReleaseNotesContent implements IReleaseNotesContent {
    content!: string;

    constructor(data?: IReleaseNotesContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
        }
    }

    static fromJS(data: any): ReleaseNotesContent {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseNotesContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content !== undefined ? this.content : null as any;
        return data;
    }
}

export interface IReleaseNotesContent {
    content: string;
}

export class ReleaseNotes implements IReleaseNotes {
    name!: string;
    date!: Date;

    constructor(data?: IReleaseNotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ReleaseNotes {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseNotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        return data;
    }
}

export interface IReleaseNotes {
    name: string;
    date: Date;
}

export class SearchResponse implements ISearchResponse {
    /** Id på posten som hittats. */
    id?: string;
    /** Personnummer eller organisationsnummer */
    idNumber?: string | null;
    /** Namn på den resurs som resultatet träffar. */
    name?: string | null;
    /** Typ av svar, kan vara antingen KAF.KundserviceApp.Api.Features.Search.Models.SearchResponseType.Foretag eller KAF.KundserviceApp.Api.Features.Search.Models.SearchResponseType.Individ */
    responseType?: SearchResponseType;
    /** IndividId på personen som är ombud för företaget. */
    ombudId?: string | null;
    /** Personnummer på personen som är ombud för företaget. */
    ombudPersonnummer?: string | null;
    /** Namn på personen som är ombud för företaget. */
    ombudNamn?: string | null;

    constructor(data?: ISearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.idNumber = _data["idNumber"] !== undefined ? _data["idNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.responseType = _data["responseType"] !== undefined ? _data["responseType"] : null as any;
            this.ombudId = _data["ombudId"] !== undefined ? _data["ombudId"] : null as any;
            this.ombudPersonnummer = _data["ombudPersonnummer"] !== undefined ? _data["ombudPersonnummer"] : null as any;
            this.ombudNamn = _data["ombudNamn"] !== undefined ? _data["ombudNamn"] : null as any;
        }
    }

    static fromJS(data: any): SearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["idNumber"] = this.idNumber !== undefined ? this.idNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["responseType"] = this.responseType !== undefined ? this.responseType : null as any;
        data["ombudId"] = this.ombudId !== undefined ? this.ombudId : null as any;
        data["ombudPersonnummer"] = this.ombudPersonnummer !== undefined ? this.ombudPersonnummer : null as any;
        data["ombudNamn"] = this.ombudNamn !== undefined ? this.ombudNamn : null as any;
        return data;
    }
}

export interface ISearchResponse {
    /** Id på posten som hittats. */
    id?: string;
    /** Personnummer eller organisationsnummer */
    idNumber?: string | null;
    /** Namn på den resurs som resultatet träffar. */
    name?: string | null;
    /** Typ av svar, kan vara antingen KAF.KundserviceApp.Api.Features.Search.Models.SearchResponseType.Foretag eller KAF.KundserviceApp.Api.Features.Search.Models.SearchResponseType.Individ */
    responseType?: SearchResponseType;
    /** IndividId på personen som är ombud för företaget. */
    ombudId?: string | null;
    /** Personnummer på personen som är ombud för företaget. */
    ombudPersonnummer?: string | null;
    /** Namn på personen som är ombud för företaget. */
    ombudNamn?: string | null;
}

export enum SearchResponseType {
    Unknown = "Unknown",
    Individ = "Individ",
    Foretag = "Foretag",
}

export class Svarsmall implements ISvarsmall {
    id!: string;
    name!: string;
    language!: string;
    category!: string;
    content!: string;

    constructor(data?: ISvarsmall) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
        }
    }

    static fromJS(data: any): Svarsmall {
        data = typeof data === 'object' ? data : {};
        let result = new Svarsmall();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        return data;
    }
}

export interface ISvarsmall {
    id: string;
    name: string;
    language: string;
    category: string;
    content: string;
}

export class SvarsmallarResponse implements ISvarsmallarResponse {
    templates!: Svarsmall[];
    defaultFirstAnswerId?: string | null;

    constructor(data?: ISvarsmallarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.templates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(Svarsmall.fromJS(item));
            }
            else {
                this.templates = null as any;
            }
            this.defaultFirstAnswerId = _data["defaultFirstAnswerId"] !== undefined ? _data["defaultFirstAnswerId"] : null as any;
        }
    }

    static fromJS(data: any): SvarsmallarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SvarsmallarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : null as any);
        }
        data["defaultFirstAnswerId"] = this.defaultFirstAnswerId !== undefined ? this.defaultFirstAnswerId : null as any;
        return data;
    }
}

export interface ISvarsmallarResponse {
    templates: Svarsmall[];
    defaultFirstAnswerId?: string | null;
}

export class AnslutningsperiodItemResponse implements IAnslutningsperiodItemResponse {
    /** Datum då anslutningsperioden börjar gälla. */
    startdatum?: Date | null;
    /** Datum då anslutningsperioden slutar gälla. */
    slutdatum?: Date | null;
    /** Identitet för ITP planens avdelning. Avdelningskoden kan vara ITP1, ITP2 eller ITP2PP (Pressens Pensionskassa). */
    avdelningskod!: Avdelningskod;
    /** Pensionsplanens identitet. */
    pensionsplankod?: string | null;
    /** Pensionsplanplanens namn. */
    pensionsplannamn?: string | null;

    constructor(data?: IAnslutningsperiodItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startdatum = _data["startdatum"] ? new Date(_data["startdatum"].toString()) : null as any;
            this.slutdatum = _data["slutdatum"] ? new Date(_data["slutdatum"].toString()) : null as any;
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.pensionsplankod = _data["pensionsplankod"] !== undefined ? _data["pensionsplankod"] : null as any;
            this.pensionsplannamn = _data["pensionsplannamn"] !== undefined ? _data["pensionsplannamn"] : null as any;
        }
    }

    static fromJS(data: any): AnslutningsperiodItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnslutningsperiodItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startdatum"] = this.startdatum ? this.startdatum.toISOString() : null as any;
        data["slutdatum"] = this.slutdatum ? this.slutdatum.toISOString() : null as any;
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["pensionsplankod"] = this.pensionsplankod !== undefined ? this.pensionsplankod : null as any;
        data["pensionsplannamn"] = this.pensionsplannamn !== undefined ? this.pensionsplannamn : null as any;
        return data;
    }
}

export interface IAnslutningsperiodItemResponse {
    /** Datum då anslutningsperioden börjar gälla. */
    startdatum?: Date | null;
    /** Datum då anslutningsperioden slutar gälla. */
    slutdatum?: Date | null;
    /** Identitet för ITP planens avdelning. Avdelningskoden kan vara ITP1, ITP2 eller ITP2PP (Pressens Pensionskassa). */
    avdelningskod: Avdelningskod;
    /** Pensionsplanens identitet. */
    pensionsplankod?: string | null;
    /** Pensionsplanplanens namn. */
    pensionsplannamn?: string | null;
}

export class AnstallningarItemResponse implements IAnstallningarItemResponse {
    /** Collectums identitet på en individs anställning. */
    anstallningsId!: string;
    /** Avtalats identitet på en arbetsgivare. */
    arbetsgivareId?: string | null;
    /** Arbetsgivarens organisationsnummer. */
    organisationsnummer?: string | null;
    /** Datum då anställningen påbörjades. */
    startdatum?: Date | null;
    /** Datum då anställningen avslutades. Slutdatum saknas om anställningen är aktiv. */
    slutdatum?: Date | null;
    /** Anställningens status (Aktiv, Avslutad, Tjänstledig, Föräldraledig). */
    anstallningsstatus!: Anstallningsstatus;
    /** Anger om anställd har sjukpension */
    sjukpension?: boolean;
    /** Anger om individen arbetare eller tjänsteman inom den privata sektorn. */
    kundgrupp!: Kundgrupp;
    /** Identitet för ITP-planens avdelning. Avdelningskoden kan vara ITP1, ITP2 eller ITP2PP (Pressens Pensionskassa). */
    avdelningskod!: Avdelningskod;
    /** Pensionsplanens identitet. */
    pensionsplanskod?: string | null;
    /** Pensionsplanplanens namn. */
    pensionsplansnamn?: string | null;
    /** Lönens belopp i SEK. */
    senasteGallandeLon?: number | null;
    /** Anger vilken typ av lönebelopp som avses. Exempelvis så är Lönetypen "AnmaldLon" för registrerad årslön (ITP 2)

och "KontantUtbetaldBruttolon" för registrerad månadslön (ITP 1). */
    senasteGallandeLonetyp!: Lonetyp;
    /** Datum då lönen börjar gälla. */
    senasteGallandeLonGiltigFrom?: Date | null;
    /** Lönebelopp efter löneväxling. */
    senasteGallandeLonEfterVaxling?: number | null;
    /** Anger om löneperioden är år eller månad. */
    senasteGallandeLoneperiodtyp!: TypAvLoneperiod;
    /** Datum då gällande lön registrerades. */
    senasteGallandeLonRegistreringsdatum?: Date | null;
    /** Anger ITP 2 är premiebefriad eller ej. */
    premiebefriadItp2?: boolean | null;
    /** Anger om det finns ett Undantag, Avstående eller Utträde ur ITP för anställningen. */
    uau?: boolean | null;
    /** Lista av anslutningsperioder anslutningsvillkor). */
    anslutningsperioder?: AnslutningsperiodItemResponse[] | null;

    constructor(data?: IAnstallningarItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anstallningsId = _data["anstallningsId"] !== undefined ? _data["anstallningsId"] : null as any;
            this.arbetsgivareId = _data["arbetsgivareId"] !== undefined ? _data["arbetsgivareId"] : null as any;
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.startdatum = _data["startdatum"] ? new Date(_data["startdatum"].toString()) : null as any;
            this.slutdatum = _data["slutdatum"] ? new Date(_data["slutdatum"].toString()) : null as any;
            this.anstallningsstatus = _data["anstallningsstatus"] !== undefined ? _data["anstallningsstatus"] : null as any;
            this.sjukpension = _data["sjukpension"] !== undefined ? _data["sjukpension"] : null as any;
            this.kundgrupp = _data["kundgrupp"] !== undefined ? _data["kundgrupp"] : null as any;
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.pensionsplanskod = _data["pensionsplanskod"] !== undefined ? _data["pensionsplanskod"] : null as any;
            this.pensionsplansnamn = _data["pensionsplansnamn"] !== undefined ? _data["pensionsplansnamn"] : null as any;
            this.senasteGallandeLon = _data["senasteGallandeLon"] !== undefined ? _data["senasteGallandeLon"] : null as any;
            this.senasteGallandeLonetyp = _data["senasteGallandeLonetyp"] !== undefined ? _data["senasteGallandeLonetyp"] : null as any;
            this.senasteGallandeLonGiltigFrom = _data["senasteGallandeLonGiltigFrom"] ? new Date(_data["senasteGallandeLonGiltigFrom"].toString()) : null as any;
            this.senasteGallandeLonEfterVaxling = _data["senasteGallandeLonEfterVaxling"] !== undefined ? _data["senasteGallandeLonEfterVaxling"] : null as any;
            this.senasteGallandeLoneperiodtyp = _data["senasteGallandeLoneperiodtyp"] !== undefined ? _data["senasteGallandeLoneperiodtyp"] : null as any;
            this.senasteGallandeLonRegistreringsdatum = _data["senasteGallandeLonRegistreringsdatum"] ? new Date(_data["senasteGallandeLonRegistreringsdatum"].toString()) : null as any;
            this.premiebefriadItp2 = _data["premiebefriadItp2"] !== undefined ? _data["premiebefriadItp2"] : null as any;
            this.uau = _data["uau"] !== undefined ? _data["uau"] : null as any;
            if (Array.isArray(_data["anslutningsperioder"])) {
                this.anslutningsperioder = [] as any;
                for (let item of _data["anslutningsperioder"])
                    this.anslutningsperioder!.push(AnslutningsperiodItemResponse.fromJS(item));
            }
            else {
                this.anslutningsperioder = null as any;
            }
        }
    }

    static fromJS(data: any): AnstallningarItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnstallningarItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anstallningsId"] = this.anstallningsId !== undefined ? this.anstallningsId : null as any;
        data["arbetsgivareId"] = this.arbetsgivareId !== undefined ? this.arbetsgivareId : null as any;
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["startdatum"] = this.startdatum ? this.startdatum.toISOString() : null as any;
        data["slutdatum"] = this.slutdatum ? this.slutdatum.toISOString() : null as any;
        data["anstallningsstatus"] = this.anstallningsstatus !== undefined ? this.anstallningsstatus : null as any;
        data["sjukpension"] = this.sjukpension !== undefined ? this.sjukpension : null as any;
        data["kundgrupp"] = this.kundgrupp !== undefined ? this.kundgrupp : null as any;
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["pensionsplanskod"] = this.pensionsplanskod !== undefined ? this.pensionsplanskod : null as any;
        data["pensionsplansnamn"] = this.pensionsplansnamn !== undefined ? this.pensionsplansnamn : null as any;
        data["senasteGallandeLon"] = this.senasteGallandeLon !== undefined ? this.senasteGallandeLon : null as any;
        data["senasteGallandeLonetyp"] = this.senasteGallandeLonetyp !== undefined ? this.senasteGallandeLonetyp : null as any;
        data["senasteGallandeLonGiltigFrom"] = this.senasteGallandeLonGiltigFrom ? this.senasteGallandeLonGiltigFrom.toISOString() : null as any;
        data["senasteGallandeLonEfterVaxling"] = this.senasteGallandeLonEfterVaxling !== undefined ? this.senasteGallandeLonEfterVaxling : null as any;
        data["senasteGallandeLoneperiodtyp"] = this.senasteGallandeLoneperiodtyp !== undefined ? this.senasteGallandeLoneperiodtyp : null as any;
        data["senasteGallandeLonRegistreringsdatum"] = this.senasteGallandeLonRegistreringsdatum ? this.senasteGallandeLonRegistreringsdatum.toISOString() : null as any;
        data["premiebefriadItp2"] = this.premiebefriadItp2 !== undefined ? this.premiebefriadItp2 : null as any;
        data["uau"] = this.uau !== undefined ? this.uau : null as any;
        if (Array.isArray(this.anslutningsperioder)) {
            data["anslutningsperioder"] = [];
            for (let item of this.anslutningsperioder)
                data["anslutningsperioder"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAnstallningarItemResponse {
    /** Collectums identitet på en individs anställning. */
    anstallningsId: string;
    /** Avtalats identitet på en arbetsgivare. */
    arbetsgivareId?: string | null;
    /** Arbetsgivarens organisationsnummer. */
    organisationsnummer?: string | null;
    /** Datum då anställningen påbörjades. */
    startdatum?: Date | null;
    /** Datum då anställningen avslutades. Slutdatum saknas om anställningen är aktiv. */
    slutdatum?: Date | null;
    /** Anställningens status (Aktiv, Avslutad, Tjänstledig, Föräldraledig). */
    anstallningsstatus: Anstallningsstatus;
    /** Anger om anställd har sjukpension */
    sjukpension?: boolean;
    /** Anger om individen arbetare eller tjänsteman inom den privata sektorn. */
    kundgrupp: Kundgrupp;
    /** Identitet för ITP-planens avdelning. Avdelningskoden kan vara ITP1, ITP2 eller ITP2PP (Pressens Pensionskassa). */
    avdelningskod: Avdelningskod;
    /** Pensionsplanens identitet. */
    pensionsplanskod?: string | null;
    /** Pensionsplanplanens namn. */
    pensionsplansnamn?: string | null;
    /** Lönens belopp i SEK. */
    senasteGallandeLon?: number | null;
    /** Anger vilken typ av lönebelopp som avses. Exempelvis så är Lönetypen "AnmaldLon" för registrerad årslön (ITP 2)

och "KontantUtbetaldBruttolon" för registrerad månadslön (ITP 1). */
    senasteGallandeLonetyp: Lonetyp;
    /** Datum då lönen börjar gälla. */
    senasteGallandeLonGiltigFrom?: Date | null;
    /** Lönebelopp efter löneväxling. */
    senasteGallandeLonEfterVaxling?: number | null;
    /** Anger om löneperioden är år eller månad. */
    senasteGallandeLoneperiodtyp: TypAvLoneperiod;
    /** Datum då gällande lön registrerades. */
    senasteGallandeLonRegistreringsdatum?: Date | null;
    /** Anger ITP 2 är premiebefriad eller ej. */
    premiebefriadItp2?: boolean | null;
    /** Anger om det finns ett Undantag, Avstående eller Utträde ur ITP för anställningen. */
    uau?: boolean | null;
    /** Lista av anslutningsperioder anslutningsvillkor). */
    anslutningsperioder?: AnslutningsperiodItemResponse[] | null;
}

export class AnstallningarResponse implements IAnstallningarResponse {
    /** Avtalats identitet på en individ. */
    individId!: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status!: InfoStatusItemResponse[];
    /** Lista med individens anställningar. */
    anstallningar!: AnstallningarItemResponse[];

    constructor(data?: IAnstallningarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.status = [];
            this.anstallningar = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(InfoStatusItemResponse.fromJS(item));
            }
            else {
                this.status = null as any;
            }
            if (Array.isArray(_data["anstallningar"])) {
                this.anstallningar = [] as any;
                for (let item of _data["anstallningar"])
                    this.anstallningar!.push(AnstallningarItemResponse.fromJS(item));
            }
            else {
                this.anstallningar = null as any;
            }
        }
    }

    static fromJS(data: any): AnstallningarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnstallningarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.anstallningar)) {
            data["anstallningar"] = [];
            for (let item of this.anstallningar)
                data["anstallningar"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAnstallningarResponse {
    /** Avtalats identitet på en individ. */
    individId: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status: InfoStatusItemResponse[];
    /** Lista med individens anställningar. */
    anstallningar: AnstallningarItemResponse[];
}

export enum Anstallningsstatus {
    Okand = "Okand",
    Aktiv = "Aktiv",
    Avslutad = "Avslutad",
    Tjanstledig = "Tjanstledig",
    Foraldraledig = "Foraldraledig",
}

export class ArManad implements IArManad {
    ar?: number;
    manad?: number;

    constructor(data?: IArManad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ar = _data["ar"] !== undefined ? _data["ar"] : null as any;
            this.manad = _data["manad"] !== undefined ? _data["manad"] : null as any;
        }
    }

    static fromJS(data: any): ArManad {
        data = typeof data === 'object' ? data : {};
        let result = new ArManad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ar"] = this.ar !== undefined ? this.ar : null as any;
        data["manad"] = this.manad !== undefined ? this.manad : null as any;
        return data;
    }
}

export interface IArManad {
    ar?: number;
    manad?: number;
}

export enum Avdelningskod {
    Okand = "Okand",
    ITP1 = "ITP1",
    ITP2 = "ITP2",
    ITP2PP = "ITP2PP",
    LP = "LP",
}

export enum DataSource2 {
    Unknown = "Unknown",
    Alecta = "Alecta",
    Collectum = "Collectum",
    Fora = "Fora",
    SvensktNaringsliv = "SvensktNaringsliv",
    TSL = "TSL",
    IndividerAPI = "IndividerAPI",
    GrunddataAPI = "GrunddataAPI",
    AnstalldaAPI = "AnstalldaAPI",
    PermissionsAPI = "PermissionsAPI",
}

export class EngangspremieItemResponse implements IEngangspremieItemResponse {
    /** Engångspremiens belopp. */
    beloppEngangspremie?: number | null;
    /** Månad för avsättning. */
    avsattningsmanad?: ArManad | null;
    /** Belopp om avsatt engångspremie görs via löneväxling. */
    beloppEngangsLonevaxling?: number | null;
    /** Belopp om avsättning sker via Livsarbetstidspremier (LP-premier). */
    beloppLivsarbetstidspremie?: number | null;

    constructor(data?: IEngangspremieItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beloppEngangspremie = _data["beloppEngangspremie"] !== undefined ? _data["beloppEngangspremie"] : null as any;
            this.avsattningsmanad = _data["avsattningsmanad"] ? ArManad.fromJS(_data["avsattningsmanad"]) : null as any;
            this.beloppEngangsLonevaxling = _data["beloppEngangsLonevaxling"] !== undefined ? _data["beloppEngangsLonevaxling"] : null as any;
            this.beloppLivsarbetstidspremie = _data["beloppLivsarbetstidspremie"] !== undefined ? _data["beloppLivsarbetstidspremie"] : null as any;
        }
    }

    static fromJS(data: any): EngangspremieItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EngangspremieItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beloppEngangspremie"] = this.beloppEngangspremie !== undefined ? this.beloppEngangspremie : null as any;
        data["avsattningsmanad"] = this.avsattningsmanad ? this.avsattningsmanad.toJSON() : null as any;
        data["beloppEngangsLonevaxling"] = this.beloppEngangsLonevaxling !== undefined ? this.beloppEngangsLonevaxling : null as any;
        data["beloppLivsarbetstidspremie"] = this.beloppLivsarbetstidspremie !== undefined ? this.beloppLivsarbetstidspremie : null as any;
        return data;
    }
}

export interface IEngangspremieItemResponse {
    /** Engångspremiens belopp. */
    beloppEngangspremie?: number | null;
    /** Månad för avsättning. */
    avsattningsmanad?: ArManad | null;
    /** Belopp om avsatt engångspremie görs via löneväxling. */
    beloppEngangsLonevaxling?: number | null;
    /** Belopp om avsättning sker via Livsarbetstidspremier (LP-premier). */
    beloppLivsarbetstidspremie?: number | null;
}

export enum FetchStatus {
    Unknown = "Unknown",
    Fetching = "Fetching",
    Success = "Success",
    NotFound = "NotFound",
    Timeout = "Timeout",
    Error = "Error",
}

export class GrunduppgifterItemResponse implements IGrunduppgifterItemResponse {
    /** Avtalats identitet på en individ. */
    individId!: string;
    /** Collectums identitet på en individs anställning. */
    anstallningsId?: string | null;
    /** Arbetsgivarens organisationsnummer. */
    organisationsnummer?: string | null;
    /** Anger om individen är arbetare eller tjänsteman inom den privata sektorn. Attributet sätts alltid till "Tjansteman" för ITP. */
    kundgrupp!: Kundgrupp;
    /** Datum då anställningen påbörjades. */
    startdatum?: Date | null;
    /** Datum då anställningen avslutades. Slutdatum saknas om anställningen är aktiv. */
    slutdatum?: Date | null;
    /** Anställningens status (Aktiv, Avslutad, Tjänstledig, Föräldraledig). */
    anstallningsstatus!: Anstallningsstatus;
    /** Anger om anställd har sjukpension */
    sjukpension?: boolean;
    /** Identitet för ITP planens avdelning. Avdelningskoden kan vara ITP1, ITP2 eller ITP2PP (Pressens Pensionskassa). */
    senasteAvdelningskod!: Avdelningskod;
    /** Pensionsplanens namn. */
    senastePensionsplansnamn?: string | null;
    /** Pensionsplanens identitet. */
    senastePensionsplanskod?: string | null;
    /** Anger vilket kostnadsställe anställningen tillhör. */
    kostnadsstalleId?: string | null;
    /** Möjliggör för arbetsgivare att namnsätta kostnadsställen. */
    kostnadsstallenamn?: string | null;
    /** Lönens belopp i SEK. */
    senasteGallandeLon?: number | null;
    /** Anger vilken typ av lönebelopp som avses. Exempelvis så är Lönetypen: Anmäld lön för registrerad årslön (ITP 2)

och Kontant utbetald bruttolön för registrerad månadslön (ITP 1). */
    senasteGallandeLonetyp!: Lonetyp;
    /** Datum då lönen börjar gälla. */
    senasteGallandeLonGiltigFrom?: Date | null;
    /** Lönebelopp efter löneväxling. */
    senasteGallandeLonEfterVaxling?: number | null;
    /** Anger om löneperioden är år eller månad. */
    senasteGallandeLoneperiodtyp!: TypAvLoneperiod;
    /** Datum då gällande lön registrerades. */
    senasteGallandeLonRegistreringsdatum?: Date | null;
    /** Den månad som alternativ ITP gäller från. */
    alternativITPFromArManad?: ArManad | null;
    /** Lista med perioder individen inte omfattas av ITP. */
    undantagAvstaendeUttraden!: UndantagAvstaendeUttradeItemResponse[];
    /** Lista med individuellt avtalad löpande kompletterande premier som är eller har varit gällande för denna

anställning. I listan ingår endast premier som avtalats på individnivå. */
    individuelltAvtaladeLopandeKompletterandePremier!: IndividuelltAvtaladeLopandeKompletterandePremierItemResponse[];
    /** Lista med perioder som individen valt alternativ ITP. */
    valAvAlternativITP!: ValAvAlternativItpItemResponse[];
    /** Anger ITP 2 är premiebefriad eller ej. */
    premiebefriadITP2?: boolean | null;
    /** Lista av perioder som anger vilken/vilka pensionsplan/er som anställning tillhört. */
    anslutningsperioder?: AnslutningsperiodItemResponse[] | null;
    /** Lista med avsatta engångspremier. Engångspremier används för att göra en extrainsättning till den anställdes

tjänstepension hos Collectum. */
    engangspremier?: EngangspremieItemResponse[] | null;

    constructor(data?: IGrunduppgifterItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.undantagAvstaendeUttraden = [];
            this.individuelltAvtaladeLopandeKompletterandePremier = [];
            this.valAvAlternativITP = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            this.anstallningsId = _data["anstallningsId"] !== undefined ? _data["anstallningsId"] : null as any;
            this.organisationsnummer = _data["organisationsnummer"] !== undefined ? _data["organisationsnummer"] : null as any;
            this.kundgrupp = _data["kundgrupp"] !== undefined ? _data["kundgrupp"] : null as any;
            this.startdatum = _data["startdatum"] ? new Date(_data["startdatum"].toString()) : null as any;
            this.slutdatum = _data["slutdatum"] ? new Date(_data["slutdatum"].toString()) : null as any;
            this.anstallningsstatus = _data["anstallningsstatus"] !== undefined ? _data["anstallningsstatus"] : null as any;
            this.sjukpension = _data["sjukpension"] !== undefined ? _data["sjukpension"] : null as any;
            this.senasteAvdelningskod = _data["senasteAvdelningskod"] !== undefined ? _data["senasteAvdelningskod"] : null as any;
            this.senastePensionsplansnamn = _data["senastePensionsplansnamn"] !== undefined ? _data["senastePensionsplansnamn"] : null as any;
            this.senastePensionsplanskod = _data["senastePensionsplanskod"] !== undefined ? _data["senastePensionsplanskod"] : null as any;
            this.kostnadsstalleId = _data["kostnadsstalleId"] !== undefined ? _data["kostnadsstalleId"] : null as any;
            this.kostnadsstallenamn = _data["kostnadsstallenamn"] !== undefined ? _data["kostnadsstallenamn"] : null as any;
            this.senasteGallandeLon = _data["senasteGallandeLon"] !== undefined ? _data["senasteGallandeLon"] : null as any;
            this.senasteGallandeLonetyp = _data["senasteGallandeLonetyp"] !== undefined ? _data["senasteGallandeLonetyp"] : null as any;
            this.senasteGallandeLonGiltigFrom = _data["senasteGallandeLonGiltigFrom"] ? new Date(_data["senasteGallandeLonGiltigFrom"].toString()) : null as any;
            this.senasteGallandeLonEfterVaxling = _data["senasteGallandeLonEfterVaxling"] !== undefined ? _data["senasteGallandeLonEfterVaxling"] : null as any;
            this.senasteGallandeLoneperiodtyp = _data["senasteGallandeLoneperiodtyp"] !== undefined ? _data["senasteGallandeLoneperiodtyp"] : null as any;
            this.senasteGallandeLonRegistreringsdatum = _data["senasteGallandeLonRegistreringsdatum"] ? new Date(_data["senasteGallandeLonRegistreringsdatum"].toString()) : null as any;
            this.alternativITPFromArManad = _data["alternativITPFromArManad"] ? ArManad.fromJS(_data["alternativITPFromArManad"]) : null as any;
            if (Array.isArray(_data["undantagAvstaendeUttraden"])) {
                this.undantagAvstaendeUttraden = [] as any;
                for (let item of _data["undantagAvstaendeUttraden"])
                    this.undantagAvstaendeUttraden!.push(UndantagAvstaendeUttradeItemResponse.fromJS(item));
            }
            else {
                this.undantagAvstaendeUttraden = null as any;
            }
            if (Array.isArray(_data["individuelltAvtaladeLopandeKompletterandePremier"])) {
                this.individuelltAvtaladeLopandeKompletterandePremier = [] as any;
                for (let item of _data["individuelltAvtaladeLopandeKompletterandePremier"])
                    this.individuelltAvtaladeLopandeKompletterandePremier!.push(IndividuelltAvtaladeLopandeKompletterandePremierItemResponse.fromJS(item));
            }
            else {
                this.individuelltAvtaladeLopandeKompletterandePremier = null as any;
            }
            if (Array.isArray(_data["valAvAlternativITP"])) {
                this.valAvAlternativITP = [] as any;
                for (let item of _data["valAvAlternativITP"])
                    this.valAvAlternativITP!.push(ValAvAlternativItpItemResponse.fromJS(item));
            }
            else {
                this.valAvAlternativITP = null as any;
            }
            this.premiebefriadITP2 = _data["premiebefriadITP2"] !== undefined ? _data["premiebefriadITP2"] : null as any;
            if (Array.isArray(_data["anslutningsperioder"])) {
                this.anslutningsperioder = [] as any;
                for (let item of _data["anslutningsperioder"])
                    this.anslutningsperioder!.push(AnslutningsperiodItemResponse.fromJS(item));
            }
            else {
                this.anslutningsperioder = null as any;
            }
            if (Array.isArray(_data["engangspremier"])) {
                this.engangspremier = [] as any;
                for (let item of _data["engangspremier"])
                    this.engangspremier!.push(EngangspremieItemResponse.fromJS(item));
            }
            else {
                this.engangspremier = null as any;
            }
        }
    }

    static fromJS(data: any): GrunduppgifterItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GrunduppgifterItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        data["anstallningsId"] = this.anstallningsId !== undefined ? this.anstallningsId : null as any;
        data["organisationsnummer"] = this.organisationsnummer !== undefined ? this.organisationsnummer : null as any;
        data["kundgrupp"] = this.kundgrupp !== undefined ? this.kundgrupp : null as any;
        data["startdatum"] = this.startdatum ? this.startdatum.toISOString() : null as any;
        data["slutdatum"] = this.slutdatum ? this.slutdatum.toISOString() : null as any;
        data["anstallningsstatus"] = this.anstallningsstatus !== undefined ? this.anstallningsstatus : null as any;
        data["sjukpension"] = this.sjukpension !== undefined ? this.sjukpension : null as any;
        data["senasteAvdelningskod"] = this.senasteAvdelningskod !== undefined ? this.senasteAvdelningskod : null as any;
        data["senastePensionsplansnamn"] = this.senastePensionsplansnamn !== undefined ? this.senastePensionsplansnamn : null as any;
        data["senastePensionsplanskod"] = this.senastePensionsplanskod !== undefined ? this.senastePensionsplanskod : null as any;
        data["kostnadsstalleId"] = this.kostnadsstalleId !== undefined ? this.kostnadsstalleId : null as any;
        data["kostnadsstallenamn"] = this.kostnadsstallenamn !== undefined ? this.kostnadsstallenamn : null as any;
        data["senasteGallandeLon"] = this.senasteGallandeLon !== undefined ? this.senasteGallandeLon : null as any;
        data["senasteGallandeLonetyp"] = this.senasteGallandeLonetyp !== undefined ? this.senasteGallandeLonetyp : null as any;
        data["senasteGallandeLonGiltigFrom"] = this.senasteGallandeLonGiltigFrom ? this.senasteGallandeLonGiltigFrom.toISOString() : null as any;
        data["senasteGallandeLonEfterVaxling"] = this.senasteGallandeLonEfterVaxling !== undefined ? this.senasteGallandeLonEfterVaxling : null as any;
        data["senasteGallandeLoneperiodtyp"] = this.senasteGallandeLoneperiodtyp !== undefined ? this.senasteGallandeLoneperiodtyp : null as any;
        data["senasteGallandeLonRegistreringsdatum"] = this.senasteGallandeLonRegistreringsdatum ? this.senasteGallandeLonRegistreringsdatum.toISOString() : null as any;
        data["alternativITPFromArManad"] = this.alternativITPFromArManad ? this.alternativITPFromArManad.toJSON() : null as any;
        if (Array.isArray(this.undantagAvstaendeUttraden)) {
            data["undantagAvstaendeUttraden"] = [];
            for (let item of this.undantagAvstaendeUttraden)
                data["undantagAvstaendeUttraden"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.individuelltAvtaladeLopandeKompletterandePremier)) {
            data["individuelltAvtaladeLopandeKompletterandePremier"] = [];
            for (let item of this.individuelltAvtaladeLopandeKompletterandePremier)
                data["individuelltAvtaladeLopandeKompletterandePremier"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.valAvAlternativITP)) {
            data["valAvAlternativITP"] = [];
            for (let item of this.valAvAlternativITP)
                data["valAvAlternativITP"].push(item ? item.toJSON() : null as any);
        }
        data["premiebefriadITP2"] = this.premiebefriadITP2 !== undefined ? this.premiebefriadITP2 : null as any;
        if (Array.isArray(this.anslutningsperioder)) {
            data["anslutningsperioder"] = [];
            for (let item of this.anslutningsperioder)
                data["anslutningsperioder"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.engangspremier)) {
            data["engangspremier"] = [];
            for (let item of this.engangspremier)
                data["engangspremier"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGrunduppgifterItemResponse {
    /** Avtalats identitet på en individ. */
    individId: string;
    /** Collectums identitet på en individs anställning. */
    anstallningsId?: string | null;
    /** Arbetsgivarens organisationsnummer. */
    organisationsnummer?: string | null;
    /** Anger om individen är arbetare eller tjänsteman inom den privata sektorn. Attributet sätts alltid till "Tjansteman" för ITP. */
    kundgrupp: Kundgrupp;
    /** Datum då anställningen påbörjades. */
    startdatum?: Date | null;
    /** Datum då anställningen avslutades. Slutdatum saknas om anställningen är aktiv. */
    slutdatum?: Date | null;
    /** Anställningens status (Aktiv, Avslutad, Tjänstledig, Föräldraledig). */
    anstallningsstatus: Anstallningsstatus;
    /** Anger om anställd har sjukpension */
    sjukpension?: boolean;
    /** Identitet för ITP planens avdelning. Avdelningskoden kan vara ITP1, ITP2 eller ITP2PP (Pressens Pensionskassa). */
    senasteAvdelningskod: Avdelningskod;
    /** Pensionsplanens namn. */
    senastePensionsplansnamn?: string | null;
    /** Pensionsplanens identitet. */
    senastePensionsplanskod?: string | null;
    /** Anger vilket kostnadsställe anställningen tillhör. */
    kostnadsstalleId?: string | null;
    /** Möjliggör för arbetsgivare att namnsätta kostnadsställen. */
    kostnadsstallenamn?: string | null;
    /** Lönens belopp i SEK. */
    senasteGallandeLon?: number | null;
    /** Anger vilken typ av lönebelopp som avses. Exempelvis så är Lönetypen: Anmäld lön för registrerad årslön (ITP 2)

och Kontant utbetald bruttolön för registrerad månadslön (ITP 1). */
    senasteGallandeLonetyp: Lonetyp;
    /** Datum då lönen börjar gälla. */
    senasteGallandeLonGiltigFrom?: Date | null;
    /** Lönebelopp efter löneväxling. */
    senasteGallandeLonEfterVaxling?: number | null;
    /** Anger om löneperioden är år eller månad. */
    senasteGallandeLoneperiodtyp: TypAvLoneperiod;
    /** Datum då gällande lön registrerades. */
    senasteGallandeLonRegistreringsdatum?: Date | null;
    /** Den månad som alternativ ITP gäller från. */
    alternativITPFromArManad?: ArManad | null;
    /** Lista med perioder individen inte omfattas av ITP. */
    undantagAvstaendeUttraden: UndantagAvstaendeUttradeItemResponse[];
    /** Lista med individuellt avtalad löpande kompletterande premier som är eller har varit gällande för denna

anställning. I listan ingår endast premier som avtalats på individnivå. */
    individuelltAvtaladeLopandeKompletterandePremier: IndividuelltAvtaladeLopandeKompletterandePremierItemResponse[];
    /** Lista med perioder som individen valt alternativ ITP. */
    valAvAlternativITP: ValAvAlternativItpItemResponse[];
    /** Anger ITP 2 är premiebefriad eller ej. */
    premiebefriadITP2?: boolean | null;
    /** Lista av perioder som anger vilken/vilka pensionsplan/er som anställning tillhört. */
    anslutningsperioder?: AnslutningsperiodItemResponse[] | null;
    /** Lista med avsatta engångspremier. Engångspremier används för att göra en extrainsättning till den anställdes

tjänstepension hos Collectum. */
    engangspremier?: EngangspremieItemResponse[] | null;
}

export class GrunduppgifterResponse implements IGrunduppgifterResponse {
    /** Lista över statusar på hämtning från externa datakällor. */
    status!: InfoStatusItemResponse[];
    /** Individens grunduppgifter. */
    grunduppgifter!: GrunduppgifterItemResponse;

    constructor(data?: IGrunduppgifterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.status = [];
            this.grunduppgifter = new GrunduppgifterItemResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(InfoStatusItemResponse.fromJS(item));
            }
            else {
                this.status = null as any;
            }
            this.grunduppgifter = _data["grunduppgifter"] ? GrunduppgifterItemResponse.fromJS(_data["grunduppgifter"]) : new GrunduppgifterItemResponse();
        }
    }

    static fromJS(data: any): GrunduppgifterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GrunduppgifterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : null as any);
        }
        data["grunduppgifter"] = this.grunduppgifter ? this.grunduppgifter.toJSON() : null as any;
        return data;
    }
}

export interface IGrunduppgifterResponse {
    /** Lista över statusar på hämtning från externa datakällor. */
    status: InfoStatusItemResponse[];
    /** Individens grunduppgifter. */
    grunduppgifter: GrunduppgifterItemResponse;
}

export class IndividuelltAvtaladeLopandeKompletterandePremierItemResponse implements IIndividuelltAvtaladeLopandeKompletterandePremierItemResponse {
    /** Periodens startdatum. */
    giltigFrom!: Date;
    /** Perioden slutdatum. */
    giltigTom!: Date;
    /** Anger typ av löpande premie. Kan vara: Fast Belopp, Fast belopp löneväxling, Premietrappa, Alternativ ITP

premietrappa. */
    typAvLopandePremie!: TypAvLopandePremie;
    /** Premiens belopp. */
    belopp?: number;
    /** Lista med premietrappans premietrappsteg. Premietrappan finns endast om typ av löpande premie är "Premietrappa"

eller "Alternativ ITP premietrappa". */
    premietrappa?: PremietrappaResponse[] | null;

    constructor(data?: IIndividuelltAvtaladeLopandeKompletterandePremierItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giltigFrom = _data["giltigFrom"] ? new Date(_data["giltigFrom"].toString()) : null as any;
            this.giltigTom = _data["giltigTom"] ? new Date(_data["giltigTom"].toString()) : null as any;
            this.typAvLopandePremie = _data["typAvLopandePremie"] !== undefined ? _data["typAvLopandePremie"] : null as any;
            this.belopp = _data["belopp"] !== undefined ? _data["belopp"] : null as any;
            if (Array.isArray(_data["premietrappa"])) {
                this.premietrappa = [] as any;
                for (let item of _data["premietrappa"])
                    this.premietrappa!.push(PremietrappaResponse.fromJS(item));
            }
            else {
                this.premietrappa = null as any;
            }
        }
    }

    static fromJS(data: any): IndividuelltAvtaladeLopandeKompletterandePremierItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IndividuelltAvtaladeLopandeKompletterandePremierItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giltigFrom"] = this.giltigFrom ? this.giltigFrom.toISOString() : null as any;
        data["giltigTom"] = this.giltigTom ? this.giltigTom.toISOString() : null as any;
        data["typAvLopandePremie"] = this.typAvLopandePremie !== undefined ? this.typAvLopandePremie : null as any;
        data["belopp"] = this.belopp !== undefined ? this.belopp : null as any;
        if (Array.isArray(this.premietrappa)) {
            data["premietrappa"] = [];
            for (let item of this.premietrappa)
                data["premietrappa"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IIndividuelltAvtaladeLopandeKompletterandePremierItemResponse {
    /** Periodens startdatum. */
    giltigFrom: Date;
    /** Perioden slutdatum. */
    giltigTom: Date;
    /** Anger typ av löpande premie. Kan vara: Fast Belopp, Fast belopp löneväxling, Premietrappa, Alternativ ITP

premietrappa. */
    typAvLopandePremie: TypAvLopandePremie;
    /** Premiens belopp. */
    belopp?: number;
    /** Lista med premietrappans premietrappsteg. Premietrappan finns endast om typ av löpande premie är "Premietrappa"

eller "Alternativ ITP premietrappa". */
    premietrappa?: PremietrappaResponse[] | null;
}

export class InfoStatusItemResponse implements IInfoStatusItemResponse {
    /** Källa som data hämtats från. */
    dataSource!: DataSource2;
    /** Status på hur hämtningen gick.

* Unknown: Okänd status.

* Fetching: Hämtning av data pågår.

* Success: Data hämtades utan problem.

* NotFound: Data saknas hos källan.

* Timeout: Det tog för lång tid att hämta data.

* Error: Ett fel uppstod vid hämtning av data.

 */
    status!: FetchStatus;
    /** Tidpunkt för senaste uppdateringen av KAF.Platform.Anstallda.Api.V4.Common.ResponseModels.InfoStatusItemResponse.Status. */
    updatedStatusTime!: Date;
    /** Tidpunkt för senaste uppdateringen av data. */
    updatedDataTime?: Date | null;
    /** Tidpunkt för när data anses vara gammal och ny kommer att hämtas. */
    validToTime?: Date | null;

    constructor(data?: IInfoStatusItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSource = _data["dataSource"] !== undefined ? _data["dataSource"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.updatedStatusTime = _data["updatedStatusTime"] ? new Date(_data["updatedStatusTime"].toString()) : null as any;
            this.updatedDataTime = _data["updatedDataTime"] ? new Date(_data["updatedDataTime"].toString()) : null as any;
            this.validToTime = _data["validToTime"] ? new Date(_data["validToTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): InfoStatusItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InfoStatusItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["updatedStatusTime"] = this.updatedStatusTime ? this.updatedStatusTime.toISOString() : null as any;
        data["updatedDataTime"] = this.updatedDataTime ? this.updatedDataTime.toISOString() : null as any;
        data["validToTime"] = this.validToTime ? this.validToTime.toISOString() : null as any;
        return data;
    }
}

export interface IInfoStatusItemResponse {
    /** Källa som data hämtats från. */
    dataSource: DataSource2;
    /** Status på hur hämtningen gick.

* Unknown: Okänd status.

* Fetching: Hämtning av data pågår.

* Success: Data hämtades utan problem.

* NotFound: Data saknas hos källan.

* Timeout: Det tog för lång tid att hämta data.

* Error: Ett fel uppstod vid hämtning av data.

 */
    status: FetchStatus;
    /** Tidpunkt för senaste uppdateringen av KAF.Platform.Anstallda.Api.V4.Common.ResponseModels.InfoStatusItemResponse.Status. */
    updatedStatusTime: Date;
    /** Tidpunkt för senaste uppdateringen av data. */
    updatedDataTime?: Date | null;
    /** Tidpunkt för när data anses vara gammal och ny kommer att hämtas. */
    validToTime?: Date | null;
}

export enum Kundgrupp {
    Okant = "Okant",
    Arbetare = "Arbetare",
    Tjansteman = "Tjansteman",
}

export enum Lonetyp {
    Okand = "Okand",
    AnmaldLon = "AnmaldLon",
    AvtaladLon = "AvtaladLon",
    KontantUtbetaldBruttolon = "KontantUtbetaldBruttolon",
    SjukpensionsgrundandeLon = "SjukpensionsgrundandeLon",
    PensionsmedforandeLon = "PensionsmedforandeLon",
    Efterskyddslon = "Efterskyddslon",
    AnmaldLonPfLon = "AnmaldLonPfLon",
    PfLon = "PfLon",
    LonEfterAvslutadAnstallning = "LonEfterAvslutadAnstallning",
}

export enum Orsak {
    Okand = "Okand",
    AktieagareMindreAn13 = "AktieagareMindreAn13",
    HarTjanstepensionOrdnad = "HarTjanstepensionOrdnad",
    PersonligenArbetsgivare = "PersonligenArbetsgivare",
    ForetagsledandeStallning = "ForetagsledandeStallning",
    VD = "VD",
    Nomenklaturfall = "Nomenklaturfall",
    AktieagareMerAn13 = "AktieagareMerAn13",
    AvstaendeVidNyanslutning = "AvstaendeVidNyanslutning",
}

export class PremietrappaResponse implements IPremietrappaResponse {
    /** Premienivå uttryckt som andel av lön (procent). */
    procent?: number | null;
    /** Datum premietrappsteget gäller från och med. */
    fromDatum?: Date | null;
    /** Datum premietrappsteget gäller till och med. */
    tomDatum?: Date | null;
    /** Inkomstbasbelopp. */
    basbeloppFrom?: number;
    /** Inkomstbasbelopp. */
    basbeloppTom?: number;
    /** startålder för premienivå (trappsetget). */
    alderFrom?: number;
    /** slutålder för premienivå (trappsetget). */
    alderTom?: number;

    constructor(data?: IPremietrappaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procent = _data["procent"] !== undefined ? _data["procent"] : null as any;
            this.fromDatum = _data["fromDatum"] ? new Date(_data["fromDatum"].toString()) : null as any;
            this.tomDatum = _data["tomDatum"] ? new Date(_data["tomDatum"].toString()) : null as any;
            this.basbeloppFrom = _data["basbeloppFrom"] !== undefined ? _data["basbeloppFrom"] : null as any;
            this.basbeloppTom = _data["basbeloppTom"] !== undefined ? _data["basbeloppTom"] : null as any;
            this.alderFrom = _data["alderFrom"] !== undefined ? _data["alderFrom"] : null as any;
            this.alderTom = _data["alderTom"] !== undefined ? _data["alderTom"] : null as any;
        }
    }

    static fromJS(data: any): PremietrappaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PremietrappaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procent"] = this.procent !== undefined ? this.procent : null as any;
        data["fromDatum"] = this.fromDatum ? this.fromDatum.toISOString() : null as any;
        data["tomDatum"] = this.tomDatum ? this.tomDatum.toISOString() : null as any;
        data["basbeloppFrom"] = this.basbeloppFrom !== undefined ? this.basbeloppFrom : null as any;
        data["basbeloppTom"] = this.basbeloppTom !== undefined ? this.basbeloppTom : null as any;
        data["alderFrom"] = this.alderFrom !== undefined ? this.alderFrom : null as any;
        data["alderTom"] = this.alderTom !== undefined ? this.alderTom : null as any;
        return data;
    }
}

export interface IPremietrappaResponse {
    /** Premienivå uttryckt som andel av lön (procent). */
    procent?: number | null;
    /** Datum premietrappsteget gäller från och med. */
    fromDatum?: Date | null;
    /** Datum premietrappsteget gäller till och med. */
    tomDatum?: Date | null;
    /** Inkomstbasbelopp. */
    basbeloppFrom?: number;
    /** Inkomstbasbelopp. */
    basbeloppTom?: number;
    /** startålder för premienivå (trappsetget). */
    alderFrom?: number;
    /** slutålder för premienivå (trappsetget). */
    alderTom?: number;
}

export enum TypAvLoneperiod {
    Okand = "Okand",
    Manad = "Manad",
    Ar = "Ar",
}

export enum TypAvLopandePremie {
    Okand = "Okand",
    FastBelopp = "FastBelopp",
    FastBeloppLonevaxling = "FastBeloppLonevaxling",
    Premietrappa = "Premietrappa",
    AlternativITPPremietrappa = "AlternativITPPremietrappa",
}

export enum UauTyp {
    Okand = "Okand",
    Undantag = "Undantag",
    Avstaende = "Avstaende",
    Uttrade = "Uttrade",
}

export class UndantagAvstaendeUttradeItemResponse implements IUndantagAvstaendeUttradeItemResponse {
    /** Periodens startdatum. */
    startdatum!: Date;
    /** Perioden slutdatum. */
    slutdatum?: Date | null;
    /** Anger typ av UAU (Undantag/Avstående/Utträde). */
    typ!: UauTyp;
    /** Anger orsaken till UAU. */
    orsak!: Orsak;

    constructor(data?: IUndantagAvstaendeUttradeItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startdatum = _data["startdatum"] ? new Date(_data["startdatum"].toString()) : null as any;
            this.slutdatum = _data["slutdatum"] ? new Date(_data["slutdatum"].toString()) : null as any;
            this.typ = _data["typ"] !== undefined ? _data["typ"] : null as any;
            this.orsak = _data["orsak"] !== undefined ? _data["orsak"] : null as any;
        }
    }

    static fromJS(data: any): UndantagAvstaendeUttradeItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UndantagAvstaendeUttradeItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startdatum"] = this.startdatum ? this.startdatum.toISOString() : null as any;
        data["slutdatum"] = this.slutdatum ? this.slutdatum.toISOString() : null as any;
        data["typ"] = this.typ !== undefined ? this.typ : null as any;
        data["orsak"] = this.orsak !== undefined ? this.orsak : null as any;
        return data;
    }
}

export interface IUndantagAvstaendeUttradeItemResponse {
    /** Periodens startdatum. */
    startdatum: Date;
    /** Perioden slutdatum. */
    slutdatum?: Date | null;
    /** Anger typ av UAU (Undantag/Avstående/Utträde). */
    typ: UauTyp;
    /** Anger orsaken till UAU. */
    orsak: Orsak;
}

export class ValAvAlternativItpItemResponse implements IValAvAlternativItpItemResponse {
    /** Månad som alternativ ITP gäller från. */
    fromArManad?: ArManad | null;
    /** Månad som alternativ ITP gäller till och med. */
    tomArManad?: ArManad | null;
    /** Anger om ITPK ingår. */
    inkluderaITPK?: boolean | null;

    constructor(data?: IValAvAlternativItpItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromArManad = _data["fromArManad"] ? ArManad.fromJS(_data["fromArManad"]) : null as any;
            this.tomArManad = _data["tomArManad"] ? ArManad.fromJS(_data["tomArManad"]) : null as any;
            this.inkluderaITPK = _data["inkluderaITPK"] !== undefined ? _data["inkluderaITPK"] : null as any;
        }
    }

    static fromJS(data: any): ValAvAlternativItpItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValAvAlternativItpItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromArManad"] = this.fromArManad ? this.fromArManad.toJSON() : null as any;
        data["tomArManad"] = this.tomArManad ? this.tomArManad.toJSON() : null as any;
        data["inkluderaITPK"] = this.inkluderaITPK !== undefined ? this.inkluderaITPK : null as any;
        return data;
    }
}

export interface IValAvAlternativItpItemResponse {
    /** Månad som alternativ ITP gäller från. */
    fromArManad?: ArManad | null;
    /** Månad som alternativ ITP gäller till och med. */
    tomArManad?: ArManad | null;
    /** Anger om ITPK ingår. */
    inkluderaITPK?: boolean | null;
}

export class ArbetsskadaResponse implements IArbetsskadaResponse {
    forsakring!: ForsakringResponse;

    constructor(data?: IArbetsskadaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
        }
    }

    static fromJS(data: any): ArbetsskadaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArbetsskadaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        return data;
    }
}

export interface IArbetsskadaResponse {
    forsakring: ForsakringResponse;
}

export enum Avdelningskod2 {
    Unknown = "Unknown",
    ITP1 = "ITP1",
    ITP2 = "ITP2",
    ITP2PP = "ITP2PP",
    LP = "LP",
}

export class AvgangsersattningResponse implements IAvgangsersattningResponse {
    forsakring!: ForsakringResponse;

    constructor(data?: IAvgangsersattningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
        }
    }

    static fromJS(data: any): AvgangsersattningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvgangsersattningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        return data;
    }
}

export interface IAvgangsersattningResponse {
    forsakring: ForsakringResponse;
}

export class AvstaendeFamiljepensionItemResponse implements IAvstaendeFamiljepensionItemResponse {
    avdelningskod!: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;

    constructor(data?: IAvstaendeFamiljepensionItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.giltigFromDatum = _data["giltigFromDatum"] ? new Date(_data["giltigFromDatum"].toString()) : null as any;
            this.giltigTomDatum = _data["giltigTomDatum"] ? new Date(_data["giltigTomDatum"].toString()) : null as any;
            this.registreringsdatum = _data["registreringsdatum"] ? new Date(_data["registreringsdatum"].toString()) : null as any;
            this.giltighetstid = _data["giltighetstid"] ? OpenEndedDateRange.fromJS(_data["giltighetstid"]) : null as any;
            this.valdatum = _data["valdatum"] ? new Date(_data["valdatum"].toString()) : null as any;
            this.andringPagar = _data["andringPagar"] !== undefined ? _data["andringPagar"] : null as any;
        }
    }

    static fromJS(data: any): AvstaendeFamiljepensionItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvstaendeFamiljepensionItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["giltigFromDatum"] = this.giltigFromDatum ? this.giltigFromDatum.toISOString() : null as any;
        data["giltigTomDatum"] = this.giltigTomDatum ? this.giltigTomDatum.toISOString() : null as any;
        data["registreringsdatum"] = this.registreringsdatum ? this.registreringsdatum.toISOString() : null as any;
        data["giltighetstid"] = this.giltighetstid ? this.giltighetstid.toJSON() : null as any;
        data["valdatum"] = this.valdatum ? this.valdatum.toISOString() : null as any;
        data["andringPagar"] = this.andringPagar !== undefined ? this.andringPagar : null as any;
        return data;
    }
}

export interface IAvstaendeFamiljepensionItemResponse {
    avdelningskod: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;
}

export enum Basbeloppstyp {
    Unknown = "Unknown",
    Prisbasbelopp = "Prisbasbelopp",
    ForhojtPrisbasbelopp = "ForhojtPrisbasbelopp",
    Inkomstbasbelopp = "Inkomstbasbelopp",
}

export enum DataSource3 {
    Unknown = "Unknown",
    Alecta = "Alecta",
    Collectum = "Collectum",
    Fora = "Fora",
    SvensktNaringsliv = "SvensktNaringsliv",
    TSL = "TSL",
    IndividerAPI = "IndividerAPI",
    GrunddataAPI = "GrunddataAPI",
    AnstalldaAPI = "AnstalldaAPI",
    PermissionsAPI = "PermissionsAPI",
}

export class FamiljepensionResponse implements IFamiljepensionResponse {
    forsakring!: ForsakringResponse;
    fribrevsvarde?: number | null;
    prognosManadsbelopp?: number | null;
    kollektivtSlutbetald?: boolean;
    samordning?: SamordningResponse | null;
    tjanstetid?: TjanstetidResponse | null;

    constructor(data?: IFamiljepensionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
            this.fribrevsvarde = _data["fribrevsvarde"] !== undefined ? _data["fribrevsvarde"] : null as any;
            this.prognosManadsbelopp = _data["prognosManadsbelopp"] !== undefined ? _data["prognosManadsbelopp"] : null as any;
            this.kollektivtSlutbetald = _data["kollektivtSlutbetald"] !== undefined ? _data["kollektivtSlutbetald"] : null as any;
            this.samordning = _data["samordning"] ? SamordningResponse.fromJS(_data["samordning"]) : null as any;
            this.tjanstetid = _data["tjanstetid"] ? TjanstetidResponse.fromJS(_data["tjanstetid"]) : null as any;
        }
    }

    static fromJS(data: any): FamiljepensionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FamiljepensionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        data["fribrevsvarde"] = this.fribrevsvarde !== undefined ? this.fribrevsvarde : null as any;
        data["prognosManadsbelopp"] = this.prognosManadsbelopp !== undefined ? this.prognosManadsbelopp : null as any;
        data["kollektivtSlutbetald"] = this.kollektivtSlutbetald !== undefined ? this.kollektivtSlutbetald : null as any;
        data["samordning"] = this.samordning ? this.samordning.toJSON() : null as any;
        data["tjanstetid"] = this.tjanstetid ? this.tjanstetid.toJSON() : null as any;
        return data;
    }
}

export interface IFamiljepensionResponse {
    forsakring: ForsakringResponse;
    fribrevsvarde?: number | null;
    prognosManadsbelopp?: number | null;
    kollektivtSlutbetald?: boolean;
    samordning?: SamordningResponse | null;
    tjanstetid?: TjanstetidResponse | null;
}

export class FamiljeskyddResponse implements IFamiljeskyddResponse {
    forsakring!: ForsakringResponse;
    forsakringsbelopp?: number;
    utbetalningstidManader?: number;

    constructor(data?: IFamiljeskyddResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
            this.forsakringsbelopp = _data["forsakringsbelopp"] !== undefined ? _data["forsakringsbelopp"] : null as any;
            this.utbetalningstidManader = _data["utbetalningstidManader"] !== undefined ? _data["utbetalningstidManader"] : null as any;
        }
    }

    static fromJS(data: any): FamiljeskyddResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FamiljeskyddResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        data["forsakringsbelopp"] = this.forsakringsbelopp !== undefined ? this.forsakringsbelopp : null as any;
        data["utbetalningstidManader"] = this.utbetalningstidManader !== undefined ? this.utbetalningstidManader : null as any;
        return data;
    }
}

export interface IFamiljeskyddResponse {
    forsakring: ForsakringResponse;
    forsakringsbelopp?: number;
    utbetalningstidManader?: number;
}

export enum FetchStatus2 {
    Unknown = "Unknown",
    Fetching = "Fetching",
    Success = "Success",
    NotFound = "NotFound",
    Timeout = "Timeout",
    Error = "Error",
}

export class ForaldraledighetResponse implements IForaldraledighetResponse {
    forsakring!: ForsakringResponse;

    constructor(data?: IForaldraledighetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
        }
    }

    static fromJS(data: any): ForaldraledighetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForaldraledighetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        return data;
    }
}

export interface IForaldraledighetResponse {
    forsakring: ForsakringResponse;
}

export class FormansgrundandeUppgifterItemResponse implements IFormansgrundandeUppgifterItemResponse {
    /** Avtalats identitet på en arbetsgivare. */
    arbetsgivareId?: string | null;
    /** Den pensionsmedförande lönen ligger till grund för hur pension förmånen beräknas. Den kan skilja sig från

den verkliga/rapporterade lönen. */
    pensionsmedforandeLon?: PensionsmedforandeLonItemResponse | null;
    /** Den sjukpensionsgrundande lönen ligger till grund för hur stor sjukpensionsförmånen blir. */
    sjukpensionsgrundandeLon?: SjukpensionsgrundandeLonItemResponse | null;
    /** Lista med tjänstetider */
    tjanstetider?: FormansgrundandeUppgifterTjanstetidItemResponse[] | null;
    /** Lista med samordningsuppgifter. */
    samordningsuppgifter?: SamordningsuppgifterItemResponse[] | null;

    constructor(data?: IFormansgrundandeUppgifterItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arbetsgivareId = _data["arbetsgivareId"] !== undefined ? _data["arbetsgivareId"] : null as any;
            this.pensionsmedforandeLon = _data["pensionsmedforandeLon"] ? PensionsmedforandeLonItemResponse.fromJS(_data["pensionsmedforandeLon"]) : null as any;
            this.sjukpensionsgrundandeLon = _data["sjukpensionsgrundandeLon"] ? SjukpensionsgrundandeLonItemResponse.fromJS(_data["sjukpensionsgrundandeLon"]) : null as any;
            if (Array.isArray(_data["tjanstetider"])) {
                this.tjanstetider = [] as any;
                for (let item of _data["tjanstetider"])
                    this.tjanstetider!.push(FormansgrundandeUppgifterTjanstetidItemResponse.fromJS(item));
            }
            else {
                this.tjanstetider = null as any;
            }
            if (Array.isArray(_data["samordningsuppgifter"])) {
                this.samordningsuppgifter = [] as any;
                for (let item of _data["samordningsuppgifter"])
                    this.samordningsuppgifter!.push(SamordningsuppgifterItemResponse.fromJS(item));
            }
            else {
                this.samordningsuppgifter = null as any;
            }
        }
    }

    static fromJS(data: any): FormansgrundandeUppgifterItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormansgrundandeUppgifterItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arbetsgivareId"] = this.arbetsgivareId !== undefined ? this.arbetsgivareId : null as any;
        data["pensionsmedforandeLon"] = this.pensionsmedforandeLon ? this.pensionsmedforandeLon.toJSON() : null as any;
        data["sjukpensionsgrundandeLon"] = this.sjukpensionsgrundandeLon ? this.sjukpensionsgrundandeLon.toJSON() : null as any;
        if (Array.isArray(this.tjanstetider)) {
            data["tjanstetider"] = [];
            for (let item of this.tjanstetider)
                data["tjanstetider"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.samordningsuppgifter)) {
            data["samordningsuppgifter"] = [];
            for (let item of this.samordningsuppgifter)
                data["samordningsuppgifter"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFormansgrundandeUppgifterItemResponse {
    /** Avtalats identitet på en arbetsgivare. */
    arbetsgivareId?: string | null;
    /** Den pensionsmedförande lönen ligger till grund för hur pension förmånen beräknas. Den kan skilja sig från

den verkliga/rapporterade lönen. */
    pensionsmedforandeLon?: PensionsmedforandeLonItemResponse | null;
    /** Den sjukpensionsgrundande lönen ligger till grund för hur stor sjukpensionsförmånen blir. */
    sjukpensionsgrundandeLon?: SjukpensionsgrundandeLonItemResponse | null;
    /** Lista med tjänstetider */
    tjanstetider?: FormansgrundandeUppgifterTjanstetidItemResponse[] | null;
    /** Lista med samordningsuppgifter. */
    samordningsuppgifter?: SamordningsuppgifterItemResponse[] | null;
}

export class FormansgrundandeUppgifterResponse implements IFormansgrundandeUppgifterResponse {
    /** Avtalats identitet på en individ. */
    individId!: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status!: InfoStatusItemResponse2[];
    /** Lista med individens förmånsgrundande uppgifter. */
    formansgrundandeUppgifter!: FormansgrundandeUppgifterItemResponse[];

    constructor(data?: IFormansgrundandeUppgifterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.status = [];
            this.formansgrundandeUppgifter = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(InfoStatusItemResponse2.fromJS(item));
            }
            else {
                this.status = null as any;
            }
            if (Array.isArray(_data["formansgrundandeUppgifter"])) {
                this.formansgrundandeUppgifter = [] as any;
                for (let item of _data["formansgrundandeUppgifter"])
                    this.formansgrundandeUppgifter!.push(FormansgrundandeUppgifterItemResponse.fromJS(item));
            }
            else {
                this.formansgrundandeUppgifter = null as any;
            }
        }
    }

    static fromJS(data: any): FormansgrundandeUppgifterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormansgrundandeUppgifterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.formansgrundandeUppgifter)) {
            data["formansgrundandeUppgifter"] = [];
            for (let item of this.formansgrundandeUppgifter)
                data["formansgrundandeUppgifter"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFormansgrundandeUppgifterResponse {
    /** Avtalats identitet på en individ. */
    individId: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status: InfoStatusItemResponse2[];
    /** Lista med individens förmånsgrundande uppgifter. */
    formansgrundandeUppgifter: FormansgrundandeUppgifterItemResponse[];
}

/** Tjänstetid används för att beräkna förmånsbestämd ålderspension. Utelämnas om försäkringen är premiebefriad, slutbetald eller under utbetalning. Tjänstetid över 7.5 ibb utelämnas om den är 0. Anges i månader. */
export class FormansgrundandeUppgifterTjanstetidItemResponse implements IFormansgrundandeUppgifterTjanstetidItemResponse {
    /** Beräknad tjänstetid under 7,5 ibb */
    beraknadTjanstetidUnder75Ibb?: number;
    /** Beräknad tjänstetid över 7,5 ibb. Ingår endast för aktiv försäkring. */
    beraknadTjanstetidOver75Ibb?: number;
    /** Intjänad tjänstetid under 7,5 ibb. */
    intjanadTjanstetidUnder75Ibb?: number;
    /** Intjänad tjänstetid över 7,5 ibb. */
    intjanadTjanstetidOver75Ibb?: number;
    /** Beskrivning av försäkringen. */
    forsakringsproduktBeskrivning!: string;
    /** Status på försäkringen. */
    forsakringensStatus!: ForsakringStatus;

    constructor(data?: IFormansgrundandeUppgifterTjanstetidItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beraknadTjanstetidUnder75Ibb = _data["beraknadTjanstetidUnder75Ibb"] !== undefined ? _data["beraknadTjanstetidUnder75Ibb"] : null as any;
            this.beraknadTjanstetidOver75Ibb = _data["beraknadTjanstetidOver75Ibb"] !== undefined ? _data["beraknadTjanstetidOver75Ibb"] : null as any;
            this.intjanadTjanstetidUnder75Ibb = _data["intjanadTjanstetidUnder75Ibb"] !== undefined ? _data["intjanadTjanstetidUnder75Ibb"] : null as any;
            this.intjanadTjanstetidOver75Ibb = _data["intjanadTjanstetidOver75Ibb"] !== undefined ? _data["intjanadTjanstetidOver75Ibb"] : null as any;
            this.forsakringsproduktBeskrivning = _data["forsakringsproduktBeskrivning"] !== undefined ? _data["forsakringsproduktBeskrivning"] : null as any;
            this.forsakringensStatus = _data["forsakringensStatus"] !== undefined ? _data["forsakringensStatus"] : null as any;
        }
    }

    static fromJS(data: any): FormansgrundandeUppgifterTjanstetidItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormansgrundandeUppgifterTjanstetidItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beraknadTjanstetidUnder75Ibb"] = this.beraknadTjanstetidUnder75Ibb !== undefined ? this.beraknadTjanstetidUnder75Ibb : null as any;
        data["beraknadTjanstetidOver75Ibb"] = this.beraknadTjanstetidOver75Ibb !== undefined ? this.beraknadTjanstetidOver75Ibb : null as any;
        data["intjanadTjanstetidUnder75Ibb"] = this.intjanadTjanstetidUnder75Ibb !== undefined ? this.intjanadTjanstetidUnder75Ibb : null as any;
        data["intjanadTjanstetidOver75Ibb"] = this.intjanadTjanstetidOver75Ibb !== undefined ? this.intjanadTjanstetidOver75Ibb : null as any;
        data["forsakringsproduktBeskrivning"] = this.forsakringsproduktBeskrivning !== undefined ? this.forsakringsproduktBeskrivning : null as any;
        data["forsakringensStatus"] = this.forsakringensStatus !== undefined ? this.forsakringensStatus : null as any;
        return data;
    }
}

/** Tjänstetid används för att beräkna förmånsbestämd ålderspension. Utelämnas om försäkringen är premiebefriad, slutbetald eller under utbetalning. Tjänstetid över 7.5 ibb utelämnas om den är 0. Anges i månader. */
export interface IFormansgrundandeUppgifterTjanstetidItemResponse {
    /** Beräknad tjänstetid under 7,5 ibb */
    beraknadTjanstetidUnder75Ibb?: number;
    /** Beräknad tjänstetid över 7,5 ibb. Ingår endast för aktiv försäkring. */
    beraknadTjanstetidOver75Ibb?: number;
    /** Intjänad tjänstetid under 7,5 ibb. */
    intjanadTjanstetidUnder75Ibb?: number;
    /** Intjänad tjänstetid över 7,5 ibb. */
    intjanadTjanstetidOver75Ibb?: number;
    /** Beskrivning av försäkringen. */
    forsakringsproduktBeskrivning: string;
    /** Status på försäkringen. */
    forsakringensStatus: ForsakringStatus;
}

export class ForsakringResponse implements IForsakringResponse {
    forsakringsId?: string | null;
    forsakringsproduktNamn!: string;
    forsakringsgivare?: string | null;
    forsakringsproduktKod!: string;
    status!: ForsakringStatus;
    startdatum!: Date;
    slutdatum?: Date | null;
    andringsdatum?: Date | null;

    constructor(data?: IForsakringResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakringsId = _data["forsakringsId"] !== undefined ? _data["forsakringsId"] : null as any;
            this.forsakringsproduktNamn = _data["forsakringsproduktNamn"] !== undefined ? _data["forsakringsproduktNamn"] : null as any;
            this.forsakringsgivare = _data["forsakringsgivare"] !== undefined ? _data["forsakringsgivare"] : null as any;
            this.forsakringsproduktKod = _data["forsakringsproduktKod"] !== undefined ? _data["forsakringsproduktKod"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.startdatum = _data["startdatum"] ? new Date(_data["startdatum"].toString()) : null as any;
            this.slutdatum = _data["slutdatum"] ? new Date(_data["slutdatum"].toString()) : null as any;
            this.andringsdatum = _data["andringsdatum"] ? new Date(_data["andringsdatum"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ForsakringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForsakringResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakringsId"] = this.forsakringsId !== undefined ? this.forsakringsId : null as any;
        data["forsakringsproduktNamn"] = this.forsakringsproduktNamn !== undefined ? this.forsakringsproduktNamn : null as any;
        data["forsakringsgivare"] = this.forsakringsgivare !== undefined ? this.forsakringsgivare : null as any;
        data["forsakringsproduktKod"] = this.forsakringsproduktKod !== undefined ? this.forsakringsproduktKod : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["startdatum"] = this.startdatum ? this.startdatum.toISOString() : null as any;
        data["slutdatum"] = this.slutdatum ? this.slutdatum.toISOString() : null as any;
        data["andringsdatum"] = this.andringsdatum ? this.andringsdatum.toISOString() : null as any;
        return data;
    }
}

export interface IForsakringResponse {
    forsakringsId?: string | null;
    forsakringsproduktNamn: string;
    forsakringsgivare?: string | null;
    forsakringsproduktKod: string;
    status: ForsakringStatus;
    startdatum: Date;
    slutdatum?: Date | null;
    andringsdatum?: Date | null;
}

export enum ForsakringStatus {
    Unknown = "Unknown",
    Aktiv = "Aktiv",
    Fribrev = "Fribrev",
    UnderUtbetalning = "UnderUtbetalning",
    Slutbetald = "Slutbetald",
    Premiebefriad = "Premiebefriad",
}

export class ForsakringarItemResponse implements IForsakringarItemResponse {
    familjepension?: FamiljepensionResponse | null;
    familjeskydd?: FamiljeskyddResponse | null;
    sjukpension?: SjukpensionResponse | null;
    tjanstegrupplivforsakring?: TjanstegrupplivforsakringResponse | null;
    arbetsskada?: ArbetsskadaResponse | null;
    avgangsersattning?: AvgangsersattningResponse | null;
    foraldraledighet?: ForaldraledighetResponse | null;
    kompetensstod?: KompetensstodResponse | null;
    omstallningsstod?: OmstallningsstodResponse | null;

    constructor(data?: IForsakringarItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.familjepension = _data["familjepension"] ? FamiljepensionResponse.fromJS(_data["familjepension"]) : null as any;
            this.familjeskydd = _data["familjeskydd"] ? FamiljeskyddResponse.fromJS(_data["familjeskydd"]) : null as any;
            this.sjukpension = _data["sjukpension"] ? SjukpensionResponse.fromJS(_data["sjukpension"]) : null as any;
            this.tjanstegrupplivforsakring = _data["tjanstegrupplivforsakring"] ? TjanstegrupplivforsakringResponse.fromJS(_data["tjanstegrupplivforsakring"]) : null as any;
            this.arbetsskada = _data["arbetsskada"] ? ArbetsskadaResponse.fromJS(_data["arbetsskada"]) : null as any;
            this.avgangsersattning = _data["avgangsersattning"] ? AvgangsersattningResponse.fromJS(_data["avgangsersattning"]) : null as any;
            this.foraldraledighet = _data["foraldraledighet"] ? ForaldraledighetResponse.fromJS(_data["foraldraledighet"]) : null as any;
            this.kompetensstod = _data["kompetensstod"] ? KompetensstodResponse.fromJS(_data["kompetensstod"]) : null as any;
            this.omstallningsstod = _data["omstallningsstod"] ? OmstallningsstodResponse.fromJS(_data["omstallningsstod"]) : null as any;
        }
    }

    static fromJS(data: any): ForsakringarItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForsakringarItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familjepension"] = this.familjepension ? this.familjepension.toJSON() : null as any;
        data["familjeskydd"] = this.familjeskydd ? this.familjeskydd.toJSON() : null as any;
        data["sjukpension"] = this.sjukpension ? this.sjukpension.toJSON() : null as any;
        data["tjanstegrupplivforsakring"] = this.tjanstegrupplivforsakring ? this.tjanstegrupplivforsakring.toJSON() : null as any;
        data["arbetsskada"] = this.arbetsskada ? this.arbetsskada.toJSON() : null as any;
        data["avgangsersattning"] = this.avgangsersattning ? this.avgangsersattning.toJSON() : null as any;
        data["foraldraledighet"] = this.foraldraledighet ? this.foraldraledighet.toJSON() : null as any;
        data["kompetensstod"] = this.kompetensstod ? this.kompetensstod.toJSON() : null as any;
        data["omstallningsstod"] = this.omstallningsstod ? this.omstallningsstod.toJSON() : null as any;
        return data;
    }
}

export interface IForsakringarItemResponse {
    familjepension?: FamiljepensionResponse | null;
    familjeskydd?: FamiljeskyddResponse | null;
    sjukpension?: SjukpensionResponse | null;
    tjanstegrupplivforsakring?: TjanstegrupplivforsakringResponse | null;
    arbetsskada?: ArbetsskadaResponse | null;
    avgangsersattning?: AvgangsersattningResponse | null;
    foraldraledighet?: ForaldraledighetResponse | null;
    kompetensstod?: KompetensstodResponse | null;
    omstallningsstod?: OmstallningsstodResponse | null;
}

export class ForsakringarPerPlanItemResponse implements IForsakringarPerPlanItemResponse {
    pensionsalder?: number | null;
    arbetsgivareNamn?: string | null;
    arbetsgivareOrgnummer?: string | null;
    arbetsgivareOrgnummerTyp?: string | null;
    avdelningskod!: Avdelningskod2;
    pensionsplan?: string | null;
    forsakringar?: ForsakringarItemResponse | null;

    constructor(data?: IForsakringarPerPlanItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pensionsalder = _data["pensionsalder"] !== undefined ? _data["pensionsalder"] : null as any;
            this.arbetsgivareNamn = _data["arbetsgivareNamn"] !== undefined ? _data["arbetsgivareNamn"] : null as any;
            this.arbetsgivareOrgnummer = _data["arbetsgivareOrgnummer"] !== undefined ? _data["arbetsgivareOrgnummer"] : null as any;
            this.arbetsgivareOrgnummerTyp = _data["arbetsgivareOrgnummerTyp"] !== undefined ? _data["arbetsgivareOrgnummerTyp"] : null as any;
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.pensionsplan = _data["pensionsplan"] !== undefined ? _data["pensionsplan"] : null as any;
            this.forsakringar = _data["forsakringar"] ? ForsakringarItemResponse.fromJS(_data["forsakringar"]) : null as any;
        }
    }

    static fromJS(data: any): ForsakringarPerPlanItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForsakringarPerPlanItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pensionsalder"] = this.pensionsalder !== undefined ? this.pensionsalder : null as any;
        data["arbetsgivareNamn"] = this.arbetsgivareNamn !== undefined ? this.arbetsgivareNamn : null as any;
        data["arbetsgivareOrgnummer"] = this.arbetsgivareOrgnummer !== undefined ? this.arbetsgivareOrgnummer : null as any;
        data["arbetsgivareOrgnummerTyp"] = this.arbetsgivareOrgnummerTyp !== undefined ? this.arbetsgivareOrgnummerTyp : null as any;
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["pensionsplan"] = this.pensionsplan !== undefined ? this.pensionsplan : null as any;
        data["forsakringar"] = this.forsakringar ? this.forsakringar.toJSON() : null as any;
        return data;
    }
}

export interface IForsakringarPerPlanItemResponse {
    pensionsalder?: number | null;
    arbetsgivareNamn?: string | null;
    arbetsgivareOrgnummer?: string | null;
    arbetsgivareOrgnummerTyp?: string | null;
    avdelningskod: Avdelningskod2;
    pensionsplan?: string | null;
    forsakringar?: ForsakringarItemResponse | null;
}

export class ForsakringarResponse implements IForsakringarResponse {
    individId!: string;
    status!: InfoStatusItemResponse2[];
    forsakringarPerPlan!: ForsakringarPerPlanItemResponse[];

    constructor(data?: IForsakringarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.status = [];
            this.forsakringarPerPlan = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(InfoStatusItemResponse2.fromJS(item));
            }
            else {
                this.status = null as any;
            }
            if (Array.isArray(_data["forsakringarPerPlan"])) {
                this.forsakringarPerPlan = [] as any;
                for (let item of _data["forsakringarPerPlan"])
                    this.forsakringarPerPlan!.push(ForsakringarPerPlanItemResponse.fromJS(item));
            }
            else {
                this.forsakringarPerPlan = null as any;
            }
        }
    }

    static fromJS(data: any): ForsakringarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForsakringarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.forsakringarPerPlan)) {
            data["forsakringarPerPlan"] = [];
            for (let item of this.forsakringarPerPlan)
                data["forsakringarPerPlan"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IForsakringarResponse {
    individId: string;
    status: InfoStatusItemResponse2[];
    forsakringarPerPlan: ForsakringarPerPlanItemResponse[];
}

export class HalsoprovningResponse implements IHalsoprovningResponse {
    status!: HalsoprovningsStatus;
    initieringsdatum!: Date;

    constructor(data?: IHalsoprovningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.initieringsdatum = _data["initieringsdatum"] ? new Date(_data["initieringsdatum"].toString()) : null as any;
        }
    }

    static fromJS(data: any): HalsoprovningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HalsoprovningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["initieringsdatum"] = this.initieringsdatum ? this.initieringsdatum.toISOString() : null as any;
        return data;
    }
}

export interface IHalsoprovningResponse {
    status: HalsoprovningsStatus;
    initieringsdatum: Date;
}

export enum HalsoprovningsStatus {
    Unknown = "Unknown",
    Pagar = "Pagar",
    Godkand = "Godkand",
    Avslag = "Avslag",
}

export class IndividuellaValResponse implements IIndividuellaValResponse {
    individId!: string;
    status!: InfoStatusItemResponse2[];
    andringPagar?: boolean | null;
    sarskildaFormanstagarForordnanden!: SarskiltFormanstagarForordnandeItemResponse[];
    avstaendeFamiljepension!: AvstaendeFamiljepensionItemResponse[];
    valAvAterbetalningsskydd!: ValAvAterbetalningsskyddItemResponse[];
    valAvFamiljeskydd!: ValAvFamiljeskyddItemResponse[];
    mojligaVal!: MojligaValResponse;

    constructor(data?: IIndividuellaValResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.status = [];
            this.sarskildaFormanstagarForordnanden = [];
            this.avstaendeFamiljepension = [];
            this.valAvAterbetalningsskydd = [];
            this.valAvFamiljeskydd = [];
            this.mojligaVal = new MojligaValResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(InfoStatusItemResponse2.fromJS(item));
            }
            else {
                this.status = null as any;
            }
            this.andringPagar = _data["andringPagar"] !== undefined ? _data["andringPagar"] : null as any;
            if (Array.isArray(_data["sarskildaFormanstagarForordnanden"])) {
                this.sarskildaFormanstagarForordnanden = [] as any;
                for (let item of _data["sarskildaFormanstagarForordnanden"])
                    this.sarskildaFormanstagarForordnanden!.push(SarskiltFormanstagarForordnandeItemResponse.fromJS(item));
            }
            else {
                this.sarskildaFormanstagarForordnanden = null as any;
            }
            if (Array.isArray(_data["avstaendeFamiljepension"])) {
                this.avstaendeFamiljepension = [] as any;
                for (let item of _data["avstaendeFamiljepension"])
                    this.avstaendeFamiljepension!.push(AvstaendeFamiljepensionItemResponse.fromJS(item));
            }
            else {
                this.avstaendeFamiljepension = null as any;
            }
            if (Array.isArray(_data["valAvAterbetalningsskydd"])) {
                this.valAvAterbetalningsskydd = [] as any;
                for (let item of _data["valAvAterbetalningsskydd"])
                    this.valAvAterbetalningsskydd!.push(ValAvAterbetalningsskyddItemResponse.fromJS(item));
            }
            else {
                this.valAvAterbetalningsskydd = null as any;
            }
            if (Array.isArray(_data["valAvFamiljeskydd"])) {
                this.valAvFamiljeskydd = [] as any;
                for (let item of _data["valAvFamiljeskydd"])
                    this.valAvFamiljeskydd!.push(ValAvFamiljeskyddItemResponse.fromJS(item));
            }
            else {
                this.valAvFamiljeskydd = null as any;
            }
            this.mojligaVal = _data["mojligaVal"] ? MojligaValResponse.fromJS(_data["mojligaVal"]) : new MojligaValResponse();
        }
    }

    static fromJS(data: any): IndividuellaValResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IndividuellaValResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : null as any);
        }
        data["andringPagar"] = this.andringPagar !== undefined ? this.andringPagar : null as any;
        if (Array.isArray(this.sarskildaFormanstagarForordnanden)) {
            data["sarskildaFormanstagarForordnanden"] = [];
            for (let item of this.sarskildaFormanstagarForordnanden)
                data["sarskildaFormanstagarForordnanden"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.avstaendeFamiljepension)) {
            data["avstaendeFamiljepension"] = [];
            for (let item of this.avstaendeFamiljepension)
                data["avstaendeFamiljepension"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.valAvAterbetalningsskydd)) {
            data["valAvAterbetalningsskydd"] = [];
            for (let item of this.valAvAterbetalningsskydd)
                data["valAvAterbetalningsskydd"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.valAvFamiljeskydd)) {
            data["valAvFamiljeskydd"] = [];
            for (let item of this.valAvFamiljeskydd)
                data["valAvFamiljeskydd"].push(item ? item.toJSON() : null as any);
        }
        data["mojligaVal"] = this.mojligaVal ? this.mojligaVal.toJSON() : null as any;
        return data;
    }
}

export interface IIndividuellaValResponse {
    individId: string;
    status: InfoStatusItemResponse2[];
    andringPagar?: boolean | null;
    sarskildaFormanstagarForordnanden: SarskiltFormanstagarForordnandeItemResponse[];
    avstaendeFamiljepension: AvstaendeFamiljepensionItemResponse[];
    valAvAterbetalningsskydd: ValAvAterbetalningsskyddItemResponse[];
    valAvFamiljeskydd: ValAvFamiljeskyddItemResponse[];
    mojligaVal: MojligaValResponse;
}

export class InfoStatusItemResponse2 implements IInfoStatusItemResponse2 {
    dataSource!: DataSource3;
    status!: FetchStatus2;
    statusMessage?: string | null;
    updatedStatusTime!: Date;
    updatedDataTime?: Date | null;
    validToTime?: Date | null;

    constructor(data?: IInfoStatusItemResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSource = _data["dataSource"] !== undefined ? _data["dataSource"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusMessage = _data["statusMessage"] !== undefined ? _data["statusMessage"] : null as any;
            this.updatedStatusTime = _data["updatedStatusTime"] ? new Date(_data["updatedStatusTime"].toString()) : null as any;
            this.updatedDataTime = _data["updatedDataTime"] ? new Date(_data["updatedDataTime"].toString()) : null as any;
            this.validToTime = _data["validToTime"] ? new Date(_data["validToTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): InfoStatusItemResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new InfoStatusItemResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusMessage"] = this.statusMessage !== undefined ? this.statusMessage : null as any;
        data["updatedStatusTime"] = this.updatedStatusTime ? this.updatedStatusTime.toISOString() : null as any;
        data["updatedDataTime"] = this.updatedDataTime ? this.updatedDataTime.toISOString() : null as any;
        data["validToTime"] = this.validToTime ? this.validToTime.toISOString() : null as any;
        return data;
    }
}

export interface IInfoStatusItemResponse2 {
    dataSource: DataSource3;
    status: FetchStatus2;
    statusMessage?: string | null;
    updatedStatusTime: Date;
    updatedDataTime?: Date | null;
    validToTime?: Date | null;
}

export class KompetensstodResponse implements IKompetensstodResponse {
    forsakring!: ForsakringResponse;

    constructor(data?: IKompetensstodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
        }
    }

    static fromJS(data: any): KompetensstodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KompetensstodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        return data;
    }
}

export interface IKompetensstodResponse {
    forsakring: ForsakringResponse;
}

export class MojligaValResponse implements IMojligaValResponse {
    aterbetalningsskydd!: MojligtValResponse[];
    familjeskydd!: MojligtValResponse[];
    familjepension!: MojligtValResponse[];

    constructor(data?: IMojligaValResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.aterbetalningsskydd = [];
            this.familjeskydd = [];
            this.familjepension = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["aterbetalningsskydd"])) {
                this.aterbetalningsskydd = [] as any;
                for (let item of _data["aterbetalningsskydd"])
                    this.aterbetalningsskydd!.push(MojligtValResponse.fromJS(item));
            }
            else {
                this.aterbetalningsskydd = null as any;
            }
            if (Array.isArray(_data["familjeskydd"])) {
                this.familjeskydd = [] as any;
                for (let item of _data["familjeskydd"])
                    this.familjeskydd!.push(MojligtValResponse.fromJS(item));
            }
            else {
                this.familjeskydd = null as any;
            }
            if (Array.isArray(_data["familjepension"])) {
                this.familjepension = [] as any;
                for (let item of _data["familjepension"])
                    this.familjepension!.push(MojligtValResponse.fromJS(item));
            }
            else {
                this.familjepension = null as any;
            }
        }
    }

    static fromJS(data: any): MojligaValResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MojligaValResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.aterbetalningsskydd)) {
            data["aterbetalningsskydd"] = [];
            for (let item of this.aterbetalningsskydd)
                data["aterbetalningsskydd"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.familjeskydd)) {
            data["familjeskydd"] = [];
            for (let item of this.familjeskydd)
                data["familjeskydd"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.familjepension)) {
            data["familjepension"] = [];
            for (let item of this.familjepension)
                data["familjepension"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IMojligaValResponse {
    aterbetalningsskydd: MojligtValResponse[];
    familjeskydd: MojligtValResponse[];
    familjepension: MojligtValResponse[];
}

export class MojligtValResponse implements IMojligtValResponse {
    avdelning!: Avdelningskod2;

    constructor(data?: IMojligtValResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avdelning = _data["avdelning"] !== undefined ? _data["avdelning"] : null as any;
        }
    }

    static fromJS(data: any): MojligtValResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MojligtValResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avdelning"] = this.avdelning !== undefined ? this.avdelning : null as any;
        return data;
    }
}

export interface IMojligtValResponse {
    avdelning: Avdelningskod2;
}

export class OmstallningsstodResponse implements IOmstallningsstodResponse {
    forsakring!: ForsakringResponse;

    constructor(data?: IOmstallningsstodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
        }
    }

    static fromJS(data: any): OmstallningsstodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OmstallningsstodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        return data;
    }
}

export interface IOmstallningsstodResponse {
    forsakring: ForsakringResponse;
}

export class OpenEndedDateRange implements IOpenEndedDateRange {
    from!: Date;
    to?: Date | null;

    constructor(data?: IOpenEndedDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OpenEndedDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new OpenEndedDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IOpenEndedDateRange {
    from: Date;
    to?: Date | null;
}

/** Den pensionsmedförande lönen ligger till grund för hur pension förmånen beräknas. Den kan skilja sig från den verkliga/rapporterade lönen. */
export class PensionsmedforandeLonItemResponse implements IPensionsmedforandeLonItemResponse {
    /** Den pensionsmedförande lönens belopp i SEK. */
    belopp?: number;
    /** Anger om löneperioden är år eller månad för den pensionsmedförande lönen. */
    typAvLoneperiod!: TypAvLoneperiod2;
    /** Tidpunkt lönen gäller från. */
    giltigFrom?: Date | null;

    constructor(data?: IPensionsmedforandeLonItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.belopp = _data["belopp"] !== undefined ? _data["belopp"] : null as any;
            this.typAvLoneperiod = _data["typAvLoneperiod"] !== undefined ? _data["typAvLoneperiod"] : null as any;
            this.giltigFrom = _data["giltigFrom"] ? new Date(_data["giltigFrom"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PensionsmedforandeLonItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PensionsmedforandeLonItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["belopp"] = this.belopp !== undefined ? this.belopp : null as any;
        data["typAvLoneperiod"] = this.typAvLoneperiod !== undefined ? this.typAvLoneperiod : null as any;
        data["giltigFrom"] = this.giltigFrom ? this.giltigFrom.toISOString() : null as any;
        return data;
    }
}

/** Den pensionsmedförande lönen ligger till grund för hur pension förmånen beräknas. Den kan skilja sig från den verkliga/rapporterade lönen. */
export interface IPensionsmedforandeLonItemResponse {
    /** Den pensionsmedförande lönens belopp i SEK. */
    belopp?: number;
    /** Anger om löneperioden är år eller månad för den pensionsmedförande lönen. */
    typAvLoneperiod: TypAvLoneperiod2;
    /** Tidpunkt lönen gäller från. */
    giltigFrom?: Date | null;
}

export class SamordningResponse implements ISamordningResponse {
    forvaltare!: string;
    samordnatManadsbelopp?: number;

    constructor(data?: ISamordningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forvaltare = _data["forvaltare"] !== undefined ? _data["forvaltare"] : null as any;
            this.samordnatManadsbelopp = _data["samordnatManadsbelopp"] !== undefined ? _data["samordnatManadsbelopp"] : null as any;
        }
    }

    static fromJS(data: any): SamordningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SamordningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forvaltare"] = this.forvaltare !== undefined ? this.forvaltare : null as any;
        data["samordnatManadsbelopp"] = this.samordnatManadsbelopp !== undefined ? this.samordnatManadsbelopp : null as any;
        return data;
    }
}

export interface ISamordningResponse {
    forvaltare: string;
    samordnatManadsbelopp?: number;
}

/** Uppgift om annan tjänstepension som behöver tas hänsyn till för att beräkna storleken på den förmånsbestämda ålderspensionen. */
export class SamordningsuppgifterItemResponse implements ISamordningsuppgifterItemResponse {
    /** Namn på förvaltare av samordnad tjänstepension. */
    forvaltare!: string;
    /** Belopp/månad i kr. */
    samordnatManadsbelopp?: number;

    constructor(data?: ISamordningsuppgifterItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forvaltare = _data["forvaltare"] !== undefined ? _data["forvaltare"] : null as any;
            this.samordnatManadsbelopp = _data["samordnatManadsbelopp"] !== undefined ? _data["samordnatManadsbelopp"] : null as any;
        }
    }

    static fromJS(data: any): SamordningsuppgifterItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SamordningsuppgifterItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forvaltare"] = this.forvaltare !== undefined ? this.forvaltare : null as any;
        data["samordnatManadsbelopp"] = this.samordnatManadsbelopp !== undefined ? this.samordnatManadsbelopp : null as any;
        return data;
    }
}

/** Uppgift om annan tjänstepension som behöver tas hänsyn till för att beräkna storleken på den förmånsbestämda ålderspensionen. */
export interface ISamordningsuppgifterItemResponse {
    /** Namn på förvaltare av samordnad tjänstepension. */
    forvaltare: string;
    /** Belopp/månad i kr. */
    samordnatManadsbelopp?: number;
}

export class SarskiltFormanstagarForordnandeItemResponse implements ISarskiltFormanstagarForordnandeItemResponse {
    avdelningskod!: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;
    forordnandekod!: string;
    valomradeskod?: string | null;

    constructor(data?: ISarskiltFormanstagarForordnandeItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.giltigFromDatum = _data["giltigFromDatum"] ? new Date(_data["giltigFromDatum"].toString()) : null as any;
            this.giltigTomDatum = _data["giltigTomDatum"] ? new Date(_data["giltigTomDatum"].toString()) : null as any;
            this.registreringsdatum = _data["registreringsdatum"] ? new Date(_data["registreringsdatum"].toString()) : null as any;
            this.giltighetstid = _data["giltighetstid"] ? OpenEndedDateRange.fromJS(_data["giltighetstid"]) : null as any;
            this.valdatum = _data["valdatum"] ? new Date(_data["valdatum"].toString()) : null as any;
            this.andringPagar = _data["andringPagar"] !== undefined ? _data["andringPagar"] : null as any;
            this.forordnandekod = _data["forordnandekod"] !== undefined ? _data["forordnandekod"] : null as any;
            this.valomradeskod = _data["valomradeskod"] !== undefined ? _data["valomradeskod"] : null as any;
        }
    }

    static fromJS(data: any): SarskiltFormanstagarForordnandeItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SarskiltFormanstagarForordnandeItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["giltigFromDatum"] = this.giltigFromDatum ? this.giltigFromDatum.toISOString() : null as any;
        data["giltigTomDatum"] = this.giltigTomDatum ? this.giltigTomDatum.toISOString() : null as any;
        data["registreringsdatum"] = this.registreringsdatum ? this.registreringsdatum.toISOString() : null as any;
        data["giltighetstid"] = this.giltighetstid ? this.giltighetstid.toJSON() : null as any;
        data["valdatum"] = this.valdatum ? this.valdatum.toISOString() : null as any;
        data["andringPagar"] = this.andringPagar !== undefined ? this.andringPagar : null as any;
        data["forordnandekod"] = this.forordnandekod !== undefined ? this.forordnandekod : null as any;
        data["valomradeskod"] = this.valomradeskod !== undefined ? this.valomradeskod : null as any;
        return data;
    }
}

export interface ISarskiltFormanstagarForordnandeItemResponse {
    avdelningskod: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;
    forordnandekod: string;
    valomradeskod?: string | null;
}

export class SjukpensionResponse implements ISjukpensionResponse {
    forsakring!: ForsakringResponse;
    forsakringsbelopp90DagarKarens?: number;
    forsakringsbelopp360DagarKarens?: number;
    forsakringsbeloppRKarens?: number;

    constructor(data?: ISjukpensionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
            this.forsakringsbelopp90DagarKarens = _data["forsakringsbelopp90DagarKarens"] !== undefined ? _data["forsakringsbelopp90DagarKarens"] : null as any;
            this.forsakringsbelopp360DagarKarens = _data["forsakringsbelopp360DagarKarens"] !== undefined ? _data["forsakringsbelopp360DagarKarens"] : null as any;
            this.forsakringsbeloppRKarens = _data["forsakringsbeloppRKarens"] !== undefined ? _data["forsakringsbeloppRKarens"] : null as any;
        }
    }

    static fromJS(data: any): SjukpensionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SjukpensionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        data["forsakringsbelopp90DagarKarens"] = this.forsakringsbelopp90DagarKarens !== undefined ? this.forsakringsbelopp90DagarKarens : null as any;
        data["forsakringsbelopp360DagarKarens"] = this.forsakringsbelopp360DagarKarens !== undefined ? this.forsakringsbelopp360DagarKarens : null as any;
        data["forsakringsbeloppRKarens"] = this.forsakringsbeloppRKarens !== undefined ? this.forsakringsbeloppRKarens : null as any;
        return data;
    }
}

export interface ISjukpensionResponse {
    forsakring: ForsakringResponse;
    forsakringsbelopp90DagarKarens?: number;
    forsakringsbelopp360DagarKarens?: number;
    forsakringsbeloppRKarens?: number;
}

/** Den sjukpensionsgrundande lönen ligger till grund för hur stor sjukpensionsförmånen blir. */
export class SjukpensionsgrundandeLonItemResponse implements ISjukpensionsgrundandeLonItemResponse {
    /** Den sjukpensionsgrundande lönens belopp i SEK. */
    belopp?: number;
    /** Anger om löneperioden är år eller månad för den sjukpensionsgrundande lönen. */
    typAvLoneperiod!: TypAvLoneperiod2;
    /** Tidpunkt lönen gäller från. */
    giltigFrom?: Date | null;

    constructor(data?: ISjukpensionsgrundandeLonItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.belopp = _data["belopp"] !== undefined ? _data["belopp"] : null as any;
            this.typAvLoneperiod = _data["typAvLoneperiod"] !== undefined ? _data["typAvLoneperiod"] : null as any;
            this.giltigFrom = _data["giltigFrom"] ? new Date(_data["giltigFrom"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SjukpensionsgrundandeLonItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SjukpensionsgrundandeLonItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["belopp"] = this.belopp !== undefined ? this.belopp : null as any;
        data["typAvLoneperiod"] = this.typAvLoneperiod !== undefined ? this.typAvLoneperiod : null as any;
        data["giltigFrom"] = this.giltigFrom ? this.giltigFrom.toISOString() : null as any;
        return data;
    }
}

/** Den sjukpensionsgrundande lönen ligger till grund för hur stor sjukpensionsförmånen blir. */
export interface ISjukpensionsgrundandeLonItemResponse {
    /** Den sjukpensionsgrundande lönens belopp i SEK. */
    belopp?: number;
    /** Anger om löneperioden är år eller månad för den sjukpensionsgrundande lönen. */
    typAvLoneperiod: TypAvLoneperiod2;
    /** Tidpunkt lönen gäller från. */
    giltigFrom?: Date | null;
}

export enum SkyddsVal {
    Unknown = "Unknown",
    SkyddBortvalt = "SkyddBortvalt",
    SkyddValt = "SkyddValt",
    SkyddInteValt = "SkyddInteValt",
}

export class TjanstegrupplivforsakringResponse implements ITjanstegrupplivforsakringResponse {
    forsakring!: ForsakringResponse;
    basbelopp?: number;
    grundbelopp?: number | null;

    constructor(data?: ITjanstegrupplivforsakringResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forsakring = new ForsakringResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakring = _data["forsakring"] ? ForsakringResponse.fromJS(_data["forsakring"]) : new ForsakringResponse();
            this.basbelopp = _data["basbelopp"] !== undefined ? _data["basbelopp"] : null as any;
            this.grundbelopp = _data["grundbelopp"] !== undefined ? _data["grundbelopp"] : null as any;
        }
    }

    static fromJS(data: any): TjanstegrupplivforsakringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TjanstegrupplivforsakringResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakring"] = this.forsakring ? this.forsakring.toJSON() : null as any;
        data["basbelopp"] = this.basbelopp !== undefined ? this.basbelopp : null as any;
        data["grundbelopp"] = this.grundbelopp !== undefined ? this.grundbelopp : null as any;
        return data;
    }
}

export interface ITjanstegrupplivforsakringResponse {
    forsakring: ForsakringResponse;
    basbelopp?: number;
    grundbelopp?: number | null;
}

export class TjanstetidResponse implements ITjanstetidResponse {
    beraknadTjanstetidUnder75Ibb?: number;
    beraknadTjanstetidOver75Ibb?: number;
    intjanadTjanstetidUnder75Ibb?: number;
    intjanadTjanstetidOver75Ibb?: number;

    constructor(data?: ITjanstetidResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beraknadTjanstetidUnder75Ibb = _data["beraknadTjanstetidUnder75Ibb"] !== undefined ? _data["beraknadTjanstetidUnder75Ibb"] : null as any;
            this.beraknadTjanstetidOver75Ibb = _data["beraknadTjanstetidOver75Ibb"] !== undefined ? _data["beraknadTjanstetidOver75Ibb"] : null as any;
            this.intjanadTjanstetidUnder75Ibb = _data["intjanadTjanstetidUnder75Ibb"] !== undefined ? _data["intjanadTjanstetidUnder75Ibb"] : null as any;
            this.intjanadTjanstetidOver75Ibb = _data["intjanadTjanstetidOver75Ibb"] !== undefined ? _data["intjanadTjanstetidOver75Ibb"] : null as any;
        }
    }

    static fromJS(data: any): TjanstetidResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TjanstetidResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beraknadTjanstetidUnder75Ibb"] = this.beraknadTjanstetidUnder75Ibb !== undefined ? this.beraknadTjanstetidUnder75Ibb : null as any;
        data["beraknadTjanstetidOver75Ibb"] = this.beraknadTjanstetidOver75Ibb !== undefined ? this.beraknadTjanstetidOver75Ibb : null as any;
        data["intjanadTjanstetidUnder75Ibb"] = this.intjanadTjanstetidUnder75Ibb !== undefined ? this.intjanadTjanstetidUnder75Ibb : null as any;
        data["intjanadTjanstetidOver75Ibb"] = this.intjanadTjanstetidOver75Ibb !== undefined ? this.intjanadTjanstetidOver75Ibb : null as any;
        return data;
    }
}

export interface ITjanstetidResponse {
    beraknadTjanstetidUnder75Ibb?: number;
    beraknadTjanstetidOver75Ibb?: number;
    intjanadTjanstetidUnder75Ibb?: number;
    intjanadTjanstetidOver75Ibb?: number;
}

export enum TypAvLoneperiod2 {
    Okand = "Okand",
    Ar = "Ar",
    Manad = "Manad",
}

export class ValAvAterbetalningsskyddItemResponse implements IValAvAterbetalningsskyddItemResponse {
    avdelningskod!: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;
    applicerasRetroaktivt?: boolean;
    val!: SkyddsVal;
    arGallande?: boolean;
    halsoprovning?: HalsoprovningResponse | null;

    constructor(data?: IValAvAterbetalningsskyddItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.giltigFromDatum = _data["giltigFromDatum"] ? new Date(_data["giltigFromDatum"].toString()) : null as any;
            this.giltigTomDatum = _data["giltigTomDatum"] ? new Date(_data["giltigTomDatum"].toString()) : null as any;
            this.registreringsdatum = _data["registreringsdatum"] ? new Date(_data["registreringsdatum"].toString()) : null as any;
            this.giltighetstid = _data["giltighetstid"] ? OpenEndedDateRange.fromJS(_data["giltighetstid"]) : null as any;
            this.valdatum = _data["valdatum"] ? new Date(_data["valdatum"].toString()) : null as any;
            this.andringPagar = _data["andringPagar"] !== undefined ? _data["andringPagar"] : null as any;
            this.applicerasRetroaktivt = _data["applicerasRetroaktivt"] !== undefined ? _data["applicerasRetroaktivt"] : null as any;
            this.val = _data["val"] !== undefined ? _data["val"] : null as any;
            this.arGallande = _data["arGallande"] !== undefined ? _data["arGallande"] : null as any;
            this.halsoprovning = _data["halsoprovning"] ? HalsoprovningResponse.fromJS(_data["halsoprovning"]) : null as any;
        }
    }

    static fromJS(data: any): ValAvAterbetalningsskyddItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValAvAterbetalningsskyddItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["giltigFromDatum"] = this.giltigFromDatum ? this.giltigFromDatum.toISOString() : null as any;
        data["giltigTomDatum"] = this.giltigTomDatum ? this.giltigTomDatum.toISOString() : null as any;
        data["registreringsdatum"] = this.registreringsdatum ? this.registreringsdatum.toISOString() : null as any;
        data["giltighetstid"] = this.giltighetstid ? this.giltighetstid.toJSON() : null as any;
        data["valdatum"] = this.valdatum ? this.valdatum.toISOString() : null as any;
        data["andringPagar"] = this.andringPagar !== undefined ? this.andringPagar : null as any;
        data["applicerasRetroaktivt"] = this.applicerasRetroaktivt !== undefined ? this.applicerasRetroaktivt : null as any;
        data["val"] = this.val !== undefined ? this.val : null as any;
        data["arGallande"] = this.arGallande !== undefined ? this.arGallande : null as any;
        data["halsoprovning"] = this.halsoprovning ? this.halsoprovning.toJSON() : null as any;
        return data;
    }
}

export interface IValAvAterbetalningsskyddItemResponse {
    avdelningskod: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;
    applicerasRetroaktivt?: boolean;
    val: SkyddsVal;
    arGallande?: boolean;
    halsoprovning?: HalsoprovningResponse | null;
}

export class ValAvFamiljeskyddItemResponse implements IValAvFamiljeskyddItemResponse {
    avdelningskod!: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;
    val!: SkyddsVal;
    antalBasbelopp?: number;
    basbeloppstyp!: Basbeloppstyp;
    ersattningsbeloppPerManad?: number;
    utbetalningstidManader?: number;
    halsoprovning?: HalsoprovningResponse | null;
    forsakringsproduktsnamn?: string | null;
    forsakringsproduktskod?: string | null;
    kommandeKostnad?: number | null;
    premiedragande?: boolean;

    constructor(data?: IValAvFamiljeskyddItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.giltigFromDatum = _data["giltigFromDatum"] ? new Date(_data["giltigFromDatum"].toString()) : null as any;
            this.giltigTomDatum = _data["giltigTomDatum"] ? new Date(_data["giltigTomDatum"].toString()) : null as any;
            this.registreringsdatum = _data["registreringsdatum"] ? new Date(_data["registreringsdatum"].toString()) : null as any;
            this.giltighetstid = _data["giltighetstid"] ? OpenEndedDateRange.fromJS(_data["giltighetstid"]) : null as any;
            this.valdatum = _data["valdatum"] ? new Date(_data["valdatum"].toString()) : null as any;
            this.andringPagar = _data["andringPagar"] !== undefined ? _data["andringPagar"] : null as any;
            this.val = _data["val"] !== undefined ? _data["val"] : null as any;
            this.antalBasbelopp = _data["antalBasbelopp"] !== undefined ? _data["antalBasbelopp"] : null as any;
            this.basbeloppstyp = _data["basbeloppstyp"] !== undefined ? _data["basbeloppstyp"] : null as any;
            this.ersattningsbeloppPerManad = _data["ersattningsbeloppPerManad"] !== undefined ? _data["ersattningsbeloppPerManad"] : null as any;
            this.utbetalningstidManader = _data["utbetalningstidManader"] !== undefined ? _data["utbetalningstidManader"] : null as any;
            this.halsoprovning = _data["halsoprovning"] ? HalsoprovningResponse.fromJS(_data["halsoprovning"]) : null as any;
            this.forsakringsproduktsnamn = _data["forsakringsproduktsnamn"] !== undefined ? _data["forsakringsproduktsnamn"] : null as any;
            this.forsakringsproduktskod = _data["forsakringsproduktskod"] !== undefined ? _data["forsakringsproduktskod"] : null as any;
            this.kommandeKostnad = _data["kommandeKostnad"] !== undefined ? _data["kommandeKostnad"] : null as any;
            this.premiedragande = _data["premiedragande"] !== undefined ? _data["premiedragande"] : null as any;
        }
    }

    static fromJS(data: any): ValAvFamiljeskyddItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValAvFamiljeskyddItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["giltigFromDatum"] = this.giltigFromDatum ? this.giltigFromDatum.toISOString() : null as any;
        data["giltigTomDatum"] = this.giltigTomDatum ? this.giltigTomDatum.toISOString() : null as any;
        data["registreringsdatum"] = this.registreringsdatum ? this.registreringsdatum.toISOString() : null as any;
        data["giltighetstid"] = this.giltighetstid ? this.giltighetstid.toJSON() : null as any;
        data["valdatum"] = this.valdatum ? this.valdatum.toISOString() : null as any;
        data["andringPagar"] = this.andringPagar !== undefined ? this.andringPagar : null as any;
        data["val"] = this.val !== undefined ? this.val : null as any;
        data["antalBasbelopp"] = this.antalBasbelopp !== undefined ? this.antalBasbelopp : null as any;
        data["basbeloppstyp"] = this.basbeloppstyp !== undefined ? this.basbeloppstyp : null as any;
        data["ersattningsbeloppPerManad"] = this.ersattningsbeloppPerManad !== undefined ? this.ersattningsbeloppPerManad : null as any;
        data["utbetalningstidManader"] = this.utbetalningstidManader !== undefined ? this.utbetalningstidManader : null as any;
        data["halsoprovning"] = this.halsoprovning ? this.halsoprovning.toJSON() : null as any;
        data["forsakringsproduktsnamn"] = this.forsakringsproduktsnamn !== undefined ? this.forsakringsproduktsnamn : null as any;
        data["forsakringsproduktskod"] = this.forsakringsproduktskod !== undefined ? this.forsakringsproduktskod : null as any;
        data["kommandeKostnad"] = this.kommandeKostnad !== undefined ? this.kommandeKostnad : null as any;
        data["premiedragande"] = this.premiedragande !== undefined ? this.premiedragande : null as any;
        return data;
    }
}

export interface IValAvFamiljeskyddItemResponse {
    avdelningskod: Avdelningskod2;
    giltigFromDatum?: Date | null;
    giltigTomDatum?: Date | null;
    registreringsdatum?: Date | null;
    giltighetstid?: OpenEndedDateRange | null;
    valdatum?: Date | null;
    andringPagar?: boolean;
    val: SkyddsVal;
    antalBasbelopp?: number;
    basbeloppstyp: Basbeloppstyp;
    ersattningsbeloppPerManad?: number;
    utbetalningstidManader?: number;
    halsoprovning?: HalsoprovningResponse | null;
    forsakringsproduktsnamn?: string | null;
    forsakringsproduktskod?: string | null;
    kommandeKostnad?: number | null;
    premiedragande?: boolean;
}

export enum Avdelningskod3 {
    Okand = "Okand",
    ITP1 = "ITP1",
    ITP2 = "ITP2",
    ITP2PP = "ITP2PP",
    LP = "LP",
}

export enum Avtalsomrade {
    Okand = "Okand",
    Itp1 = "Itp1",
    Itpk = "Itpk",
    ItpkPp = "ItpkPp",
    Lp = "Lp",
}

export enum DataSource4 {
    Unknown = "Unknown",
    Alecta = "Alecta",
    Collectum = "Collectum",
    Fora = "Fora",
    SvensktNaringsliv = "SvensktNaringsliv",
    TSL = "TSL",
    IndividerAPI = "IndividerAPI",
    GrunddataAPI = "GrunddataAPI",
    AnstalldaAPI = "AnstalldaAPI",
    PermissionsAPI = "PermissionsAPI",
}

export enum ExternStatus {
    GILTIG = "GILTIG",
    AKTUALISERING = "AKTUALISERING",
    DELUTBETALNING = "DELUTBETALNING",
    FULL_UTBETALNING = "FULL_UTBETALNING",
    FULLT_UTBETALD_UTFLYTTAD = "FULLT_UTBETALD_UTFLYTTAD",
}

export enum FetchStatus3 {
    Unknown = "Unknown",
    Fetching = "Fetching",
    Success = "Success",
    NotFound = "NotFound",
    Timeout = "Timeout",
    Error = "Error",
}

export class FordelningPerForvaltningsformItemResponse implements IFordelningPerForvaltningsformItemResponse {
    /** Placeringens förvaltningsform.

Observera att detta inte motsvarar den allmänna beskrivningen av

förvaltningsform som t.ex. MISXMLs definition av förvaltningsform 

då den innehåller URSPRUNGLIG ITPK som inte beskriver en förvaltningsform

utan egentligen en produkt. */
    forvaltningsform!: Forvaltningsform;
    /** Procentuell andel av Kapital fördelat till denna förvaltningsform. */
    fordelning?: number;

    constructor(data?: IFordelningPerForvaltningsformItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forvaltningsform = _data["forvaltningsform"] !== undefined ? _data["forvaltningsform"] : null as any;
            this.fordelning = _data["fordelning"] !== undefined ? _data["fordelning"] : null as any;
        }
    }

    static fromJS(data: any): FordelningPerForvaltningsformItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FordelningPerForvaltningsformItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forvaltningsform"] = this.forvaltningsform !== undefined ? this.forvaltningsform : null as any;
        data["fordelning"] = this.fordelning !== undefined ? this.fordelning : null as any;
        return data;
    }
}

export interface IFordelningPerForvaltningsformItemResponse {
    /** Placeringens förvaltningsform.

Observera att detta inte motsvarar den allmänna beskrivningen av

förvaltningsform som t.ex. MISXMLs definition av förvaltningsform 

då den innehåller URSPRUNGLIG ITPK som inte beskriver en förvaltningsform

utan egentligen en produkt. */
    forvaltningsform: Forvaltningsform;
    /** Procentuell andel av Kapital fördelat till denna förvaltningsform. */
    fordelning?: number;
}

export class FordelningPerPensionsbolagItemResponse implements IFordelningPerPensionsbolagItemResponse {
    /** Namn på försäkringsbolag. */
    pensionsbolagsNamn!: string;
    /** Procentuell andel av Kapital fördelat till detta bolag. */
    fordelning?: number;

    constructor(data?: IFordelningPerPensionsbolagItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pensionsbolagsNamn = _data["pensionsbolagsNamn"] !== undefined ? _data["pensionsbolagsNamn"] : null as any;
            this.fordelning = _data["fordelning"] !== undefined ? _data["fordelning"] : null as any;
        }
    }

    static fromJS(data: any): FordelningPerPensionsbolagItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FordelningPerPensionsbolagItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pensionsbolagsNamn"] = this.pensionsbolagsNamn !== undefined ? this.pensionsbolagsNamn : null as any;
        data["fordelning"] = this.fordelning !== undefined ? this.fordelning : null as any;
        return data;
    }
}

export interface IFordelningPerPensionsbolagItemResponse {
    /** Namn på försäkringsbolag. */
    pensionsbolagsNamn: string;
    /** Procentuell andel av Kapital fördelat till detta bolag. */
    fordelning?: number;
}

export class FormansbestamdAlderspensionItemResponse implements IFormansbestamdAlderspensionItemResponse {
    /** Status på den förmånsbestämda ålderspensionen. */
    status!: TjanstepensionStatusResponse;
    /** Avtalad pensionsålder, anges i månader.

Ett värde av 780 menar då 65 år. */
    pensionsalder?: number | null;
    /** ITP plan. */
    avdelningskod!: Avdelningskod3;
    /** Försäkringsbolagets namn, motsvarar försäkringsbolagets namn vid placeringen.

För t.ex. historiska val kan försäkringsbolaget ha bytt namn, då är detta fortfarande det namn som gällde vid

valet. */
    forsakringsbolagNamn?: string | null;
    /** Namn på försäkringstagare. */
    forsakringstagare?: string | null;
    /** Identitet på försäkring hos försäkringsgivare. */
    forsakringsnummer?: string | null;
    /** Typ av produkt. */
    produkttyp!: TjanstepensionProdukttypResponse;
    /** Utbetalt pensionsmånadsbelopp den första utbetalningsmånaden. */
    prognosManadsbelopp?: number | null;
    /** Den tidsperiod under vilken ålderspension betalas ut fr.o.m. pensionering.

Kan ske livsvarigt (999) eller under specifik tidsperiod angiven i månader. Exempelvis 5 år (60) */
    utbetalningstidManader?: number | null;
    /** Värdet av en ålders- eller familjepension inom ITP 2 vid en viss tidpunkt.

Värde på ett fribrev för en försäkring där premieinbetalningarna är helt avslutade. */
    fribrevsvarde?: number | null;
    /** Placeringens förvältningsform.

Observera att detta inte motsvarar den allmänna beskrivning av förvaltningsform som t.ex. MISXMLs definition av

förvaltningsform,

då den innehåller URSPRUNGLIG ITPK som inte beskriver en förvaltningsform utan egentligen en produkt. */
    forvaltningsform!: Forvaltningsform;
    /** Produktbenämning (Alectas värdeföråd). */
    produktkod?: string | null;
    /** Försäkringsbolagets benämning på produkten. */
    forsakringsproduktnamn?: string | null;
    /** Tjänstetid används för att beräkna förmånsbestämd ålderspension.

Utelämnas om försäkringen är premiebefriad, slutbetald, eller under utbetalning. */
    tjanstetid?: TjanstetidResponse2 | null;
    /** Uppgift om annan tjänstepension som behöver tas hänsyn till för att beräkna storleken på den förmånsbestämda

ålderspensionen. */
    samordningsuppgifter?: SamordningsuppgifterItemResponse2[] | null;

    constructor(data?: IFormansbestamdAlderspensionItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.pensionsalder = _data["pensionsalder"] !== undefined ? _data["pensionsalder"] : null as any;
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.forsakringsbolagNamn = _data["forsakringsbolagNamn"] !== undefined ? _data["forsakringsbolagNamn"] : null as any;
            this.forsakringstagare = _data["forsakringstagare"] !== undefined ? _data["forsakringstagare"] : null as any;
            this.forsakringsnummer = _data["forsakringsnummer"] !== undefined ? _data["forsakringsnummer"] : null as any;
            this.produkttyp = _data["produkttyp"] !== undefined ? _data["produkttyp"] : null as any;
            this.prognosManadsbelopp = _data["prognosManadsbelopp"] !== undefined ? _data["prognosManadsbelopp"] : null as any;
            this.utbetalningstidManader = _data["utbetalningstidManader"] !== undefined ? _data["utbetalningstidManader"] : null as any;
            this.fribrevsvarde = _data["fribrevsvarde"] !== undefined ? _data["fribrevsvarde"] : null as any;
            this.forvaltningsform = _data["forvaltningsform"] !== undefined ? _data["forvaltningsform"] : null as any;
            this.produktkod = _data["produktkod"] !== undefined ? _data["produktkod"] : null as any;
            this.forsakringsproduktnamn = _data["forsakringsproduktnamn"] !== undefined ? _data["forsakringsproduktnamn"] : null as any;
            this.tjanstetid = _data["tjanstetid"] ? TjanstetidResponse2.fromJS(_data["tjanstetid"]) : null as any;
            if (Array.isArray(_data["samordningsuppgifter"])) {
                this.samordningsuppgifter = [] as any;
                for (let item of _data["samordningsuppgifter"])
                    this.samordningsuppgifter!.push(SamordningsuppgifterItemResponse2.fromJS(item));
            }
            else {
                this.samordningsuppgifter = null as any;
            }
        }
    }

    static fromJS(data: any): FormansbestamdAlderspensionItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormansbestamdAlderspensionItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["pensionsalder"] = this.pensionsalder !== undefined ? this.pensionsalder : null as any;
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["forsakringsbolagNamn"] = this.forsakringsbolagNamn !== undefined ? this.forsakringsbolagNamn : null as any;
        data["forsakringstagare"] = this.forsakringstagare !== undefined ? this.forsakringstagare : null as any;
        data["forsakringsnummer"] = this.forsakringsnummer !== undefined ? this.forsakringsnummer : null as any;
        data["produkttyp"] = this.produkttyp !== undefined ? this.produkttyp : null as any;
        data["prognosManadsbelopp"] = this.prognosManadsbelopp !== undefined ? this.prognosManadsbelopp : null as any;
        data["utbetalningstidManader"] = this.utbetalningstidManader !== undefined ? this.utbetalningstidManader : null as any;
        data["fribrevsvarde"] = this.fribrevsvarde !== undefined ? this.fribrevsvarde : null as any;
        data["forvaltningsform"] = this.forvaltningsform !== undefined ? this.forvaltningsform : null as any;
        data["produktkod"] = this.produktkod !== undefined ? this.produktkod : null as any;
        data["forsakringsproduktnamn"] = this.forsakringsproduktnamn !== undefined ? this.forsakringsproduktnamn : null as any;
        data["tjanstetid"] = this.tjanstetid ? this.tjanstetid.toJSON() : null as any;
        if (Array.isArray(this.samordningsuppgifter)) {
            data["samordningsuppgifter"] = [];
            for (let item of this.samordningsuppgifter)
                data["samordningsuppgifter"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFormansbestamdAlderspensionItemResponse {
    /** Status på den förmånsbestämda ålderspensionen. */
    status: TjanstepensionStatusResponse;
    /** Avtalad pensionsålder, anges i månader.

Ett värde av 780 menar då 65 år. */
    pensionsalder?: number | null;
    /** ITP plan. */
    avdelningskod: Avdelningskod3;
    /** Försäkringsbolagets namn, motsvarar försäkringsbolagets namn vid placeringen.

För t.ex. historiska val kan försäkringsbolaget ha bytt namn, då är detta fortfarande det namn som gällde vid

valet. */
    forsakringsbolagNamn?: string | null;
    /** Namn på försäkringstagare. */
    forsakringstagare?: string | null;
    /** Identitet på försäkring hos försäkringsgivare. */
    forsakringsnummer?: string | null;
    /** Typ av produkt. */
    produkttyp: TjanstepensionProdukttypResponse;
    /** Utbetalt pensionsmånadsbelopp den första utbetalningsmånaden. */
    prognosManadsbelopp?: number | null;
    /** Den tidsperiod under vilken ålderspension betalas ut fr.o.m. pensionering.

Kan ske livsvarigt (999) eller under specifik tidsperiod angiven i månader. Exempelvis 5 år (60) */
    utbetalningstidManader?: number | null;
    /** Värdet av en ålders- eller familjepension inom ITP 2 vid en viss tidpunkt.

Värde på ett fribrev för en försäkring där premieinbetalningarna är helt avslutade. */
    fribrevsvarde?: number | null;
    /** Placeringens förvältningsform.

Observera att detta inte motsvarar den allmänna beskrivning av förvaltningsform som t.ex. MISXMLs definition av

förvaltningsform,

då den innehåller URSPRUNGLIG ITPK som inte beskriver en förvaltningsform utan egentligen en produkt. */
    forvaltningsform: Forvaltningsform;
    /** Produktbenämning (Alectas värdeföråd). */
    produktkod?: string | null;
    /** Försäkringsbolagets benämning på produkten. */
    forsakringsproduktnamn?: string | null;
    /** Tjänstetid används för att beräkna förmånsbestämd ålderspension.

Utelämnas om försäkringen är premiebefriad, slutbetald, eller under utbetalning. */
    tjanstetid?: TjanstetidResponse2 | null;
    /** Uppgift om annan tjänstepension som behöver tas hänsyn till för att beräkna storleken på den förmånsbestämda

ålderspensionen. */
    samordningsuppgifter?: SamordningsuppgifterItemResponse2[] | null;
}

export enum Forvaltningsform {
    Okand = "Okand",
    Trad = "Trad",
    Fond = "Fond",
    UrsprungligItpk = "UrsprungligItpk",
    StandigTrad = "StandigTrad",
}

export class InfoStatusItemResponse3 implements IInfoStatusItemResponse3 {
    /** Källa som data hämtats från. */
    dataSource!: DataSource4;
    /** Status på hur hämtningen gick.

* Unknown: Okänd status.

* Fetching: Hämtning av data pågår.

* Success: Data hämtades utan problem.

* NotFound: Data saknas hos källan.

* Timeout: Det tog för lång tid att hämta data.

* Error: Ett fel uppstod vid hämtning av data.

 */
    status!: FetchStatus3;
    /** Tidpunkt för senaste uppdateringen av KAF.Platform.Pensioner.Api.V4.Common.ResponseModels.InfoStatusItemResponse.Status. */
    updatedStatusTime!: Date;
    /** Tidpunkt för senaste uppdateringen av data. */
    updatedDataTime?: Date | null;
    /** Tidpunkt för när data anses vara gammal och ny kommer att hämtas. */
    validToTime?: Date | null;

    constructor(data?: IInfoStatusItemResponse3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataSource = _data["dataSource"] !== undefined ? _data["dataSource"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.updatedStatusTime = _data["updatedStatusTime"] ? new Date(_data["updatedStatusTime"].toString()) : null as any;
            this.updatedDataTime = _data["updatedDataTime"] ? new Date(_data["updatedDataTime"].toString()) : null as any;
            this.validToTime = _data["validToTime"] ? new Date(_data["validToTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): InfoStatusItemResponse3 {
        data = typeof data === 'object' ? data : {};
        let result = new InfoStatusItemResponse3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["updatedStatusTime"] = this.updatedStatusTime ? this.updatedStatusTime.toISOString() : null as any;
        data["updatedDataTime"] = this.updatedDataTime ? this.updatedDataTime.toISOString() : null as any;
        data["validToTime"] = this.validToTime ? this.validToTime.toISOString() : null as any;
        return data;
    }
}

export interface IInfoStatusItemResponse3 {
    /** Källa som data hämtats från. */
    dataSource: DataSource4;
    /** Status på hur hämtningen gick.

* Unknown: Okänd status.

* Fetching: Hämtning av data pågår.

* Success: Data hämtades utan problem.

* NotFound: Data saknas hos källan.

* Timeout: Det tog för lång tid att hämta data.

* Error: Ett fel uppstod vid hämtning av data.

 */
    status: FetchStatus3;
    /** Tidpunkt för senaste uppdateringen av KAF.Platform.Pensioner.Api.V4.Common.ResponseModels.InfoStatusItemResponse.Status. */
    updatedStatusTime: Date;
    /** Tidpunkt för senaste uppdateringen av data. */
    updatedDataTime?: Date | null;
    /** Tidpunkt för när data anses vara gammal och ny kommer att hämtas. */
    validToTime?: Date | null;
}

export enum Inkanal {
    Okand = "Okand",
    Inloggat = "Inloggat",
    Blankett = "Blankett",
    System = "System",
    Rattning = "Rattning",
    Kapitalflytt = "Kapitalflytt",
    Avtalat = "Avtalat",
}

export class KapitalItemResponse implements IKapitalItemResponse {
    /** Identitet på försäkring hos försäkringsgivare. */
    forsakringsnummer?: string | null;
    /** Datum för när utgående värde är daterat. */
    utgaendeVardedatum?: Date | null;
    /** Värdet av pensionskapitalet vid värderingspunkten (utgående värdedatum). */
    utgaendeVarde?: number | null;
    /** Tidpunkt för värderingsperiodens början. */
    ingaendeVardedatum?: Date | null;
    /** Ingående kapital vid värderingsperiodens början (ingående värdedatum). */
    ingaendeVarde?: number | null;
    /** Den tidsperiod under vilken ålderspension betalas ut fr.o.m. pensionering.

Kan ske livsvarigt (999) eller under specifik tidsperiod angiven i månader. Exempelvis 5 år (60) */
    utbetalningstidManader?: number | null;
    /** Utbetalt pensionsmånadsbelopp den första utbetalningsmånaden. */
    prognosManadsbelopp?: number | null;
    /** Om kapitalet innehåller en garanterad del/värde är detta värde separat här. */
    garanteratVarde?: number | null;
    /** Månadsbeloppet man beräknas få utbetald från 65 år. */
    beraknadAterbaring?: number | null;
    /** Månadsbelopp med utbetalningstid i 5 år. */
    aterbetalningsskyddManadsbelopp?: number | null;
    /** Startdatumet för värdeändringsberäkningen, detta "nollställs" vid varje nyår. */
    vardeforandringSedan?: Date | null;
    /** Värdeförändring under perioden KAF.Platform.Pensioner.Api.V4.Tjanstepensioner.ResponseModels.KapitalItemResponse.VardeforandringSedan.

Beloppet kan vara såväl positivt som negativt. */
    vardeforandring?: number | null;
    /** Summan av försäkringsbolagets mottagna premier för perioden minskat med återbetalda premier. */
    overfordaPremierIAr?: number | null;
    /** Vinst i år. */
    arsvinst?: number | null;
    /** Olika typer av avgifter som försäkringsgivare drar från försäkringen, exklusive flyttavgift. */
    forsakrigsbolagsavgift?: number | null;
    /** Avkastningsskatt. */
    avkastningsskatt?: number | null;

    constructor(data?: IKapitalItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakringsnummer = _data["forsakringsnummer"] !== undefined ? _data["forsakringsnummer"] : null as any;
            this.utgaendeVardedatum = _data["utgaendeVardedatum"] ? new Date(_data["utgaendeVardedatum"].toString()) : null as any;
            this.utgaendeVarde = _data["utgaendeVarde"] !== undefined ? _data["utgaendeVarde"] : null as any;
            this.ingaendeVardedatum = _data["ingaendeVardedatum"] ? new Date(_data["ingaendeVardedatum"].toString()) : null as any;
            this.ingaendeVarde = _data["ingaendeVarde"] !== undefined ? _data["ingaendeVarde"] : null as any;
            this.utbetalningstidManader = _data["utbetalningstidManader"] !== undefined ? _data["utbetalningstidManader"] : null as any;
            this.prognosManadsbelopp = _data["prognosManadsbelopp"] !== undefined ? _data["prognosManadsbelopp"] : null as any;
            this.garanteratVarde = _data["garanteratVarde"] !== undefined ? _data["garanteratVarde"] : null as any;
            this.beraknadAterbaring = _data["beraknadAterbaring"] !== undefined ? _data["beraknadAterbaring"] : null as any;
            this.aterbetalningsskyddManadsbelopp = _data["aterbetalningsskyddManadsbelopp"] !== undefined ? _data["aterbetalningsskyddManadsbelopp"] : null as any;
            this.vardeforandringSedan = _data["vardeforandringSedan"] ? new Date(_data["vardeforandringSedan"].toString()) : null as any;
            this.vardeforandring = _data["vardeforandring"] !== undefined ? _data["vardeforandring"] : null as any;
            this.overfordaPremierIAr = _data["overfordaPremierIAr"] !== undefined ? _data["overfordaPremierIAr"] : null as any;
            this.arsvinst = _data["arsvinst"] !== undefined ? _data["arsvinst"] : null as any;
            this.forsakrigsbolagsavgift = _data["forsakrigsbolagsavgift"] !== undefined ? _data["forsakrigsbolagsavgift"] : null as any;
            this.avkastningsskatt = _data["avkastningsskatt"] !== undefined ? _data["avkastningsskatt"] : null as any;
        }
    }

    static fromJS(data: any): KapitalItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KapitalItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakringsnummer"] = this.forsakringsnummer !== undefined ? this.forsakringsnummer : null as any;
        data["utgaendeVardedatum"] = this.utgaendeVardedatum ? this.utgaendeVardedatum.toISOString() : null as any;
        data["utgaendeVarde"] = this.utgaendeVarde !== undefined ? this.utgaendeVarde : null as any;
        data["ingaendeVardedatum"] = this.ingaendeVardedatum ? this.ingaendeVardedatum.toISOString() : null as any;
        data["ingaendeVarde"] = this.ingaendeVarde !== undefined ? this.ingaendeVarde : null as any;
        data["utbetalningstidManader"] = this.utbetalningstidManader !== undefined ? this.utbetalningstidManader : null as any;
        data["prognosManadsbelopp"] = this.prognosManadsbelopp !== undefined ? this.prognosManadsbelopp : null as any;
        data["garanteratVarde"] = this.garanteratVarde !== undefined ? this.garanteratVarde : null as any;
        data["beraknadAterbaring"] = this.beraknadAterbaring !== undefined ? this.beraknadAterbaring : null as any;
        data["aterbetalningsskyddManadsbelopp"] = this.aterbetalningsskyddManadsbelopp !== undefined ? this.aterbetalningsskyddManadsbelopp : null as any;
        data["vardeforandringSedan"] = this.vardeforandringSedan ? this.vardeforandringSedan.toISOString() : null as any;
        data["vardeforandring"] = this.vardeforandring !== undefined ? this.vardeforandring : null as any;
        data["overfordaPremierIAr"] = this.overfordaPremierIAr !== undefined ? this.overfordaPremierIAr : null as any;
        data["arsvinst"] = this.arsvinst !== undefined ? this.arsvinst : null as any;
        data["forsakrigsbolagsavgift"] = this.forsakrigsbolagsavgift !== undefined ? this.forsakrigsbolagsavgift : null as any;
        data["avkastningsskatt"] = this.avkastningsskatt !== undefined ? this.avkastningsskatt : null as any;
        return data;
    }
}

export interface IKapitalItemResponse {
    /** Identitet på försäkring hos försäkringsgivare. */
    forsakringsnummer?: string | null;
    /** Datum för när utgående värde är daterat. */
    utgaendeVardedatum?: Date | null;
    /** Värdet av pensionskapitalet vid värderingspunkten (utgående värdedatum). */
    utgaendeVarde?: number | null;
    /** Tidpunkt för värderingsperiodens början. */
    ingaendeVardedatum?: Date | null;
    /** Ingående kapital vid värderingsperiodens början (ingående värdedatum). */
    ingaendeVarde?: number | null;
    /** Den tidsperiod under vilken ålderspension betalas ut fr.o.m. pensionering.

Kan ske livsvarigt (999) eller under specifik tidsperiod angiven i månader. Exempelvis 5 år (60) */
    utbetalningstidManader?: number | null;
    /** Utbetalt pensionsmånadsbelopp den första utbetalningsmånaden. */
    prognosManadsbelopp?: number | null;
    /** Om kapitalet innehåller en garanterad del/värde är detta värde separat här. */
    garanteratVarde?: number | null;
    /** Månadsbeloppet man beräknas få utbetald från 65 år. */
    beraknadAterbaring?: number | null;
    /** Månadsbelopp med utbetalningstid i 5 år. */
    aterbetalningsskyddManadsbelopp?: number | null;
    /** Startdatumet för värdeändringsberäkningen, detta "nollställs" vid varje nyår. */
    vardeforandringSedan?: Date | null;
    /** Värdeförändring under perioden KAF.Platform.Pensioner.Api.V4.Tjanstepensioner.ResponseModels.KapitalItemResponse.VardeforandringSedan.

Beloppet kan vara såväl positivt som negativt. */
    vardeforandring?: number | null;
    /** Summan av försäkringsbolagets mottagna premier för perioden minskat med återbetalda premier. */
    overfordaPremierIAr?: number | null;
    /** Vinst i år. */
    arsvinst?: number | null;
    /** Olika typer av avgifter som försäkringsgivare drar från försäkringen, exklusive flyttavgift. */
    forsakrigsbolagsavgift?: number | null;
    /** Avkastningsskatt. */
    avkastningsskatt?: number | null;
}

export class MappItemResponse implements IMappItemResponse {
    /** Identitet på en mapp för en samling försäkringar/kapital.

Mappen är ett Collectum specifikt begrepp som håller ihop ett samlat 

premieflöde som förmedlats till en viss premiemottagare med vissa signifikanta identifikationer. */
    mappId!: string;
    /** ITP plan. */
    avdelningskod!: Avdelningskod3;
    /** Avtalsomrade. */
    avtalsomrade!: Avtalsomrade;
    /** Flagga om kapitalet har återbetalningsskydd. */
    aterbetalningsskydd?: boolean;
    /** Årtalet anger när försäkringen senast blev upphandlad eller uppdaterad med nya villkor och avgifter.

Upphandlingar äger rum vart femte år.

Den senaste upphandlingen var 2018, och nästa är 2024 [sic]. */
    upphandlatAr?: string | null;
    /** Pensionsbolagets namn, motsvarar pensionsbolagets namn vid placeringen.

För t.ex. historiska val kan pensiongsbolaget ha bytt namn, då är detta fortfarande det namn som gällde vid

valet. */
    pensionsbolagsnamn!: string;
    /** Försäkringsbolagskod som är Collectums interna kod, bör inte användas för någon funktion. */
    pensionsbolagsKod!: string;
    /** Pensionsbolagets benämning på produkten. */
    forsakringsproduktNamn?: string | null;
    /** Typ av produkt. */
    produkttyp!: TjanstepensionProdukttypResponse;
    /** Placeringens förvältningsform.

Observera att detta inte motsvarar den allmänna beskrivning av förvaltningsform som t.ex. MISXMLs definition av

förvaltningsform,

då den innehåller URSPRUNGLIG ITPK som inte beskriver en förvaltningsform utan egentligen en produkt. */
    forvaltningsform!: Forvaltningsform;
    standigTrad?: boolean;
    /** Summering av totalvärde på mappen */
    totaltVarde?: number;
    /** Staut på mappen */
    externStatus!: ExternStatus;
    kapital?: KapitalItemResponse[] | null;

    constructor(data?: IMappItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappId = _data["mappId"] !== undefined ? _data["mappId"] : null as any;
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.avtalsomrade = _data["avtalsomrade"] !== undefined ? _data["avtalsomrade"] : null as any;
            this.aterbetalningsskydd = _data["aterbetalningsskydd"] !== undefined ? _data["aterbetalningsskydd"] : null as any;
            this.upphandlatAr = _data["upphandlatAr"] !== undefined ? _data["upphandlatAr"] : null as any;
            this.pensionsbolagsnamn = _data["pensionsbolagsnamn"] !== undefined ? _data["pensionsbolagsnamn"] : null as any;
            this.pensionsbolagsKod = _data["pensionsbolagsKod"] !== undefined ? _data["pensionsbolagsKod"] : null as any;
            this.forsakringsproduktNamn = _data["forsakringsproduktNamn"] !== undefined ? _data["forsakringsproduktNamn"] : null as any;
            this.produkttyp = _data["produkttyp"] !== undefined ? _data["produkttyp"] : null as any;
            this.forvaltningsform = _data["forvaltningsform"] !== undefined ? _data["forvaltningsform"] : null as any;
            this.standigTrad = _data["standigTrad"] !== undefined ? _data["standigTrad"] : null as any;
            this.totaltVarde = _data["totaltVarde"] !== undefined ? _data["totaltVarde"] : null as any;
            this.externStatus = _data["externStatus"] !== undefined ? _data["externStatus"] : null as any;
            if (Array.isArray(_data["kapital"])) {
                this.kapital = [] as any;
                for (let item of _data["kapital"])
                    this.kapital!.push(KapitalItemResponse.fromJS(item));
            }
            else {
                this.kapital = null as any;
            }
        }
    }

    static fromJS(data: any): MappItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MappItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappId"] = this.mappId !== undefined ? this.mappId : null as any;
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["avtalsomrade"] = this.avtalsomrade !== undefined ? this.avtalsomrade : null as any;
        data["aterbetalningsskydd"] = this.aterbetalningsskydd !== undefined ? this.aterbetalningsskydd : null as any;
        data["upphandlatAr"] = this.upphandlatAr !== undefined ? this.upphandlatAr : null as any;
        data["pensionsbolagsnamn"] = this.pensionsbolagsnamn !== undefined ? this.pensionsbolagsnamn : null as any;
        data["pensionsbolagsKod"] = this.pensionsbolagsKod !== undefined ? this.pensionsbolagsKod : null as any;
        data["forsakringsproduktNamn"] = this.forsakringsproduktNamn !== undefined ? this.forsakringsproduktNamn : null as any;
        data["produkttyp"] = this.produkttyp !== undefined ? this.produkttyp : null as any;
        data["forvaltningsform"] = this.forvaltningsform !== undefined ? this.forvaltningsform : null as any;
        data["standigTrad"] = this.standigTrad !== undefined ? this.standigTrad : null as any;
        data["totaltVarde"] = this.totaltVarde !== undefined ? this.totaltVarde : null as any;
        data["externStatus"] = this.externStatus !== undefined ? this.externStatus : null as any;
        if (Array.isArray(this.kapital)) {
            data["kapital"] = [];
            for (let item of this.kapital)
                data["kapital"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IMappItemResponse {
    /** Identitet på en mapp för en samling försäkringar/kapital.

Mappen är ett Collectum specifikt begrepp som håller ihop ett samlat 

premieflöde som förmedlats till en viss premiemottagare med vissa signifikanta identifikationer. */
    mappId: string;
    /** ITP plan. */
    avdelningskod: Avdelningskod3;
    /** Avtalsomrade. */
    avtalsomrade: Avtalsomrade;
    /** Flagga om kapitalet har återbetalningsskydd. */
    aterbetalningsskydd?: boolean;
    /** Årtalet anger när försäkringen senast blev upphandlad eller uppdaterad med nya villkor och avgifter.

Upphandlingar äger rum vart femte år.

Den senaste upphandlingen var 2018, och nästa är 2024 [sic]. */
    upphandlatAr?: string | null;
    /** Pensionsbolagets namn, motsvarar pensionsbolagets namn vid placeringen.

För t.ex. historiska val kan pensiongsbolaget ha bytt namn, då är detta fortfarande det namn som gällde vid

valet. */
    pensionsbolagsnamn: string;
    /** Försäkringsbolagskod som är Collectums interna kod, bör inte användas för någon funktion. */
    pensionsbolagsKod: string;
    /** Pensionsbolagets benämning på produkten. */
    forsakringsproduktNamn?: string | null;
    /** Typ av produkt. */
    produkttyp: TjanstepensionProdukttypResponse;
    /** Placeringens förvältningsform.

Observera att detta inte motsvarar den allmänna beskrivning av förvaltningsform som t.ex. MISXMLs definition av

förvaltningsform,

då den innehåller URSPRUNGLIG ITPK som inte beskriver en förvaltningsform utan egentligen en produkt. */
    forvaltningsform: Forvaltningsform;
    standigTrad?: boolean;
    /** Summering av totalvärde på mappen */
    totaltVarde?: number;
    /** Staut på mappen */
    externStatus: ExternStatus;
    kapital?: KapitalItemResponse[] | null;
}

export class OpenEndedDateRange2 implements IOpenEndedDateRange2 {
    from!: Date;
    to?: Date | null;

    constructor(data?: IOpenEndedDateRange2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OpenEndedDateRange2 {
        data = typeof data === 'object' ? data : {};
        let result = new OpenEndedDateRange2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IOpenEndedDateRange2 {
    from: Date;
    to?: Date | null;
}

/** En placering är ett val som den anställde har gjort för hur framtida inbetalningar ska placeras/fördelas. */
export class PlaceringsItemResponse implements IPlaceringsItemResponse {
    /** Försäkringsbolagets namn, motsvarar försäkringsbolagets namn vid valet av placeringen. För t.ex. historiska val kan

försäkringsbolaget ha bytt

namn, då är detta fortfarande det namn som gällde vid valet.

Har värdet ”Ännu ej vald” om inget val är gjort. */
    forsakringsbolagNamn!: string;
    /** Försäkringsbolagskod som är Collectums interna kod, bör inte användas för någon funktion. */
    forsakringsbolagKod?: string | null;
    /** Valets förvaltningsform. Observera att detta inte motsvara MISXMLs definition av förvaltningsform då den innehåller

URSPRUNGLIG ITPK som inte

beskriver en förvaltningsform utan egentligen en produkt. */
    forvaltningsform!: Forvaltningsform;
    /** Valets andel av 100%. Dvs summan av samtliga gällande val (GiltigTomDatum = null) ska vara 100. */
    premieandel?: number;
    /** Valets giltighetstid */
    giltighetstid?: OpenEndedDateRange2 | null;
    /** Datumet då den anställde gjorde sitt val (kan vara tidigare än startdatumet).

Null om inget val gjorts och ”ickeval alternativet” är placeringsvalet */
    valdatum?: Date | null;
    inkanal?: Inkanal | null;

    constructor(data?: IPlaceringsItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forsakringsbolagNamn = _data["forsakringsbolagNamn"] !== undefined ? _data["forsakringsbolagNamn"] : null as any;
            this.forsakringsbolagKod = _data["forsakringsbolagKod"] !== undefined ? _data["forsakringsbolagKod"] : null as any;
            this.forvaltningsform = _data["forvaltningsform"] !== undefined ? _data["forvaltningsform"] : null as any;
            this.premieandel = _data["premieandel"] !== undefined ? _data["premieandel"] : null as any;
            this.giltighetstid = _data["giltighetstid"] ? OpenEndedDateRange2.fromJS(_data["giltighetstid"]) : null as any;
            this.valdatum = _data["valdatum"] ? new Date(_data["valdatum"].toString()) : null as any;
            this.inkanal = _data["inkanal"] !== undefined ? _data["inkanal"] : null as any;
        }
    }

    static fromJS(data: any): PlaceringsItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceringsItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forsakringsbolagNamn"] = this.forsakringsbolagNamn !== undefined ? this.forsakringsbolagNamn : null as any;
        data["forsakringsbolagKod"] = this.forsakringsbolagKod !== undefined ? this.forsakringsbolagKod : null as any;
        data["forvaltningsform"] = this.forvaltningsform !== undefined ? this.forvaltningsform : null as any;
        data["premieandel"] = this.premieandel !== undefined ? this.premieandel : null as any;
        data["giltighetstid"] = this.giltighetstid ? this.giltighetstid.toJSON() : null as any;
        data["valdatum"] = this.valdatum ? this.valdatum.toISOString() : null as any;
        data["inkanal"] = this.inkanal !== undefined ? this.inkanal : null as any;
        return data;
    }
}

/** En placering är ett val som den anställde har gjort för hur framtida inbetalningar ska placeras/fördelas. */
export interface IPlaceringsItemResponse {
    /** Försäkringsbolagets namn, motsvarar försäkringsbolagets namn vid valet av placeringen. För t.ex. historiska val kan

försäkringsbolaget ha bytt

namn, då är detta fortfarande det namn som gällde vid valet.

Har värdet ”Ännu ej vald” om inget val är gjort. */
    forsakringsbolagNamn: string;
    /** Försäkringsbolagskod som är Collectums interna kod, bör inte användas för någon funktion. */
    forsakringsbolagKod?: string | null;
    /** Valets förvaltningsform. Observera att detta inte motsvara MISXMLs definition av förvaltningsform då den innehåller

URSPRUNGLIG ITPK som inte

beskriver en förvaltningsform utan egentligen en produkt. */
    forvaltningsform: Forvaltningsform;
    /** Valets andel av 100%. Dvs summan av samtliga gällande val (GiltigTomDatum = null) ska vara 100. */
    premieandel?: number;
    /** Valets giltighetstid */
    giltighetstid?: OpenEndedDateRange2 | null;
    /** Datumet då den anställde gjorde sitt val (kan vara tidigare än startdatumet).

Null om inget val gjorts och ”ickeval alternativet” är placeringsvalet */
    valdatum?: Date | null;
    inkanal?: Inkanal | null;
}

export class PlaceringsvalItemResponse implements IPlaceringsvalItemResponse {
    /** Valets ITP Plan */
    avdelningskod!: Avdelningskod3;
    /** ”ITP1”, ”ITPK”, ”Pressens Pension”, ”Livsarbetstidspremier” */
    valomradeskod?: string | null;
    /** Om den anställde är i en valperiod, dvs i en period där om valet inte görs går valet till ”ickeval alternativet”, t.ex. vid nyanställning.

Om värdet är null alternativt false om den anställde INTE är i valperiod */
    pagaendeValperiod?: boolean;
    /** Detta placeringsval är möjligt att ändra, dvs det pågår inbetalningar till detta placeringsval */
    mojligtVal?: boolean;
    /** Sista datum för valperioden om den är pågående.

Null om det inte är en pågående valperiod */
    valperiodTomDatum?: Date | null;
    /** Sista datum för när ändring kan göras utan Hälsoprövning.

Null om det inte är en pågående valperiod */
    hdPeriodTomDatum?: Date | null;
    /** Lista för val av Placeringar */
    placeringar!: PlaceringsItemResponse[];

    constructor(data?: IPlaceringsvalItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.placeringar = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avdelningskod = _data["avdelningskod"] !== undefined ? _data["avdelningskod"] : null as any;
            this.valomradeskod = _data["valomradeskod"] !== undefined ? _data["valomradeskod"] : null as any;
            this.pagaendeValperiod = _data["pagaendeValperiod"] !== undefined ? _data["pagaendeValperiod"] : null as any;
            this.mojligtVal = _data["mojligtVal"] !== undefined ? _data["mojligtVal"] : null as any;
            this.valperiodTomDatum = _data["valperiodTomDatum"] ? new Date(_data["valperiodTomDatum"].toString()) : null as any;
            this.hdPeriodTomDatum = _data["hdPeriodTomDatum"] ? new Date(_data["hdPeriodTomDatum"].toString()) : null as any;
            if (Array.isArray(_data["placeringar"])) {
                this.placeringar = [] as any;
                for (let item of _data["placeringar"])
                    this.placeringar!.push(PlaceringsItemResponse.fromJS(item));
            }
            else {
                this.placeringar = null as any;
            }
        }
    }

    static fromJS(data: any): PlaceringsvalItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceringsvalItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avdelningskod"] = this.avdelningskod !== undefined ? this.avdelningskod : null as any;
        data["valomradeskod"] = this.valomradeskod !== undefined ? this.valomradeskod : null as any;
        data["pagaendeValperiod"] = this.pagaendeValperiod !== undefined ? this.pagaendeValperiod : null as any;
        data["mojligtVal"] = this.mojligtVal !== undefined ? this.mojligtVal : null as any;
        data["valperiodTomDatum"] = this.valperiodTomDatum ? this.valperiodTomDatum.toISOString() : null as any;
        data["hdPeriodTomDatum"] = this.hdPeriodTomDatum ? this.hdPeriodTomDatum.toISOString() : null as any;
        if (Array.isArray(this.placeringar)) {
            data["placeringar"] = [];
            for (let item of this.placeringar)
                data["placeringar"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlaceringsvalItemResponse {
    /** Valets ITP Plan */
    avdelningskod: Avdelningskod3;
    /** ”ITP1”, ”ITPK”, ”Pressens Pension”, ”Livsarbetstidspremier” */
    valomradeskod?: string | null;
    /** Om den anställde är i en valperiod, dvs i en period där om valet inte görs går valet till ”ickeval alternativet”, t.ex. vid nyanställning.

Om värdet är null alternativt false om den anställde INTE är i valperiod */
    pagaendeValperiod?: boolean;
    /** Detta placeringsval är möjligt att ändra, dvs det pågår inbetalningar till detta placeringsval */
    mojligtVal?: boolean;
    /** Sista datum för valperioden om den är pågående.

Null om det inte är en pågående valperiod */
    valperiodTomDatum?: Date | null;
    /** Sista datum för när ändring kan göras utan Hälsoprövning.

Null om det inte är en pågående valperiod */
    hdPeriodTomDatum?: Date | null;
    /** Lista för val av Placeringar */
    placeringar: PlaceringsItemResponse[];
}

export class PlaceringsvalResponse implements IPlaceringsvalResponse {
    /** Avtalats individID */
    individId!: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status!: InfoStatusItemResponse3[];
    /** Lista över Placeringsval */
    placeringsval!: PlaceringsvalItemResponse[];

    constructor(data?: IPlaceringsvalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.status = [];
            this.placeringsval = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(InfoStatusItemResponse3.fromJS(item));
            }
            else {
                this.status = null as any;
            }
            if (Array.isArray(_data["placeringsval"])) {
                this.placeringsval = [] as any;
                for (let item of _data["placeringsval"])
                    this.placeringsval!.push(PlaceringsvalItemResponse.fromJS(item));
            }
            else {
                this.placeringsval = null as any;
            }
        }
    }

    static fromJS(data: any): PlaceringsvalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceringsvalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.placeringsval)) {
            data["placeringsval"] = [];
            for (let item of this.placeringsval)
                data["placeringsval"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlaceringsvalResponse {
    /** Avtalats individID */
    individId: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status: InfoStatusItemResponse3[];
    /** Lista över Placeringsval */
    placeringsval: PlaceringsvalItemResponse[];
}

export class PremiebestamdAlderspensionItemResponse implements IPremiebestamdAlderspensionItemResponse {
    /** Status på den premiebestämda ålderspensionen. */
    status!: TjanstepensionStatusResponse;
    /** Summan av varje ingående kapitals prognosbelopp. */
    summaPrognosManadsbelopp?: number | null;
    /** Den premiebestämda ålderspensionens kapital fördelat per försäkringsbolag. */
    fordelningIntjanatKapitalPerPensionsbolag!: FordelningPerPensionsbolagItemResponse[];
    /** Den premiebestämda ålderspensionens kapital fördelat per förvaltningsform. */
    fordelningIntjanatKapitalPerForvaltningsform!: FordelningPerForvaltningsformItemResponse[];
    /** Listan av kapital håller samman "försäkringar" inom premiebestämd ålderspension. */
    mappar?: MappItemResponse[] | null;

    constructor(data?: IPremiebestamdAlderspensionItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.fordelningIntjanatKapitalPerPensionsbolag = [];
            this.fordelningIntjanatKapitalPerForvaltningsform = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.summaPrognosManadsbelopp = _data["summaPrognosManadsbelopp"] !== undefined ? _data["summaPrognosManadsbelopp"] : null as any;
            if (Array.isArray(_data["fordelningIntjanatKapitalPerPensionsbolag"])) {
                this.fordelningIntjanatKapitalPerPensionsbolag = [] as any;
                for (let item of _data["fordelningIntjanatKapitalPerPensionsbolag"])
                    this.fordelningIntjanatKapitalPerPensionsbolag!.push(FordelningPerPensionsbolagItemResponse.fromJS(item));
            }
            else {
                this.fordelningIntjanatKapitalPerPensionsbolag = null as any;
            }
            if (Array.isArray(_data["fordelningIntjanatKapitalPerForvaltningsform"])) {
                this.fordelningIntjanatKapitalPerForvaltningsform = [] as any;
                for (let item of _data["fordelningIntjanatKapitalPerForvaltningsform"])
                    this.fordelningIntjanatKapitalPerForvaltningsform!.push(FordelningPerForvaltningsformItemResponse.fromJS(item));
            }
            else {
                this.fordelningIntjanatKapitalPerForvaltningsform = null as any;
            }
            if (Array.isArray(_data["mappar"])) {
                this.mappar = [] as any;
                for (let item of _data["mappar"])
                    this.mappar!.push(MappItemResponse.fromJS(item));
            }
            else {
                this.mappar = null as any;
            }
        }
    }

    static fromJS(data: any): PremiebestamdAlderspensionItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PremiebestamdAlderspensionItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["summaPrognosManadsbelopp"] = this.summaPrognosManadsbelopp !== undefined ? this.summaPrognosManadsbelopp : null as any;
        if (Array.isArray(this.fordelningIntjanatKapitalPerPensionsbolag)) {
            data["fordelningIntjanatKapitalPerPensionsbolag"] = [];
            for (let item of this.fordelningIntjanatKapitalPerPensionsbolag)
                data["fordelningIntjanatKapitalPerPensionsbolag"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.fordelningIntjanatKapitalPerForvaltningsform)) {
            data["fordelningIntjanatKapitalPerForvaltningsform"] = [];
            for (let item of this.fordelningIntjanatKapitalPerForvaltningsform)
                data["fordelningIntjanatKapitalPerForvaltningsform"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.mappar)) {
            data["mappar"] = [];
            for (let item of this.mappar)
                data["mappar"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPremiebestamdAlderspensionItemResponse {
    /** Status på den premiebestämda ålderspensionen. */
    status: TjanstepensionStatusResponse;
    /** Summan av varje ingående kapitals prognosbelopp. */
    summaPrognosManadsbelopp?: number | null;
    /** Den premiebestämda ålderspensionens kapital fördelat per försäkringsbolag. */
    fordelningIntjanatKapitalPerPensionsbolag: FordelningPerPensionsbolagItemResponse[];
    /** Den premiebestämda ålderspensionens kapital fördelat per förvaltningsform. */
    fordelningIntjanatKapitalPerForvaltningsform: FordelningPerForvaltningsformItemResponse[];
    /** Listan av kapital håller samman "försäkringar" inom premiebestämd ålderspension. */
    mappar?: MappItemResponse[] | null;
}

export class SamordningsuppgifterItemResponse2 implements ISamordningsuppgifterItemResponse2 {
    /** Namn på förvaltare av samordnad tjänstepension. */
    forvaltare?: string | null;
    /** Belopp/månad i kr. */
    samordnatManadsbelopp?: number | null;

    constructor(data?: ISamordningsuppgifterItemResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forvaltare = _data["forvaltare"] !== undefined ? _data["forvaltare"] : null as any;
            this.samordnatManadsbelopp = _data["samordnatManadsbelopp"] !== undefined ? _data["samordnatManadsbelopp"] : null as any;
        }
    }

    static fromJS(data: any): SamordningsuppgifterItemResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new SamordningsuppgifterItemResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forvaltare"] = this.forvaltare !== undefined ? this.forvaltare : null as any;
        data["samordnatManadsbelopp"] = this.samordnatManadsbelopp !== undefined ? this.samordnatManadsbelopp : null as any;
        return data;
    }
}

export interface ISamordningsuppgifterItemResponse2 {
    /** Namn på förvaltare av samordnad tjänstepension. */
    forvaltare?: string | null;
    /** Belopp/månad i kr. */
    samordnatManadsbelopp?: number | null;
}

export enum TjanstepensionProdukttypResponse {
    Okand = "Okand",
    ITP1 = "ITP1",
    ITP2 = "ITP2",
    ITPK = "ITPK",
    ITPKPP = "ITPKPP",
    UITPK = "UITPK",
    LP = "LP",
}

export enum TjanstepensionStatusResponse {
    Okand = "Okand",
    Aktiv = "Aktiv",
    Fribrev = "Fribrev",
    Slutbetald = "Slutbetald",
    UnderUtbetalning = "UnderUtbetalning",
}

export class TjanstepensionerItemResponse implements ITjanstepensionerItemResponse {
    /** Premiebestämd ålderspension (ITP1, ITPK, LP) som informationsförsörjs från Collectum. */
    premiebestamdAlderspension?: PremiebestamdAlderspensionItemResponse | null;
    /** Förmånsbestämda ålderspensioner som informationsförsörjs från Alecta. */
    formansbestamdaAlderspensioner?: FormansbestamdAlderspensionItemResponse[] | null;

    constructor(data?: ITjanstepensionerItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.premiebestamdAlderspension = _data["premiebestamdAlderspension"] ? PremiebestamdAlderspensionItemResponse.fromJS(_data["premiebestamdAlderspension"]) : null as any;
            if (Array.isArray(_data["formansbestamdaAlderspensioner"])) {
                this.formansbestamdaAlderspensioner = [] as any;
                for (let item of _data["formansbestamdaAlderspensioner"])
                    this.formansbestamdaAlderspensioner!.push(FormansbestamdAlderspensionItemResponse.fromJS(item));
            }
            else {
                this.formansbestamdaAlderspensioner = null as any;
            }
        }
    }

    static fromJS(data: any): TjanstepensionerItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TjanstepensionerItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["premiebestamdAlderspension"] = this.premiebestamdAlderspension ? this.premiebestamdAlderspension.toJSON() : null as any;
        if (Array.isArray(this.formansbestamdaAlderspensioner)) {
            data["formansbestamdaAlderspensioner"] = [];
            for (let item of this.formansbestamdaAlderspensioner)
                data["formansbestamdaAlderspensioner"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITjanstepensionerItemResponse {
    /** Premiebestämd ålderspension (ITP1, ITPK, LP) som informationsförsörjs från Collectum. */
    premiebestamdAlderspension?: PremiebestamdAlderspensionItemResponse | null;
    /** Förmånsbestämda ålderspensioner som informationsförsörjs från Alecta. */
    formansbestamdaAlderspensioner?: FormansbestamdAlderspensionItemResponse[] | null;
}

export class TjanstepensionerResponse implements ITjanstepensionerResponse {
    /** Avtalats individID */
    individId!: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status!: InfoStatusItemResponse3[];
    /** Information om tjänstepensionerna. */
    tjanstepensionInformation!: TjanstepensionerItemResponse;

    constructor(data?: ITjanstepensionerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.status = [];
            this.tjanstepensionInformation = new TjanstepensionerItemResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.individId = _data["individId"] !== undefined ? _data["individId"] : null as any;
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(InfoStatusItemResponse3.fromJS(item));
            }
            else {
                this.status = null as any;
            }
            this.tjanstepensionInformation = _data["tjanstepensionInformation"] ? TjanstepensionerItemResponse.fromJS(_data["tjanstepensionInformation"]) : new TjanstepensionerItemResponse();
        }
    }

    static fromJS(data: any): TjanstepensionerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TjanstepensionerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["individId"] = this.individId !== undefined ? this.individId : null as any;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : null as any);
        }
        data["tjanstepensionInformation"] = this.tjanstepensionInformation ? this.tjanstepensionInformation.toJSON() : null as any;
        return data;
    }
}

export interface ITjanstepensionerResponse {
    /** Avtalats individID */
    individId: string;
    /** Lista över statusar på hämtning från externa datakällor. */
    status: InfoStatusItemResponse3[];
    /** Information om tjänstepensionerna. */
    tjanstepensionInformation: TjanstepensionerItemResponse;
}

export class TjanstetidResponse2 implements ITjanstetidResponse2 {
    /** Ingår endast för aktiv försäkring.

Tjänstetid över 7.5 IBB utelämnas om den är 0.

Anges i månader. */
    intjanadTjanstetidOver75IBB?: number | null;
    /** Tjänstetid över 7.5 IBB utelämnas om den är 0.

Anges i månader. */
    beraknadTjanstetidOver75IBB?: number | null;
    /** Ingår endast för aktiv försäkring.

Anges i månader. */
    intjanadTjanstetidUnder75IBB?: number | null;
    /** Anges i månader. */
    beraknadTjanstetidUnder75IBB?: number | null;

    constructor(data?: ITjanstetidResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intjanadTjanstetidOver75IBB = _data["intjanadTjanstetidOver75IBB"] !== undefined ? _data["intjanadTjanstetidOver75IBB"] : null as any;
            this.beraknadTjanstetidOver75IBB = _data["beraknadTjanstetidOver75IBB"] !== undefined ? _data["beraknadTjanstetidOver75IBB"] : null as any;
            this.intjanadTjanstetidUnder75IBB = _data["intjanadTjanstetidUnder75IBB"] !== undefined ? _data["intjanadTjanstetidUnder75IBB"] : null as any;
            this.beraknadTjanstetidUnder75IBB = _data["beraknadTjanstetidUnder75IBB"] !== undefined ? _data["beraknadTjanstetidUnder75IBB"] : null as any;
        }
    }

    static fromJS(data: any): TjanstetidResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new TjanstetidResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intjanadTjanstetidOver75IBB"] = this.intjanadTjanstetidOver75IBB !== undefined ? this.intjanadTjanstetidOver75IBB : null as any;
        data["beraknadTjanstetidOver75IBB"] = this.beraknadTjanstetidOver75IBB !== undefined ? this.beraknadTjanstetidOver75IBB : null as any;
        data["intjanadTjanstetidUnder75IBB"] = this.intjanadTjanstetidUnder75IBB !== undefined ? this.intjanadTjanstetidUnder75IBB : null as any;
        data["beraknadTjanstetidUnder75IBB"] = this.beraknadTjanstetidUnder75IBB !== undefined ? this.beraknadTjanstetidUnder75IBB : null as any;
        return data;
    }
}

export interface ITjanstetidResponse2 {
    /** Ingår endast för aktiv försäkring.

Tjänstetid över 7.5 IBB utelämnas om den är 0.

Anges i månader. */
    intjanadTjanstetidOver75IBB?: number | null;
    /** Tjänstetid över 7.5 IBB utelämnas om den är 0.

Anges i månader. */
    beraknadTjanstetidOver75IBB?: number | null;
    /** Ingår endast för aktiv försäkring.

Anges i månader. */
    intjanadTjanstetidUnder75IBB?: number | null;
    /** Anges i månader. */
    beraknadTjanstetidUnder75IBB?: number | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] !== undefined ? this.errors[key] : null as any;
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class KundserviceAppApiClientExceptions extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isKundserviceAppApiClientExceptions = true;

    static isKundserviceAppApiClientExceptions(obj: any): obj is KundserviceAppApiClientExceptions {
        return obj.isKundserviceAppApiClientExceptions === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new KundserviceAppApiClientExceptions(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

export interface IAuthorizationConfig {
  /**
   * Returns a valid value for the Authorization header.
   * Used to dynamically inject the current auth header.
   */
  getAuthorization: () => Promise<string>;
}